
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("75RpY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b066675d1aa79fa$export$2e2bcd8739ae039);
parcelRequire("iuB9z");
var $bja9j = parcelRequire("bja9j");

var $9ec1t = parcelRequire("9ec1t");

var $ddvKB = parcelRequire("ddvKB");

var $1PAc2 = parcelRequire("1PAc2");

var $7vBln = parcelRequire("7vBln");

var $8V48z = parcelRequire("8V48z");

var $7uAaF = parcelRequire("7uAaF");

var $3ANoO = parcelRequire("3ANoO");

var $16HUD = parcelRequire("16HUD");

var $gFv4l = parcelRequire("gFv4l");
class $7b066675d1aa79fa$export$2e2bcd8739ae039 extends $bja9j.Application {
    static instance;
    LoadingLayer;
    WIDTH = (0, $3ANoO.INITIAL_WIDTH);
    HEIGHT = (0, $3ANoO.INITIAL_HEIGHT);
    LAYER_HEIGHT = (0, $3ANoO.INITIAL_HEIGHT);
    Animation = new (0, $1PAc2.default)();
    CustomCursor;
    SCALE = 1;
    constructor(canvas, infoSliderAssetsSlug, cb, extraAssets = []){
        super();
        if (!$7b066675d1aa79fa$export$2e2bcd8739ae039.instance) $7b066675d1aa79fa$export$2e2bcd8739ae039.instance = this;
        this.calcGameSize();
        canvas.style.transform = `scale(${this.SCALE})`;
        this.init({
            canvas: canvas,
            antialias: true,
            backgroundColor: 0xFFFFFF,
            width: this.WIDTH,
            height: this.HEIGHT
        }).then(()=>{
            (0, $7vBln.default).loadLogo().then(async ()=>{
                const startGame = ()=>{
                    new (0, $9ec1t.default)();
                    new (0, $ddvKB.default)();
                    cb();
                    setTimeout(()=>this.CustomCursor.setLayer(false), 300);
                    (0, $gFv4l.default)();
                };
                this.LoadingLayer = new (0, $7uAaF.default)(()=>startGame());
                this.CustomCursor = new (0, $16HUD.default)();
                const infoSliderAssets = await (0, $7vBln.default).getAssetsUrls(infoSliderAssetsSlug);
                const assets = (0, $3ANoO.ROOT_ASSETS_LIST).concat(extraAssets).concat(infoSliderAssets);
                (0, $7vBln.default).load(assets, (p)=>this.LoadingLayer.drawLoadingButton(p)).then(()=>{
                    console.log("loaded assets");
                    this.ticker.add((delta)=>this.update(delta));
                });
            });
        });
    }
    static getInstance = ()=>$7b066675d1aa79fa$export$2e2bcd8739ae039.instance;
    getDim = ()=>({
            WIDTH: this.WIDTH,
            HEIGHT: this.HEIGHT,
            LAYER_HEIGHT: this.LAYER_HEIGHT
        });
    update = (delta)=>this.Animation.update(delta.lastTime);
    calcGameSize() {
        const dims = (0, $8V48z.default)((0, $3ANoO.INITIAL_WIDTH), (0, $3ANoO.INITIAL_HEIGHT));
        Object.assign(this, dims);
    }
}

});
parcelRegister("iuB9z", function(module, exports) {

$parcel$export(module.exports, "Application", () => (parcelRequire("bja9j")).Application);
$parcel$export(module.exports, "Assets", () => (parcelRequire("9Gm4h")).Assets);
$parcel$export(module.exports, "ColorMatrixFilter", () => (parcelRequire("cm9HO")).ColorMatrixFilter);
$parcel$export(module.exports, "Rectangle", () => (parcelRequire("fM4Mk")).Rectangle);
$parcel$export(module.exports, "Texture", () => (parcelRequire("bLlTJ")).Texture);
$parcel$export(module.exports, "Container", () => (parcelRequire("eicwU")).Container);
$parcel$export(module.exports, "Graphics", () => (parcelRequire("3cebA")).Graphics);
$parcel$export(module.exports, "NineSliceSprite", () => (parcelRequire("djRgo")).NineSliceSprite);
$parcel$export(module.exports, "Sprite", () => (parcelRequire("4rhnu")).Sprite);
$parcel$export(module.exports, "Text", () => (parcelRequire("gc0ip")).Text);
$parcel$export(module.exports, "EventEmitter", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3vRz3")))));

var $iA8uc = parcelRequire("iA8uc");

var $gNJFA = parcelRequire("gNJFA");

var $i9BKe = parcelRequire("i9BKe");
parcelRequire("7dx1H");
parcelRequire("4RJM2");













































var $bja9j = parcelRequire("bja9j");



var $9Gm4h = parcelRequire("9Gm4h");






































































































var $cm9HO = parcelRequire("cm9HO");



















var $fM4Mk = parcelRequire("fM4Mk");
































































































































































































var $bLlTJ = parcelRequire("bLlTJ");









var $8QN7n = parcelRequire("8QN7n");

























var $eicwU = parcelRequire("eicwU");




































var $3cebA = parcelRequire("3cebA");




















































var $djRgo = parcelRequire("djRgo");











var $4rhnu = parcelRequire("4rhnu");












































var $gc0ip = parcelRequire("gc0ip");




















var $3vRz3 = parcelRequire("3vRz3");



















"use strict";
(0, $i9BKe.extensions).add((0, $iA8uc.browserExt), (0, $gNJFA.webworkerExt));

});
parcelRegister("iA8uc", function(module, exports) {

$parcel$export(module.exports, "browserExt", () => $c220e1d99a2da004$export$a6aad6334ef58a1c);

var $i9BKe = parcelRequire("i9BKe");
"use strict";

const $c220e1d99a2da004$export$a6aad6334ef58a1c = {
    extension: {
        type: (0, $i9BKe.ExtensionType).Environment,
        name: "browser",
        priority: -1
    },
    test: ()=>true,
    load: async ()=>{
        await (parcelRequire("iuQbR"));
    }
};

});
parcelRegister("iuQbR", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("hXVys"),
    $Gr8vk("3n7mr"),
    $Gr8vk("7kLcW"),
    $Gr8vk("dCEEN")
]).then(()=>parcelRequire('gFyHJ'));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});



parcelRegister("gNJFA", function(module, exports) {

$parcel$export(module.exports, "webworkerExt", () => $a52ecd5a016ebe0a$export$ee43dd1acddf6cf8);

var $i9BKe = parcelRequire("i9BKe");
"use strict";

const $a52ecd5a016ebe0a$export$ee43dd1acddf6cf8 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).Environment,
        name: "webworker",
        priority: 0
    },
    test: ()=>typeof self !== "undefined" && self.WorkerGlobalScope !== void 0,
    load: async ()=>{
        await (parcelRequire("5ztz3"));
    }
};

});
parcelRegister("5ztz3", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("hXVys"),
    $Gr8vk("3n7mr"),
    $Gr8vk("7kLcW"),
    $Gr8vk("5zD7l")
]).then(()=>parcelRequire('danRq'));

});


parcelRegister("bja9j", function(module, exports) {

$parcel$export(module.exports, "Application", () => $2202931bfc9ee5c9$export$16975c34e60e1e61);

var $i9BKe = parcelRequire("i9BKe");

var $lmtTM = parcelRequire("lmtTM");

var $eicwU = parcelRequire("eicwU");

var $gVtOu = parcelRequire("gVtOu");

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $2202931bfc9ee5c9$var$_Application = class _Application {
    constructor(...args){
        /**
     * The root display container for your application.
     * All visual elements should be added to this container or its children.
     * @example
     * ```js
     * // Create a sprite and add it to the stage
     * const sprite = Sprite.from('image.png');
     * app.stage.addChild(sprite);
     *
     * // Create a container for grouping objects
     * const container = new Container();
     * app.stage.addChild(container);
     * ```
     */ this.stage = new (0, $eicwU.Container)();
        if (args[0] !== void 0) (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Application constructor options are deprecated, please use Application.init() instead.");
    }
    /**
   * Initializes the PixiJS application with the specified options.
   *
   * This method must be called after creating a new Application instance.
   * @param options - Configuration options for the application and renderer
   * @returns A promise that resolves when initialization is complete
   * @example
   * ```js
   * const app = new Application();
   *
   * // Initialize with custom options
   * await app.init({
   *     width: 800,
   *     height: 600,
   *     backgroundColor: 0x1099bb,
   *     preference: 'webgl', // or 'webgpu'
   * });
   * ```
   */ async init(options) {
        options = {
            ...options
        };
        this.renderer = await (0, $lmtTM.autoDetectRenderer)(options);
        _Application._plugins.forEach((plugin)=>{
            plugin.init.call(this, options);
        });
    }
    /**
   * Renders the current stage to the screen.
   *
   * When using the default setup with {@link TickerPlugin} (enabled by default), you typically don't need to call
   * this method directly as rendering is handled automatically.
   *
   * Only use this method if you've disabled the {@link TickerPlugin} or need custom
   * render timing control.
   * @example
   * ```js
   * // Example 1: Default setup (TickerPlugin handles rendering)
   * const app = new Application();
   * await app.init();
   * // No need to call render() - TickerPlugin handles it
   *
   * // Example 2: Custom rendering loop (if TickerPlugin is disabled)
   * const app = new Application();
   * await app.init({ autoStart: false }); // Disable automatic rendering
   *
   * function animate() {
   *     app.render();
   *     requestAnimationFrame(animate);
   * }
   * animate();
   * ```
   */ render() {
        this.renderer.render({
            container: this.stage
        });
    }
    /**
   * Reference to the renderer's canvas element. This is the HTML element
   * that displays your application's graphics.
   * @readonly
   * @type {HTMLCanvasElement}
   * @example
   * ```js
   * // Create a new application
   * const app = new Application();
   * // Initialize the application
   * await app.init({...});
   * // Add canvas to the page
   * document.body.appendChild(app.canvas);
   *
   * // Access the canvas directly
   * console.log(app.canvas); // HTMLCanvasElement
   * ```
   */ get canvas() {
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's canvas element.
   * @type {HTMLCanvasElement}
   * @deprecated since 8.0.0
   * @see {@link Application#canvas}
   */ get view() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Application.view is deprecated, please use Application.canvas instead.");
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's screen rectangle. This represents the visible area of your application.
   *
   * It's commonly used for:
   * - Setting filter areas for full-screen effects
   * - Defining hit areas for screen-wide interaction
   * - Determining the visible bounds of your application
   * @readonly
   * @example
   * ```js
   * // Use as filter area for a full-screen effect
   * const blurFilter = new BlurFilter();
   * sprite.filterArea = app.screen;
   *
   * // Use as hit area for screen-wide interaction
   * const screenSprite = new Sprite();
   * screenSprite.hitArea = app.screen;
   *
   * // Get screen dimensions
   * console.log(app.screen.width, app.screen.height);
   * ```
   * @see {@link Rectangle} For all available properties and methods
   */ get screen() {
        return this.renderer.screen;
    }
    /**
   * Destroys the application and all of its resources.
   *
   * This method should be called when you want to completely
   * clean up the application and free all associated memory.
   * @param rendererDestroyOptions - Options for destroying the renderer:
   *  - `false` or `undefined`: Preserves the canvas element (default)
   *  - `true`: Removes the canvas element
   *  - `{ removeView: boolean }`: Object with removeView property to control canvas removal
   * @param options - Options for destroying the application:
   *  - `false` or `undefined`: Basic cleanup (default)
   *  - `true`: Complete cleanup including children
   *  - Detailed options object:
   *    - `children`: Remove children
   *    - `texture`: Destroy textures
   *    - `textureSource`: Destroy texture sources
   *    - `context`: Destroy WebGL context
   * @example
   * ```js
   * // Basic cleanup
   * app.destroy();
   *
   * // Remove canvas and do complete cleanup
   * app.destroy(true, true);
   *
   * // Remove canvas with explicit options
   * app.destroy({ removeView: true }, true);
   *
   * // Detailed cleanup with specific options
   * app.destroy(
   *     { removeView: true },
   *     {
   *         children: true,
   *         texture: true,
   *         textureSource: true,
   *         context: true
   *     }
   * );
   * ```
   * > [!WARNING] After calling destroy, the application instance should no longer be used.
   * > All properties will be null and further operations will throw errors.
   */ destroy(rendererDestroyOptions = false, options = false) {
        const plugins = _Application._plugins.slice(0);
        plugins.reverse();
        plugins.forEach((plugin)=>{
            plugin.destroy.call(this);
        });
        this.stage.destroy(options);
        this.stage = null;
        this.renderer.destroy(rendererDestroyOptions);
        this.renderer = null;
    }
};
/**
 * Collection of installed plugins.
 * @internal
 */ $2202931bfc9ee5c9$var$_Application._plugins = [];
let $2202931bfc9ee5c9$export$16975c34e60e1e61 = $2202931bfc9ee5c9$var$_Application;
(0, $i9BKe.extensions).handleByList((0, $i9BKe.ExtensionType).Application, $2202931bfc9ee5c9$export$16975c34e60e1e61._plugins);
(0, $i9BKe.extensions).add((0, $gVtOu.ApplicationInitHook));

});
parcelRegister("lmtTM", function(module, exports) {

$parcel$export(module.exports, "autoDetectRenderer", () => $bf7ca24d384e2f55$export$3583b92ab8150eb6);

var $jknZI = parcelRequire("jknZI");

var $3MeAf = parcelRequire("3MeAf");

var $3UUq4 = parcelRequire("3UUq4");
"use strict";
const $bf7ca24d384e2f55$var$renderPriority = [
    "webgl",
    "webgpu",
    "canvas"
];


async function $bf7ca24d384e2f55$export$3583b92ab8150eb6(options) {
    let preferredOrder = [];
    if (options.preference) {
        preferredOrder.push(options.preference);
        $bf7ca24d384e2f55$var$renderPriority.forEach((item)=>{
            if (item !== options.preference) preferredOrder.push(item);
        });
    } else preferredOrder = $bf7ca24d384e2f55$var$renderPriority.slice();
    let RendererClass;
    let finalOptions = {};
    for(let i = 0; i < preferredOrder.length; i++){
        const rendererType = preferredOrder[i];
        if (rendererType === "webgpu" && await (0, $3MeAf.isWebGPUSupported)()) {
            const { WebGPURenderer: WebGPURenderer } = await (parcelRequire("ji7n1"));
            RendererClass = WebGPURenderer;
            finalOptions = {
                ...options,
                ...options.webgpu
            };
            break;
        } else if (rendererType === "webgl" && (0, $jknZI.isWebGLSupported)(options.failIfMajorPerformanceCaveat ?? (0, $3UUq4.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat)) {
            const { WebGLRenderer: WebGLRenderer } = await (parcelRequire("f1902"));
            RendererClass = WebGLRenderer;
            finalOptions = {
                ...options,
                ...options.webgl
            };
            break;
        } else if (rendererType === "canvas") {
            finalOptions = {
                ...options
            };
            throw new Error("CanvasRenderer is not yet implemented");
        }
    }
    delete finalOptions.webgpu;
    delete finalOptions.webgl;
    if (!RendererClass) throw new Error("No available renderer for the current environment");
    const renderer = new RendererClass();
    await renderer.init(finalOptions);
    return renderer;
}

});
parcelRegister("jknZI", function(module, exports) {

$parcel$export(module.exports, "isWebGLSupported", () => $21de405eafa0c0bb$export$83dc396b76015322);

var $iCGeI = parcelRequire("iCGeI");

var $3UUq4 = parcelRequire("3UUq4");
"use strict";
let $21de405eafa0c0bb$var$_isWebGLSupported;
function $21de405eafa0c0bb$export$83dc396b76015322(failIfMajorPerformanceCaveat) {
    if ($21de405eafa0c0bb$var$_isWebGLSupported !== void 0) return $21de405eafa0c0bb$var$_isWebGLSupported;
    $21de405eafa0c0bb$var$_isWebGLSupported = (()=>{
        const contextOptions = {
            stencil: true,
            failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat ?? (0, $3UUq4.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat
        };
        try {
            if (!(0, $iCGeI.DOMAdapter).get().getWebGLRenderingContext()) return false;
            const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
            let gl = canvas.getContext("webgl", contextOptions);
            const success = !!gl?.getContextAttributes()?.stencil;
            if (gl) {
                const loseContext = gl.getExtension("WEBGL_lose_context");
                if (loseContext) loseContext.loseContext();
            }
            gl = null;
            return success;
        } catch (_e) {
            return false;
        }
    })();
    return $21de405eafa0c0bb$var$_isWebGLSupported;
}

});

parcelRegister("3MeAf", function(module, exports) {

$parcel$export(module.exports, "isWebGPUSupported", () => $7cb4832c2de4c977$export$216169f30082c873);

var $iCGeI = parcelRequire("iCGeI");
"use strict";
let $7cb4832c2de4c977$var$_isWebGPUSupported;
async function $7cb4832c2de4c977$export$216169f30082c873(options = {}) {
    if ($7cb4832c2de4c977$var$_isWebGPUSupported !== void 0) return $7cb4832c2de4c977$var$_isWebGPUSupported;
    $7cb4832c2de4c977$var$_isWebGPUSupported = await (async ()=>{
        const gpu = (0, $iCGeI.DOMAdapter).get().getNavigator().gpu;
        if (!gpu) return false;
        try {
            const adapter = await gpu.requestAdapter(options);
            await adapter.requestDevice();
            return true;
        } catch (_e) {
            return false;
        }
    })();
    return $7cb4832c2de4c977$var$_isWebGPUSupported;
}

});

parcelRegister("ji7n1", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("4Zt2U"),
    $Gr8vk("aFj9c"),
    $Gr8vk("7kLcW"),
    $Gr8vk("aNM0B")
]).then(()=>parcelRequire('aIpib'));

});

parcelRegister("f1902", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("4Zt2U"),
    $Gr8vk("aFj9c"),
    $Gr8vk("7kLcW"),
    $Gr8vk("7EYKF")
]).then(()=>parcelRequire('kpxDv'));

});



parcelRegister("9Gm4h", function(module, exports) {

$parcel$export(module.exports, "Assets", () => $f4e4ce59fcdafcd2$export$c8eca95e306f7116);

var $i9BKe = parcelRequire("i9BKe");

var $5ilA5 = parcelRequire("5ilA5");

var $hUCK4 = parcelRequire("hUCK4");

var $8z5x8 = parcelRequire("8z5x8");

var $2IhKp = parcelRequire("2IhKp");

var $bAT0b = parcelRequire("bAT0b");

var $jFxOf = parcelRequire("jFxOf");

var $cIKeV = parcelRequire("cIKeV");

var $h6G9W = parcelRequire("h6G9W");

var $22lcm = parcelRequire("22lcm");

var $f5yRY = parcelRequire("f5yRY");

var $fYq25 = parcelRequire("fYq25");

var $5sc0S = parcelRequire("5sc0S");

var $30kAw = parcelRequire("30kAw");

var $eOARC = parcelRequire("eOARC");

var $13zV0 = parcelRequire("13zV0");

var $geSSO = parcelRequire("geSSO");

var $ckjdh = parcelRequire("ckjdh");

var $qPdOe = parcelRequire("qPdOe");

var $iiAQE = parcelRequire("iiAQE");

var $7ESOd = parcelRequire("7ESOd");

var $8kCsw = parcelRequire("8kCsw");

var $3CHiv = parcelRequire("3CHiv");

var $4DmkB = parcelRequire("4DmkB");
"use strict";
class $f4e4ce59fcdafcd2$export$137d4dd907afac85 {
    constructor(){
        this._detections = [];
        this._initialized = false;
        this.resolver = new (0, $8kCsw.Resolver)();
        this.loader = new (0, $5sc0S.Loader)();
        this.cache = (0, $2IhKp.Cache);
        this._backgroundLoader = new (0, $8z5x8.BackgroundLoader)(this.loader);
        this._backgroundLoader.active = true;
        this.reset();
    }
    /**
   * Initializes the Assets class with configuration options. While not required,
   * calling this before loading assets is recommended to set up default behaviors.
   * @param options - Configuration options for the Assets system
   * @example
   * ```ts
   * // Basic initialization (optional as Assets.load will call this automatically)
   * await Assets.init();
   *
   * // With CDN configuration
   * await Assets.init({
   *     basePath: 'https://my-cdn.com/assets/',
   *     defaultSearchParams: { version: '1.0.0' }
   * });
   *
   * // With manifest and preferences
   * await Assets.init({
   *     manifest: {
   *         bundles: [{
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'hero',
   *                     src: 'hero.{png,webp}',
   *                     data: { scaleMode: SCALE_MODES.NEAREST }
   *                 },
   *                 {
   *                     alias: 'map',
   *                     src: 'map.json'
   *                 }
   *             ]
   *         }]
   *     },
   *     // Optimize for device capabilities
   *     texturePreference: {
   *         resolution: window.devicePixelRatio,
   *         format: ['webp', 'png']
   *     },
   *     // Set global preferences
   *     preferences: {
   *         crossOrigin: 'anonymous',
   *     }
   * });
   *
   * // Load assets after initialization
   * const heroTexture = await Assets.load('hero');
   * ```
   * @remarks
   * - Can be called only once; subsequent calls will be ignored with a warning
   * - Format detection runs automatically unless `skipDetections` is true
   * - The manifest can be a URL to a JSON file or an inline object
   * @see {@link AssetInitOptions} For all available initialization options
   * @see {@link AssetsManifest} For manifest format details
   */ async init(options = {}) {
        if (this._initialized) {
            (0, $hUCK4.warn)("[Assets]AssetManager already initialized, did you load before calling this Assets.init()?");
            return;
        }
        this._initialized = true;
        if (options.defaultSearchParams) this.resolver.setDefaultSearchParams(options.defaultSearchParams);
        if (options.basePath) this.resolver.basePath = options.basePath;
        if (options.bundleIdentifier) this.resolver.setBundleIdentifier(options.bundleIdentifier);
        if (options.manifest) {
            let manifest = options.manifest;
            if (typeof manifest === "string") manifest = await this.load(manifest);
            this.resolver.addManifest(manifest);
        }
        const resolutionPref = options.texturePreference?.resolution ?? 1;
        const resolution = typeof resolutionPref === "number" ? [
            resolutionPref
        ] : resolutionPref;
        const formats = await this._detectFormats({
            preferredFormats: options.texturePreference?.format,
            skipDetections: options.skipDetections,
            detections: this._detections
        });
        this.resolver.prefer({
            params: {
                format: formats,
                resolution: resolution
            }
        });
        if (options.preferences) this.setPreferences(options.preferences);
    }
    /**
   * Registers assets with the Assets resolver. This method maps keys (aliases) to asset sources,
   * allowing you to load assets using friendly names instead of direct URLs.
   * @param assets - The unresolved assets to add to the resolver
   * @example
   * ```ts
   * // Basic usage - single asset
   * Assets.add({
   *     alias: 'myTexture',
   *     src: 'assets/texture.png'
   * });
   * const texture = await Assets.load('myTexture');
   *
   * // Multiple aliases for the same asset
   * Assets.add({
   *     alias: ['hero', 'player'],
   *     src: 'hero.png'
   * });
   * const hero1 = await Assets.load('hero');
   * const hero2 = await Assets.load('player'); // Same texture
   *
   * // Multiple format support
   * Assets.add({
   *     alias: 'character',
   *     src: 'character.{webp,png}' // Will choose best format
   * });
   * Assets.add({
   *     alias: 'character',
   *     src: ['character.webp', 'character.png'], // Explicitly specify formats
   * });
   *
   * // With texture options
   * Assets.add({
   *     alias: 'sprite',
   *     src: 'sprite.png',
   *     data: { scaleMode: 'nearest' }
   * });
   *
   * // Multiple assets at once
   * Assets.add([
   *     { alias: 'bg', src: 'background.png' },
   *     { alias: 'music', src: 'music.mp3' },
   *     { alias: 'spritesheet', src: 'sheet.json', data: { ignoreMultiPack: false } }
   * ]);
   * ```
   * @remarks
   * - Assets are resolved when loaded, not when added
   * - Multiple formats use the best available format for the browser
   * - Adding with same alias overwrites previous definition
   * - The `data` property is passed to the asset loader
   * @see {@link Resolver} For details on asset resolution
   * @see {@link LoaderParser} For asset-specific data options
   * @advanced
   */ add(assets) {
        this.resolver.add(assets);
    }
    async load(urls, onProgress) {
        if (!this._initialized) await this.init();
        const singleAsset = (0, $4DmkB.isSingleItem)(urls);
        const urlArray = (0, $3CHiv.convertToList)(urls).map((url)=>{
            if (typeof url !== "string") {
                const aliases = this.resolver.getAlias(url);
                if (aliases.some((alias)=>!this.resolver.hasKey(alias))) this.add(url);
                return Array.isArray(aliases) ? aliases[0] : aliases;
            }
            if (!this.resolver.hasKey(url)) this.add({
                alias: url,
                src: url
            });
            return url;
        });
        const resolveResults = this.resolver.resolve(urlArray);
        const out = await this._mapLoadToResolve(resolveResults, onProgress);
        return singleAsset ? out[urlArray[0]] : out;
    }
    /**
   * Registers a bundle of assets that can be loaded as a group. Bundles are useful for organizing
   * assets into logical groups, such as game levels or UI screens.
   * @param bundleId - Unique identifier for the bundle
   * @param assets - Assets to include in the bundle
   * @example
   * ```ts
   * // Add a bundle using array format
   * Assets.addBundle('animals', [
   *     { alias: 'bunny', src: 'bunny.png' },
   *     { alias: 'chicken', src: 'chicken.png' },
   *     { alias: 'thumper', src: 'thumper.png' },
   * ]);
   *
   * // Add a bundle using object format
   * Assets.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * // Add a bundle with advanced options
   * Assets.addBundle('ui', [
   *     {
   *         alias: 'button',
   *         src: 'button.{webp,png}',
   *         data: { scaleMode: 'nearest' }
   *     },
   *     {
   *         alias: ['logo', 'brand'],  // Multiple aliases
   *         src: 'logo.svg',
   *         data: { resolution: 2 }
   *     }
   * ]);
   *
   * // Load the bundle
   * await Assets.loadBundle('animals');
   *
   * // Use the loaded assets
   * const bunny = Sprite.from('bunny');
   * const chicken = Sprite.from('chicken');
   * ```
   * @remarks
   * - Bundle IDs must be unique
   * - Assets in bundles are not loaded until `loadBundle` is called
   * - Bundles can be background loaded using `backgroundLoadBundle`
   * - Assets in bundles can be loaded individually using their aliases
   * @see {@link Assets.loadBundle} For loading bundles
   * @see {@link Assets.backgroundLoadBundle} For background loading bundles
   * @see {@link Assets.unloadBundle} For unloading bundles
   * @see {@link AssetsManifest} For manifest format details
   */ addBundle(bundleId, assets) {
        this.resolver.addBundle(bundleId, assets);
    }
    /**
   * Loads a bundle or multiple bundles of assets. Bundles are collections of related assets
   * that can be loaded together.
   * @param bundleIds - Single bundle ID or array of bundle IDs to load
   * @param onProgress - Optional callback for load progress (0.0 to 1.0)
   * @returns Promise that resolves with the loaded bundle assets
   * @example
   * ```ts
   * // Define bundles in your manifest
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}', // use an array of individual assets
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * // Initialize with manifest
   * await Assets.init({ manifest });
   *
   * // Or add bundles programmatically
   * Assets.addBundle('load-screen', [...]);
   * Assets.loadBundle('load-screen');
   *
   * // Load a single bundle
   * await Assets.loadBundle('load-screen');
   * const bg = Sprite.from('background'); // Uses alias from bundle
   *
   * // Load multiple bundles
   * await Assets.loadBundle([
   *     'load-screen',
   *     'game-screen'
   * ]);
   *
   * // Load with progress tracking
   * await Assets.loadBundle('game-screen', (progress) => {
   *     console.log(`Loading: ${Math.round(progress * 100)}%`);
   * });
   * ```
   * @remarks
   * - Bundle assets are cached automatically
   * - Bundles can be pre-loaded using `backgroundLoadBundle`
   * - Assets in bundles can be accessed by their aliases
   * - Progress callback receives values from 0.0 to 1.0
   * @throws {Error} If the bundle ID doesn't exist in the manifest
   * @see {@link Assets.addBundle} For adding bundles programmatically
   * @see {@link Assets.backgroundLoadBundle} For background loading bundles
   * @see {@link Assets.unloadBundle} For unloading bundles
   * @see {@link AssetsManifest} For manifest format details
   */ async loadBundle(bundleIds, onProgress) {
        if (!this._initialized) await this.init();
        let singleAsset = false;
        if (typeof bundleIds === "string") {
            singleAsset = true;
            bundleIds = [
                bundleIds
            ];
        }
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        const out = {};
        const keys = Object.keys(resolveResults);
        let count = 0;
        let total = 0;
        const _onProgress = ()=>{
            onProgress?.(++count / total);
        };
        const promises = keys.map((bundleId)=>{
            const resolveResult = resolveResults[bundleId];
            const values = Object.values(resolveResult);
            const totalAssetsToLoad = [
                ...new Set(values.flat())
            ];
            total += totalAssetsToLoad.length;
            return this._mapLoadToResolve(resolveResult, _onProgress).then((resolveResult2)=>{
                out[bundleId] = resolveResult2;
            });
        });
        await Promise.all(promises);
        return singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Initiates background loading of assets. This allows assets to be loaded passively while other operations
   * continue, making them instantly available when needed later.
   *
   * Background loading is useful for:
   * - Preloading game levels while in a menu
   * - Loading non-critical assets during gameplay
   * - Reducing visible loading screens
   * @param urls - Single URL/alias or array of URLs/aliases to load in the background
   * @example
   * ```ts
   * // Basic background loading
   * Assets.backgroundLoad('images/level2-assets.png');
   *
   * // Background load multiple assets
   * Assets.backgroundLoad([
   *     'images/sprite1.png',
   *     'images/sprite2.png',
   *     'images/background.png'
   * ]);
   *
   * // Later, when you need the assets
   * const textures = await Assets.load([
   *     'images/sprite1.png',
   *     'images/sprite2.png'
   * ]); // Resolves immediately if background loading completed
   * ```
   * @remarks
   * - Background loading happens one asset at a time to avoid blocking the main thread
   * - Loading can be interrupted safely by calling `Assets.load()`
   * - Assets are cached as they complete loading
   * - No progress tracking is available for background loading
   */ async backgroundLoad(urls) {
        if (!this._initialized) await this.init();
        if (typeof urls === "string") urls = [
            urls
        ];
        const resolveResults = this.resolver.resolve(urls);
        this._backgroundLoader.add(Object.values(resolveResults));
    }
    /**
   * Initiates background loading of asset bundles. Similar to backgroundLoad but works with
   * predefined bundles of assets.
   *
   * Perfect for:
   * - Preloading level bundles during gameplay
   * - Loading UI assets during splash screens
   * - Preparing assets for upcoming game states
   * @param bundleIds - Single bundle ID or array of bundle IDs to load in the background
   * @example
   * ```ts
   * // Define bundles in your manifest
   * await Assets.init({
   *     manifest: {
   *         bundles: [
   *             {
   *               name: 'home',
   *               assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'images/home-bg.png',
   *                 },
   *                 {
   *                     alias: 'logo',
   *                     src: 'images/logo.png',
   *                 }
   *              ]
   *            },
   *            {
   *             name: 'level-1',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'images/level1/bg.png',
   *                 },
   *                 {
   *                     alias: 'sprites',
   *                     src: 'images/level1/sprites.json'
   *                 }
   *             ]
   *         }]
   *     }
   * });
   *
   * // Load the home screen assets right away
   * await Assets.loadBundle('home');
   * showHomeScreen();
   *
   * // Start background loading while showing home screen
   * Assets.backgroundLoadBundle('level-1');
   *
   * // When player starts level, load completes faster
   * await Assets.loadBundle('level-1');
   * hideHomeScreen();
   * startLevel();
   * ```
   * @remarks
   * - Bundle assets are loaded one at a time
   * - Loading can be interrupted safely by calling `Assets.loadBundle()`
   * - Assets are cached as they complete loading
   * - Requires bundles to be registered via manifest or `addBundle`
   * @see {@link Assets.addBundle} For adding bundles programmatically
   * @see {@link Assets.loadBundle} For immediate bundle loading
   * @see {@link AssetsManifest} For manifest format details
   */ async backgroundLoadBundle(bundleIds) {
        if (!this._initialized) await this.init();
        if (typeof bundleIds === "string") bundleIds = [
            bundleIds
        ];
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        Object.values(resolveResults).forEach((resolveResult)=>{
            this._backgroundLoader.add(Object.values(resolveResult));
        });
    }
    /**
   * Only intended for development purposes.
   * This will wipe the resolver and caches.
   * You will need to reinitialize the Asset
   * @internal
   */ reset() {
        this.resolver.reset();
        this.loader.reset();
        this.cache.reset();
        this._initialized = false;
    }
    get(keys) {
        if (typeof keys === "string") return (0, $2IhKp.Cache).get(keys);
        const assets = {};
        for(let i = 0; i < keys.length; i++)assets[i] = (0, $2IhKp.Cache).get(keys[i]);
        return assets;
    }
    /**
   * helper function to map resolved assets back to loaded assets
   * @param resolveResults - the resolve results from the resolver
   * @param onProgress - the progress callback
   */ async _mapLoadToResolve(resolveResults, onProgress) {
        const resolveArray = [
            ...new Set(Object.values(resolveResults))
        ];
        this._backgroundLoader.active = false;
        const loadedAssets = await this.loader.load(resolveArray, onProgress);
        this._backgroundLoader.active = true;
        const out = {};
        resolveArray.forEach((resolveResult)=>{
            const asset = loadedAssets[resolveResult.src];
            const keys = [
                resolveResult.src
            ];
            if (resolveResult.alias) keys.push(...resolveResult.alias);
            keys.forEach((key)=>{
                out[key] = asset;
            });
            (0, $2IhKp.Cache).set(keys, asset);
        });
        return out;
    }
    /**
   * Unloads assets and releases them from memory. This method ensures proper cleanup of
   * loaded assets when they're no longer needed.
   * @param urls - Single URL/alias or array of URLs/aliases to unload
   * @example
   * ```ts
   * // Unload a single asset
   * await Assets.unload('images/sprite.png');
   *
   * // Unload using an alias
   * await Assets.unload('hero'); // Unloads the asset registered with 'hero' alias
   *
   * // Unload multiple assets
   * await Assets.unload([
   *     'images/background.png',
   *     'images/character.png',
   *     'hero'
   * ]);
   *
   * // Unload and handle creation of new instances
   * await Assets.unload('hero');
   * const newHero = await Assets.load('hero'); // Will load fresh from source
   * ```
   * @remarks
   * > [!WARNING]
   * > Make sure assets aren't being used before unloading:
   * > - Remove sprites using the texture
   * > - Clear any references to the asset
   * > - Textures will be destroyed and can't be used after unloading
   * @throws {Error} If the asset is not found in cache
   */ async unload(urls) {
        if (!this._initialized) await this.init();
        const urlArray = (0, $3CHiv.convertToList)(urls).map((url)=>typeof url !== "string" ? url.src : url);
        const resolveResults = this.resolver.resolve(urlArray);
        await this._unloadFromResolved(resolveResults);
    }
    /**
   * Unloads all assets in a bundle. Use this to free memory when a bundle's assets
   * are no longer needed, such as when switching game levels.
   * @param bundleIds - Single bundle ID or array of bundle IDs to unload
   * @example
   * ```ts
   * // Define and load a bundle
   * Assets.addBundle('level-1', {
   *     background: 'level1/bg.png',
   *     sprites: 'level1/sprites.json',
   *     music: 'level1/music.mp3'
   * });
   *
   * // Load the bundle
   * const level1 = await Assets.loadBundle('level-1');
   *
   * // Use the assets
   * const background = Sprite.from(level1.background);
   *
   * // When done with the level, unload everything
   * await Assets.unloadBundle('level-1');
   * // background sprite is now invalid!
   *
   * // Unload multiple bundles
   * await Assets.unloadBundle([
   *     'level-1',
   *     'level-2',
   *     'ui-elements'
   * ]);
   * ```
   * @remarks
   * > [!WARNING]
   * > - All assets in the bundle will be destroyed
   * > - Bundle needs to be reloaded to use assets again
   * > - Make sure no sprites or other objects are using the assets
   * @throws {Error} If the bundle is not found
   * @see {@link Assets.addBundle} For adding bundles
   * @see {@link Assets.loadBundle} For loading bundles
   */ async unloadBundle(bundleIds) {
        if (!this._initialized) await this.init();
        bundleIds = (0, $3CHiv.convertToList)(bundleIds);
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        const promises = Object.keys(resolveResults).map((bundleId)=>this._unloadFromResolved(resolveResults[bundleId]));
        await Promise.all(promises);
    }
    async _unloadFromResolved(resolveResult) {
        const resolveArray = Object.values(resolveResult);
        resolveArray.forEach((resolveResult2)=>{
            (0, $2IhKp.Cache).remove(resolveResult2.src);
        });
        await this.loader.unload(resolveArray);
    }
    /**
   * Detects the supported formats for the browser, and returns an array of supported formats, respecting
   * the users preferred formats order.
   * @param options - the options to use when detecting formats
   * @param options.preferredFormats - the preferred formats to use
   * @param options.skipDetections - if we should skip the detections altogether
   * @param options.detections - the detections to use
   * @returns - the detected formats
   */ async _detectFormats(options) {
        let formats = [];
        if (options.preferredFormats) formats = Array.isArray(options.preferredFormats) ? options.preferredFormats : [
            options.preferredFormats
        ];
        for (const detection of options.detections){
            if (options.skipDetections || await detection.test()) formats = await detection.add(formats);
            else if (!options.skipDetections) formats = await detection.remove(formats);
        }
        formats = formats.filter((format, index)=>formats.indexOf(format) === index);
        return formats;
    }
    /**
   * All the detection parsers currently added to the Assets class.
   * @advanced
   */ get detections() {
        return this._detections;
    }
    /**
   * Sets global preferences for asset loading behavior. This method configures how assets
   * are loaded and processed across all parsers.
   * @param preferences - Asset loading preferences
   * @example
   * ```ts
   * // Basic preferences
   * Assets.setPreferences({
   *     crossOrigin: 'anonymous',
   *     parseAsGraphicsContext: false
   * });
   * ```
   * @remarks
   * Preferences are applied to all compatible parsers and affect future asset loading.
   * Common preferences include:
   * - `crossOrigin`: CORS setting for loaded assets
   * - `preferWorkers`: Whether to use web workers for loading textures
   * - `preferCreateImageBitmap`: Use `createImageBitmap` for texture creation. Turning this off will use the `Image` constructor instead.
   * @see {@link AssetsPreferences} For all available preferences
   */ setPreferences(preferences) {
        this.loader.parsers.forEach((parser)=>{
            if (!parser.config) return;
            Object.keys(parser.config).filter((key)=>key in preferences).forEach((key)=>{
                parser.config[key] = preferences[key];
            });
        });
    }
}
const $f4e4ce59fcdafcd2$export$c8eca95e306f7116 = new $f4e4ce59fcdafcd2$export$137d4dd907afac85();
(0, $i9BKe.extensions).handleByList((0, $i9BKe.ExtensionType).LoadParser, $f4e4ce59fcdafcd2$export$c8eca95e306f7116.loader.parsers).handleByList((0, $i9BKe.ExtensionType).ResolveParser, $f4e4ce59fcdafcd2$export$c8eca95e306f7116.resolver.parsers).handleByList((0, $i9BKe.ExtensionType).CacheParser, $f4e4ce59fcdafcd2$export$c8eca95e306f7116.cache.parsers).handleByList((0, $i9BKe.ExtensionType).DetectionParser, $f4e4ce59fcdafcd2$export$c8eca95e306f7116.detections);
(0, $i9BKe.extensions).add((0, $bAT0b.cacheTextureArray), (0, $cIKeV.detectDefaults), (0, $jFxOf.detectAvif), (0, $fYq25.detectWebp), (0, $h6G9W.detectMp4), (0, $22lcm.detectOgv), (0, $f5yRY.detectWebm), (0, $30kAw.loadJson), (0, $eOARC.loadTxt), (0, $13zV0.loadWebFont), (0, $geSSO.loadSvg), (0, $ckjdh.loadTextures), (0, $qPdOe.loadVideoTextures), (0, $5ilA5.loadBitmapFont), (0, $5ilA5.bitmapFontCachePlugin), (0, $7ESOd.resolveTextureUrl), (0, $iiAQE.resolveJsonUrl));
const $f4e4ce59fcdafcd2$var$assetKeyMap = {
    loader: (0, $i9BKe.ExtensionType).LoadParser,
    resolver: (0, $i9BKe.ExtensionType).ResolveParser,
    cache: (0, $i9BKe.ExtensionType).CacheParser,
    detection: (0, $i9BKe.ExtensionType).DetectionParser
};
(0, $i9BKe.extensions).handle((0, $i9BKe.ExtensionType).Asset, (extension)=>{
    const ref = extension.ref;
    Object.entries($f4e4ce59fcdafcd2$var$assetKeyMap).filter(([key])=>!!ref[key]).forEach(([key, type])=>(0, $i9BKe.extensions).add(Object.assign(ref[key], // Allow the function to optionally define it's own
        // ExtensionMetadata, the use cases here is priority for LoaderParsers
        {
            extension: ref[key].extension ?? type
        })));
}, (extension)=>{
    const ref = extension.ref;
    Object.keys($f4e4ce59fcdafcd2$var$assetKeyMap).filter((key)=>!!ref[key]).forEach((key)=>(0, $i9BKe.extensions).remove(ref[key]));
});

});
parcelRegister("5ilA5", function(module, exports) {

$parcel$export(module.exports, "bitmapFontCachePlugin", () => $67f0360d0045775d$export$778a313228f06f6c);
$parcel$export(module.exports, "loadBitmapFont", () => $67f0360d0045775d$export$402edee29ac8bed4);

var $iEtN5 = parcelRequire("iEtN5");

var $5Oad7 = parcelRequire("5Oad7");

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $lzfZe = parcelRequire("lzfZe");

var $fl08K = parcelRequire("fl08K");

var $isMCe = parcelRequire("isMCe");

var $hsuiF = parcelRequire("hsuiF");
"use strict";
const $67f0360d0045775d$var$validExtensions = [
    ".xml",
    ".fnt"
];
const $67f0360d0045775d$export$778a313228f06f6c = {
    extension: {
        type: (0, $i9BKe.ExtensionType).CacheParser,
        name: "cacheBitmapFont"
    },
    test: (asset)=>asset instanceof (0, $fl08K.BitmapFont),
    getCacheableAssets (keys, asset) {
        const out = {};
        keys.forEach((key)=>{
            out[key] = asset;
            out[`${key}-bitmap`] = asset;
        });
        out[`${asset.fontFamily}-bitmap`] = asset;
        return out;
    }
};
const $67f0360d0045775d$export$402edee29ac8bed4 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Normal
    },
    /** used for deprecation purposes */ name: "loadBitmapFont",
    id: "bitmap-font",
    test (url) {
        return $67f0360d0045775d$var$validExtensions.includes((0, $lzfZe.path).extname(url).toLowerCase());
    },
    async testParse (data) {
        return (0, $isMCe.bitmapFontTextParser).test(data) || (0, $hsuiF.bitmapFontXMLStringParser).test(data);
    },
    async parse (asset, data, loader) {
        const bitmapFontData = (0, $isMCe.bitmapFontTextParser).test(asset) ? (0, $isMCe.bitmapFontTextParser).parse(asset) : (0, $hsuiF.bitmapFontXMLStringParser).parse(asset);
        const { src: src } = data;
        const { pages: pages } = bitmapFontData;
        const textureUrls = [];
        const textureOptions = bitmapFontData.distanceField ? {
            scaleMode: "linear",
            alphaMode: "premultiply-alpha-on-upload",
            autoGenerateMipmaps: false,
            resolution: 1
        } : {};
        for(let i = 0; i < pages.length; ++i){
            const pageFile = pages[i].file;
            let imagePath = (0, $lzfZe.path).join((0, $lzfZe.path).dirname(src), pageFile);
            imagePath = (0, $5Oad7.copySearchParams)(imagePath, src);
            textureUrls.push({
                src: imagePath,
                data: textureOptions
            });
        }
        const loadedTextures = await loader.load(textureUrls);
        const textures = textureUrls.map((url)=>loadedTextures[url.src]);
        const bitmapFont = new (0, $fl08K.BitmapFont)({
            data: bitmapFontData,
            textures: textures
        }, src);
        return bitmapFont;
    },
    async load (url, _options) {
        const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
        return await response.text();
    },
    async unload (bitmapFont, _resolvedAsset, loader) {
        await Promise.all(bitmapFont.pages.map((page)=>loader.unload(page.texture.source._sourceOrigin)));
        bitmapFont.destroy();
    }
};

});
parcelRegister("fl08K", function(module, exports) {

$parcel$export(module.exports, "BitmapFont", () => $e203ca19ce7419c5$export$17957a09927cadc7);

var $2RwkA = parcelRequire("2RwkA");

var $fM4Mk = parcelRequire("fM4Mk");

var $bLlTJ = parcelRequire("bLlTJ");

var $hlNkG = parcelRequire("hlNkG");

var $axl5b = parcelRequire("axl5b");
"use strict";
class $e203ca19ce7419c5$export$17957a09927cadc7 extends (0, $hlNkG.AbstractBitmapFont) {
    constructor(options, url){
        super();
        const { textures: textures, data: data } = options;
        Object.keys(data.pages).forEach((key)=>{
            const pageData = data.pages[parseInt(key, 10)];
            const texture = textures[pageData.id];
            this.pages.push({
                texture: texture
            });
        });
        Object.keys(data.chars).forEach((key)=>{
            const charData = data.chars[key];
            const { frame: textureFrame, source: textureSource, rotate: textureRotate } = textures[charData.page];
            const frame = (0, $2RwkA.groupD8).transformRectCoords(charData, textureFrame, textureRotate, new (0, $fM4Mk.Rectangle)());
            const texture = new (0, $bLlTJ.Texture)({
                frame: frame,
                orig: new (0, $fM4Mk.Rectangle)(0, 0, charData.width, charData.height),
                source: textureSource,
                rotate: textureRotate
            });
            this.chars[key] = {
                id: key.codePointAt(0),
                xOffset: charData.xOffset,
                yOffset: charData.yOffset,
                xAdvance: charData.xAdvance,
                kerning: charData.kerning ?? {},
                texture: texture
            };
        });
        this.baseRenderedFontSize = data.fontSize;
        this.baseMeasurementFontSize = data.fontSize;
        this.fontMetrics = {
            ascent: 0,
            descent: 0,
            fontSize: data.fontSize
        };
        this.baseLineOffset = data.baseLineOffset;
        this.lineHeight = data.lineHeight;
        this.fontFamily = data.fontFamily;
        this.distanceField = data.distanceField ?? {
            type: "none",
            range: 0
        };
        this.url = url;
    }
    /** Destroys the BitmapFont object. */ destroy() {
        super.destroy();
        for(let i = 0; i < this.pages.length; i++){
            const { texture: texture } = this.pages[i];
            texture.destroy(true);
        }
        this.pages = null;
    }
    /**
   * Generates and installs a bitmap font with the specified options.
   * The font will be cached and available for use in BitmapText objects.
   * @param options - Setup options for font generation
   * @returns Installed font instance
   * @example
   * ```ts
   * // Install a basic font
   * BitmapFont.install({
   *     name: 'Title',
   *     style: {
   *         fontFamily: 'Arial',
   *         fontSize: 32,
   *         fill: '#ffffff'
   *     }
   * });
   *
   * // Install with advanced options
   * BitmapFont.install({
   *     name: 'Custom',
   *     style: {
   *         fontFamily: 'Arial',
   *         fontSize: 24,
   *         fill: '#00ff00',
   *         stroke: { color: '#000000', width: 2 }
   *     },
   *     chars: [['a', 'z'], ['A', 'Z'], ['0', '9']],
   *     resolution: 2,
   *     padding: 4,
   *     textureStyle: {
   *         scaleMode: 'nearest'
   *     }
   * });
   * ```
   */ static install(options) {
        (0, $axl5b.BitmapFontManager).install(options);
    }
    /**
   * Uninstalls a bitmap font from the cache.
   * This frees up memory and resources associated with the font.
   * @param name - The name of the bitmap font to uninstall
   * @example
   * ```ts
   * // Remove a font when it's no longer needed
   * BitmapFont.uninstall('MyCustomFont');
   *
   * // Clear multiple fonts
   * ['Title', 'Heading', 'Body'].forEach(BitmapFont.uninstall);
   * ```
   */ static uninstall(name) {
        (0, $axl5b.BitmapFontManager).uninstall(name);
    }
}

});

parcelRegister("isMCe", function(module, exports) {

$parcel$export(module.exports, "bitmapFontTextParser", () => $2e97ab653ff7bb1e$export$4c1815a0944ccac0);
"use strict";
const $2e97ab653ff7bb1e$export$4c1815a0944ccac0 = {
    test (data) {
        return typeof data === "string" && data.startsWith("info face=");
    },
    parse (txt) {
        const items = txt.match(/^[a-z]+\s+.+$/gm);
        const rawData = {
            info: [],
            common: [],
            page: [],
            char: [],
            chars: [],
            kerning: [],
            kernings: [],
            distanceField: []
        };
        for(const i in items){
            const name = items[i].match(/^[a-z]+/gm)[0];
            const attributeList = items[i].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm);
            const itemData = {};
            for(const i2 in attributeList){
                const split = attributeList[i2].split("=");
                const key = split[0];
                const strValue = split[1].replace(/"/gm, "");
                const floatValue = parseFloat(strValue);
                const value = isNaN(floatValue) ? strValue : floatValue;
                itemData[key] = value;
            }
            rawData[name].push(itemData);
        }
        const font = {
            chars: {},
            pages: [],
            lineHeight: 0,
            fontSize: 0,
            fontFamily: "",
            distanceField: null,
            baseLineOffset: 0
        };
        const [info] = rawData.info;
        const [common] = rawData.common;
        const [distanceField] = rawData.distanceField ?? [];
        if (distanceField) font.distanceField = {
            range: parseInt(distanceField.distanceRange, 10),
            type: distanceField.fieldType
        };
        font.fontSize = parseInt(info.size, 10);
        font.fontFamily = info.face;
        font.lineHeight = parseInt(common.lineHeight, 10);
        const page = rawData.page;
        for(let i = 0; i < page.length; i++)font.pages.push({
            id: parseInt(page[i].id, 10) || 0,
            file: page[i].file
        });
        const map = {};
        font.baseLineOffset = font.lineHeight - parseInt(common.base, 10);
        const char = rawData.char;
        for(let i = 0; i < char.length; i++){
            const charNode = char[i];
            const id = parseInt(charNode.id, 10);
            let letter = charNode.letter ?? charNode.char ?? String.fromCharCode(id);
            if (letter === "space") letter = " ";
            map[id] = letter;
            font.chars[letter] = {
                id: id,
                // texture deets..
                page: parseInt(charNode.page, 10) || 0,
                x: parseInt(charNode.x, 10),
                y: parseInt(charNode.y, 10),
                width: parseInt(charNode.width, 10),
                height: parseInt(charNode.height, 10),
                xOffset: parseInt(charNode.xoffset, 10),
                yOffset: parseInt(charNode.yoffset, 10),
                xAdvance: parseInt(charNode.xadvance, 10),
                kerning: {}
            };
        }
        const kerning = rawData.kerning || [];
        for(let i = 0; i < kerning.length; i++){
            const first = parseInt(kerning[i].first, 10);
            const second = parseInt(kerning[i].second, 10);
            const amount = parseInt(kerning[i].amount, 10);
            font.chars[map[second]].kerning[map[first]] = amount;
        }
        return font;
    }
};

});

parcelRegister("hsuiF", function(module, exports) {

$parcel$export(module.exports, "bitmapFontXMLStringParser", () => $bc1a44b21cd9ad12$export$bfc0a19e2e2cc16);

var $iCGeI = parcelRequire("iCGeI");

var $KAE8q = parcelRequire("KAE8q");
"use strict";
const $bc1a44b21cd9ad12$export$bfc0a19e2e2cc16 = {
    test (data) {
        if (typeof data === "string" && data.includes("<font>")) return (0, $KAE8q.bitmapFontXMLParser).test((0, $iCGeI.DOMAdapter).get().parseXML(data));
        return false;
    },
    parse (data) {
        return (0, $KAE8q.bitmapFontXMLParser).parse((0, $iCGeI.DOMAdapter).get().parseXML(data));
    }
};

});
parcelRegister("KAE8q", function(module, exports) {

$parcel$export(module.exports, "bitmapFontXMLParser", () => $e7c71a5aa13eb859$export$7a7adbcafc5cf8e3);
"use strict";
const $e7c71a5aa13eb859$export$7a7adbcafc5cf8e3 = {
    test (data) {
        const xml = data;
        return typeof xml !== "string" && "getElementsByTagName" in xml && xml.getElementsByTagName("page").length && xml.getElementsByTagName("info")[0].getAttribute("face") !== null;
    },
    parse (xml) {
        const data = {
            chars: {},
            pages: [],
            lineHeight: 0,
            fontSize: 0,
            fontFamily: "",
            distanceField: null,
            baseLineOffset: 0
        };
        const info = xml.getElementsByTagName("info")[0];
        const common = xml.getElementsByTagName("common")[0];
        const distanceField = xml.getElementsByTagName("distanceField")[0];
        if (distanceField) data.distanceField = {
            type: distanceField.getAttribute("fieldType"),
            range: parseInt(distanceField.getAttribute("distanceRange"), 10)
        };
        const page = xml.getElementsByTagName("page");
        const char = xml.getElementsByTagName("char");
        const kerning = xml.getElementsByTagName("kerning");
        data.fontSize = parseInt(info.getAttribute("size"), 10);
        data.fontFamily = info.getAttribute("face");
        data.lineHeight = parseInt(common.getAttribute("lineHeight"), 10);
        for(let i = 0; i < page.length; i++)data.pages.push({
            id: parseInt(page[i].getAttribute("id"), 10) || 0,
            file: page[i].getAttribute("file")
        });
        const map = {};
        data.baseLineOffset = data.lineHeight - parseInt(common.getAttribute("base"), 10);
        for(let i = 0; i < char.length; i++){
            const charNode = char[i];
            const id = parseInt(charNode.getAttribute("id"), 10);
            let letter = charNode.getAttribute("letter") ?? charNode.getAttribute("char") ?? String.fromCharCode(id);
            if (letter === "space") letter = " ";
            map[id] = letter;
            data.chars[letter] = {
                id: id,
                // texture deets..
                page: parseInt(charNode.getAttribute("page"), 10) || 0,
                x: parseInt(charNode.getAttribute("x"), 10),
                y: parseInt(charNode.getAttribute("y"), 10),
                width: parseInt(charNode.getAttribute("width"), 10),
                height: parseInt(charNode.getAttribute("height"), 10),
                // render deets..
                xOffset: parseInt(charNode.getAttribute("xoffset"), 10),
                yOffset: parseInt(charNode.getAttribute("yoffset"), 10),
                // + baseLineOffset,
                xAdvance: parseInt(charNode.getAttribute("xadvance"), 10),
                kerning: {}
            };
        }
        for(let i = 0; i < kerning.length; i++){
            const first = parseInt(kerning[i].getAttribute("first"), 10);
            const second = parseInt(kerning[i].getAttribute("second"), 10);
            const amount = parseInt(kerning[i].getAttribute("amount"), 10);
            data.chars[map[second]].kerning[map[first]] = amount;
        }
        return data;
    }
};

});



parcelRegister("8z5x8", function(module, exports) {

$parcel$export(module.exports, "BackgroundLoader", () => $1adc37b2cea8de16$export$1949379a83b843d5);
"use strict";
class $1adc37b2cea8de16$export$1949379a83b843d5 {
    /**
   * @param loader
   * @param verbose - should the loader log to the console
   */ constructor(loader, verbose = false){
        this._loader = loader;
        this._assetList = [];
        this._isLoading = false;
        this._maxConcurrent = 1;
        this.verbose = verbose;
    }
    /**
   * Adds assets to the background loading queue. Assets are loaded one at a time to minimize
   * performance impact.
   * @param assetUrls - Array of resolved assets to load in the background
   * @example
   * ```ts
   * // Add assets to background load queue
   * backgroundLoader.add([
   *     { src: 'images/level1/bg.png' },
   *     { src: 'images/level1/characters.json' }
   * ]);
   *
   * // Assets will load sequentially in the background
   * // The loader automatically pauses when high-priority loads occur
   * // e.g. Assets.load() is called
   * ```
   * @remarks
   * - Assets are loaded one at a time to minimize performance impact
   * - Loading automatically pauses when Assets.load() is called
   * - No progress tracking is available for background loading
   * - Assets are cached as they complete loading
   * @internal
   */ add(assetUrls) {
        assetUrls.forEach((a)=>{
            this._assetList.push(a);
        });
        if (this.verbose) console.log("[BackgroundLoader] assets: ", this._assetList);
        if (this._isActive && !this._isLoading) this._next();
    }
    /**
   * Loads the next set of assets. Will try to load as many assets as it can at the same time.
   *
   * The max assets it will try to load at one time will be 4.
   */ async _next() {
        if (this._assetList.length && this._isActive) {
            this._isLoading = true;
            const toLoad = [];
            const toLoadAmount = Math.min(this._assetList.length, this._maxConcurrent);
            for(let i = 0; i < toLoadAmount; i++)toLoad.push(this._assetList.pop());
            await this._loader.load(toLoad);
            this._isLoading = false;
            this._next();
        }
    }
    /**
   * Controls the active state of the background loader. When active, the loader will
   * continue processing its queue. When inactive, loading is paused.
   * @returns Whether the background loader is currently active
   * @example
   * ```ts
   * // Pause background loading
   * backgroundLoader.active = false;
   *
   * // Resume background loading
   * backgroundLoader.active = true;
   *
   * // Check current state
   * console.log(backgroundLoader.active); // true/false
   *
   * // Common use case: Pause during intensive operations
   * backgroundLoader.active = false;  // Pause background loading
   * ... // Perform high-priority tasks
   * backgroundLoader.active = true;   // Resume background loading
   * ```
   * @remarks
   * - Setting to true resumes loading immediately
   * - Setting to false pauses after current asset completes
   * - Background loading is automatically paused during `Assets.load()`
   * - Assets already being loaded will complete even when set to false
   */ get active() {
        return this._isActive;
    }
    set active(value) {
        if (this._isActive === value) return;
        this._isActive = value;
        if (value && !this._isLoading) this._next();
    }
}

});

parcelRegister("bAT0b", function(module, exports) {

$parcel$export(module.exports, "cacheTextureArray", () => $df4c0fb70a898168$export$407b4625a915919d);

var $i9BKe = parcelRequire("i9BKe");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $df4c0fb70a898168$export$407b4625a915919d = {
    extension: {
        type: (0, $i9BKe.ExtensionType).CacheParser,
        name: "cacheTextureArray"
    },
    test: (asset)=>Array.isArray(asset) && asset.every((t)=>t instanceof (0, $bLlTJ.Texture)),
    getCacheableAssets: (keys, asset)=>{
        const out = {};
        keys.forEach((key)=>{
            asset.forEach((item, i)=>{
                out[key + (i === 0 ? "" : i + 1)] = item;
            });
        });
        return out;
    }
};

});

parcelRegister("jFxOf", function(module, exports) {

$parcel$export(module.exports, "detectAvif", () => $ca5df6e874c0bc98$export$a60d2d4a3c570783);

var $i9BKe = parcelRequire("i9BKe");

var $dHzPG = parcelRequire("dHzPG");
"use strict";
const $ca5df6e874c0bc98$export$a60d2d4a3c570783 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 1
    },
    test: async ()=>(0, $dHzPG.testImageFormat)(// eslint-disable-next-line max-len
        "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A="),
    add: async (formats)=>[
            ...formats,
            "avif"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "avif")
};

});
parcelRegister("dHzPG", function(module, exports) {

$parcel$export(module.exports, "testImageFormat", () => $36c6a70b0c6633f6$export$7c459e568e7cea2c);
"use strict";
async function $36c6a70b0c6633f6$export$7c459e568e7cea2c(imageData) {
    if ("Image" in globalThis) return new Promise((resolve)=>{
        const image = new Image();
        image.onload = ()=>{
            resolve(true);
        };
        image.onerror = ()=>{
            resolve(false);
        };
        image.src = imageData;
    });
    if ("createImageBitmap" in globalThis && "fetch" in globalThis) {
        try {
            const blob = await (await fetch(imageData)).blob();
            await createImageBitmap(blob);
        } catch (_e) {
            return false;
        }
        return true;
    }
    return false;
}

});


parcelRegister("cIKeV", function(module, exports) {

$parcel$export(module.exports, "detectDefaults", () => $c65eb9bc0713cb5d$export$b106d7c2de3b4d89);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $c65eb9bc0713cb5d$var$imageFormats = [
    "png",
    "jpg",
    "jpeg"
];
const $c65eb9bc0713cb5d$export$b106d7c2de3b4d89 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: -1
    },
    test: ()=>Promise.resolve(true),
    add: async (formats)=>[
            ...formats,
            ...$c65eb9bc0713cb5d$var$imageFormats
        ],
    remove: async (formats)=>formats.filter((f)=>!$c65eb9bc0713cb5d$var$imageFormats.includes(f))
};

});

parcelRegister("h6G9W", function(module, exports) {

$parcel$export(module.exports, "detectMp4", () => $8c93018bb9bae76f$export$7726d83fee274e25);

var $i9BKe = parcelRequire("i9BKe");

var $eSIgD = parcelRequire("eSIgD");
"use strict";
const $8c93018bb9bae76f$export$7726d83fee274e25 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $eSIgD.testVideoFormat)("video/mp4"),
    add: async (formats)=>[
            ...formats,
            "mp4",
            "m4v"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "mp4" && f !== "m4v")
};

});
parcelRegister("eSIgD", function(module, exports) {

$parcel$export(module.exports, "testVideoFormat", () => $2ba590fe27c747f9$export$7a571c147b03abb1);
"use strict";
const $2ba590fe27c747f9$var$inWorker = "WorkerGlobalScope" in globalThis && globalThis instanceof globalThis.WorkerGlobalScope;
function $2ba590fe27c747f9$export$7a571c147b03abb1(mimeType) {
    if ($2ba590fe27c747f9$var$inWorker) return false;
    const video = document.createElement("video");
    return video.canPlayType(mimeType) !== "";
}

});


parcelRegister("22lcm", function(module, exports) {

$parcel$export(module.exports, "detectOgv", () => $dfa8be665f85221f$export$5a1da481121f806a);

var $i9BKe = parcelRequire("i9BKe");

var $eSIgD = parcelRequire("eSIgD");
"use strict";
const $dfa8be665f85221f$export$5a1da481121f806a = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $eSIgD.testVideoFormat)("video/ogg"),
    add: async (formats)=>[
            ...formats,
            "ogv"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "ogv")
};

});

parcelRegister("f5yRY", function(module, exports) {

$parcel$export(module.exports, "detectWebm", () => $64abecc9a39a8c54$export$a041d698a1896657);

var $i9BKe = parcelRequire("i9BKe");

var $eSIgD = parcelRequire("eSIgD");
"use strict";
const $64abecc9a39a8c54$export$a041d698a1896657 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $eSIgD.testVideoFormat)("video/webm"),
    add: async (formats)=>[
            ...formats,
            "webm"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webm")
};

});

parcelRegister("fYq25", function(module, exports) {

$parcel$export(module.exports, "detectWebp", () => $c494cf4c5ea6913a$export$d19529a9ed9823d4);

var $i9BKe = parcelRequire("i9BKe");

var $dHzPG = parcelRequire("dHzPG");
"use strict";
const $c494cf4c5ea6913a$export$d19529a9ed9823d4 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $dHzPG.testImageFormat)("data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA="),
    add: async (formats)=>[
            ...formats,
            "webp"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webp")
};

});

parcelRegister("5sc0S", function(module, exports) {

$parcel$export(module.exports, "Loader", () => $be4c9d6031b69343$export$3b0d6d7590275603);

var $hUCK4 = parcelRequire("hUCK4");

var $lzfZe = parcelRequire("lzfZe");

var $3CHiv = parcelRequire("3CHiv");

var $4DmkB = parcelRequire("4DmkB");
"use strict";
class $be4c9d6031b69343$export$3b0d6d7590275603 {
    constructor(){
        this._parsers = [];
        this._parsersValidated = false;
        /**
     * All loader parsers registered
     * @type {assets.LoaderParser[]}
     */ this.parsers = new Proxy(this._parsers, {
            set: (target, key, value)=>{
                this._parsersValidated = false;
                target[key] = value;
                return true;
            }
        });
        /** Cache loading promises that ae currently active */ this.promiseCache = {};
    }
    /** function used for testing */ reset() {
        this._parsersValidated = false;
        this.promiseCache = {};
    }
    /**
   * Used internally to generate a promise for the asset to be loaded.
   * @param url - The URL to be loaded
   * @param data - any custom additional information relevant to the asset being loaded
   * @returns - a promise that will resolve to an Asset for example a Texture of a JSON object
   */ _getLoadPromiseAndParser(url, data) {
        const result = {
            promise: null,
            parser: null
        };
        result.promise = (async ()=>{
            let asset = null;
            let parser = null;
            if (data.parser || data.loadParser) {
                parser = this._parserHash[data.parser || data.loadParser];
                if (data.loadParser) (0, $hUCK4.warn)(`[Assets] "loadParser" is deprecated, use "parser" instead for ${url}`);
                if (!parser) (0, $hUCK4.warn)(`[Assets] specified load parser "${data.parser || data.loadParser}" not found while loading ${url}`);
            }
            if (!parser) {
                for(let i = 0; i < this.parsers.length; i++){
                    const parserX = this.parsers[i];
                    if (parserX.load && parserX.test?.(url, data, this)) {
                        parser = parserX;
                        break;
                    }
                }
                if (!parser) {
                    (0, $hUCK4.warn)(`[Assets] ${url} could not be loaded as we don't know how to parse it, ensure the correct parser has been added`);
                    return null;
                }
            }
            asset = await parser.load(url, data, this);
            result.parser = parser;
            for(let i = 0; i < this.parsers.length; i++){
                const parser2 = this.parsers[i];
                if (parser2.parse) {
                    if (parser2.parse && await parser2.testParse?.(asset, data, this)) {
                        asset = await parser2.parse(asset, data, this) || asset;
                        result.parser = parser2;
                    }
                }
            }
            return asset;
        })();
        return result;
    }
    async load(assetsToLoadIn, onProgress) {
        if (!this._parsersValidated) this._validateParsers();
        let count = 0;
        const assets = {};
        const singleAsset = (0, $4DmkB.isSingleItem)(assetsToLoadIn);
        const assetsToLoad = (0, $3CHiv.convertToList)(assetsToLoadIn, (item)=>({
                alias: [
                    item
                ],
                src: item,
                data: {}
            }));
        const total = assetsToLoad.length;
        const promises = assetsToLoad.map(async (asset)=>{
            const url = (0, $lzfZe.path).toAbsolute(asset.src);
            if (!assets[asset.src]) try {
                if (!this.promiseCache[url]) this.promiseCache[url] = this._getLoadPromiseAndParser(url, asset);
                assets[asset.src] = await this.promiseCache[url].promise;
                if (onProgress) onProgress(++count / total);
            } catch (e) {
                delete this.promiseCache[url];
                delete assets[asset.src];
                throw new Error(`[Loader.load] Failed to load ${url}.
${e}`);
            }
        });
        await Promise.all(promises);
        return singleAsset ? assets[assetsToLoad[0].src] : assets;
    }
    /**
   * Unloads one or more assets. Any unloaded assets will be destroyed, freeing up memory for your app.
   * The parser that created the asset, will be the one that unloads it.
   * @example
   * // Single asset:
   * const asset = await Loader.load('cool.png');
   *
   * await Loader.unload('cool.png');
   *
   * console.log(asset.destroyed); // true
   * @param assetsToUnloadIn - urls that you want to unload, or a single one!
   */ async unload(assetsToUnloadIn) {
        const assetsToUnload = (0, $3CHiv.convertToList)(assetsToUnloadIn, (item)=>({
                alias: [
                    item
                ],
                src: item
            }));
        const promises = assetsToUnload.map(async (asset)=>{
            const url = (0, $lzfZe.path).toAbsolute(asset.src);
            const loadPromise = this.promiseCache[url];
            if (loadPromise) {
                const loadedAsset = await loadPromise.promise;
                delete this.promiseCache[url];
                await loadPromise.parser?.unload?.(loadedAsset, asset, this);
            }
        });
        await Promise.all(promises);
    }
    /** validates our parsers, right now it only checks for name conflicts but we can add more here as required! */ _validateParsers() {
        this._parsersValidated = true;
        this._parserHash = this._parsers.filter((parser)=>parser.name || parser.id).reduce((hash, parser)=>{
            if (!parser.name && !parser.id) (0, $hUCK4.warn)(`[Assets] parser should have an id`);
            else if (hash[parser.name] || hash[parser.id]) (0, $hUCK4.warn)(`[Assets] parser id conflict "${parser.id}"`);
            hash[parser.name] = parser;
            if (parser.id) hash[parser.id] = parser;
            return hash;
        }, {});
    }
}

});

parcelRegister("30kAw", function(module, exports) {

$parcel$export(module.exports, "loadJson", () => $c569a63b2f914437$export$e7c8553478f3aac7);

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $lXxYk = parcelRequire("lXxYk");

var $dofl4 = parcelRequire("dofl4");

var $iEtN5 = parcelRequire("iEtN5");
"use strict";
const $c569a63b2f914437$var$validJSONExtension = ".json";
const $c569a63b2f914437$var$validJSONMIME = "application/json";
const $c569a63b2f914437$export$e7c8553478f3aac7 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Low
    },
    /** used for deprecation purposes */ name: "loadJson",
    id: "json",
    test (url) {
        return (0, $lXxYk.checkDataUrl)(url, $c569a63b2f914437$var$validJSONMIME) || (0, $dofl4.checkExtension)(url, $c569a63b2f914437$var$validJSONExtension);
    },
    async load (url) {
        const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
        const json = await response.json();
        return json;
    }
};

});
parcelRegister("lXxYk", function(module, exports) {

$parcel$export(module.exports, "checkDataUrl", () => $d89e452ad91824ca$export$7ff8b059fb914323);
"use strict";
function $d89e452ad91824ca$export$7ff8b059fb914323(url, mimes) {
    if (Array.isArray(mimes)) {
        for (const mime of mimes){
            if (url.startsWith(`data:${mime}`)) return true;
        }
        return false;
    }
    return url.startsWith(`data:${mimes}`);
}

});

parcelRegister("dofl4", function(module, exports) {

$parcel$export(module.exports, "checkExtension", () => $8f487e3828a5ee92$export$fd0180357b95b812);

var $lzfZe = parcelRequire("lzfZe");
"use strict";
function $8f487e3828a5ee92$export$fd0180357b95b812(url, extension) {
    const tempURL = url.split("?")[0];
    const ext = (0, $lzfZe.path).extname(tempURL).toLowerCase();
    if (Array.isArray(extension)) return extension.includes(ext);
    return ext === extension;
}

});


parcelRegister("eOARC", function(module, exports) {

$parcel$export(module.exports, "loadTxt", () => $779da4c964b62347$export$3835b7ee6dbebde8);

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $lXxYk = parcelRequire("lXxYk");

var $dofl4 = parcelRequire("dofl4");

var $iEtN5 = parcelRequire("iEtN5");
"use strict";
const $779da4c964b62347$var$validTXTExtension = ".txt";
const $779da4c964b62347$var$validTXTMIME = "text/plain";
const $779da4c964b62347$export$3835b7ee6dbebde8 = {
    /** used for deprecation purposes */ name: "loadTxt",
    id: "text",
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Low,
        name: "loadTxt"
    },
    test (url) {
        return (0, $lXxYk.checkDataUrl)(url, $779da4c964b62347$var$validTXTMIME) || (0, $dofl4.checkExtension)(url, $779da4c964b62347$var$validTXTExtension);
    },
    async load (url) {
        const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
        const txt = await response.text();
        return txt;
    }
};

});

parcelRegister("13zV0", function(module, exports) {

$parcel$export(module.exports, "loadWebFont", () => $0568dcd95d86dd78$export$129ed93ad26b0298);

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $hUCK4 = parcelRequire("hUCK4");

var $lzfZe = parcelRequire("lzfZe");

var $2IhKp = parcelRequire("2IhKp");

var $lXxYk = parcelRequire("lXxYk");

var $dofl4 = parcelRequire("dofl4");

var $iEtN5 = parcelRequire("iEtN5");
"use strict";
const $0568dcd95d86dd78$var$validWeights = [
    "normal",
    "bold",
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900"
];
const $0568dcd95d86dd78$var$validFontExtensions = [
    ".ttf",
    ".otf",
    ".woff",
    ".woff2"
];
const $0568dcd95d86dd78$var$validFontMIMEs = [
    "font/ttf",
    "font/otf",
    "font/woff",
    "font/woff2"
];
const $0568dcd95d86dd78$var$CSS_IDENT_TOKEN_REGEX = /^(--|-?[A-Z_])[0-9A-Z_-]*$/i;
function $0568dcd95d86dd78$export$c461ca8f39d93d9b(url) {
    const ext = (0, $lzfZe.path).extname(url);
    const name = (0, $lzfZe.path).basename(url, ext);
    const nameWithSpaces = name.replace(/(-|_)/g, " ");
    const nameTokens = nameWithSpaces.toLowerCase().split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1));
    let valid = nameTokens.length > 0;
    for (const token of nameTokens)if (!token.match($0568dcd95d86dd78$var$CSS_IDENT_TOKEN_REGEX)) {
        valid = false;
        break;
    }
    let fontFamilyName = nameTokens.join(" ");
    if (!valid) fontFamilyName = `"${fontFamilyName.replace(/[\\"]/g, "\\$&")}"`;
    return fontFamilyName;
}
const $0568dcd95d86dd78$var$validURICharactersRegex = /^[0-9A-Za-z%:/?#\[\]@!\$&'()\*\+,;=\-._~]*$/;
function $0568dcd95d86dd78$var$encodeURIWhenNeeded(uri) {
    if ($0568dcd95d86dd78$var$validURICharactersRegex.test(uri)) return uri;
    return encodeURI(uri);
}
const $0568dcd95d86dd78$export$129ed93ad26b0298 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Low
    },
    /** used for deprecation purposes */ name: "loadWebFont",
    id: "web-font",
    test (url) {
        return (0, $lXxYk.checkDataUrl)(url, $0568dcd95d86dd78$var$validFontMIMEs) || (0, $dofl4.checkExtension)(url, $0568dcd95d86dd78$var$validFontExtensions);
    },
    async load (url, options) {
        const fonts = (0, $iCGeI.DOMAdapter).get().getFontFaceSet();
        if (fonts) {
            const fontFaces = [];
            const name = options.data?.family ?? $0568dcd95d86dd78$export$c461ca8f39d93d9b(url);
            const weights = options.data?.weights?.filter((weight)=>$0568dcd95d86dd78$var$validWeights.includes(weight)) ?? [
                "normal"
            ];
            const data = options.data ?? {};
            for(let i = 0; i < weights.length; i++){
                const weight = weights[i];
                const font = new FontFace(name, `url(${$0568dcd95d86dd78$var$encodeURIWhenNeeded(url)})`, {
                    ...data,
                    weight: weight
                });
                await font.load();
                fonts.add(font);
                fontFaces.push(font);
            }
            if ((0, $2IhKp.Cache).has(`${name}-and-url`)) {
                const cached = (0, $2IhKp.Cache).get(`${name}-and-url`);
                cached.entries.push({
                    url: url,
                    faces: fontFaces
                });
            } else (0, $2IhKp.Cache).set(`${name}-and-url`, {
                entries: [
                    {
                        url: url,
                        faces: fontFaces
                    }
                ]
            });
            return fontFaces.length === 1 ? fontFaces[0] : fontFaces;
        }
        (0, $hUCK4.warn)("[loadWebFont] FontFace API is not supported. Skipping loading font");
        return null;
    },
    unload (font) {
        const fonts = Array.isArray(font) ? font : [
            font
        ];
        const fontFamily = fonts[0].family;
        const cached = (0, $2IhKp.Cache).get(`${fontFamily}-and-url`);
        const entry = cached.entries.find((f)=>f.faces.some((t)=>fonts.indexOf(t) !== -1));
        entry.faces = entry.faces.filter((f)=>fonts.indexOf(f) === -1);
        if (entry.faces.length === 0) cached.entries = cached.entries.filter((f)=>f !== entry);
        fonts.forEach((t)=>{
            (0, $iCGeI.DOMAdapter).get().getFontFaceSet().delete(t);
        });
        if (cached.entries.length === 0) (0, $2IhKp.Cache).remove(`${fontFamily}-and-url`);
    }
};

});

parcelRegister("geSSO", function(module, exports) {

$parcel$export(module.exports, "loadSvg", () => $258a91d856307e86$export$b6a2e78b63791dfa);

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $aQPld = parcelRequire("aQPld");

var $8aC7P = parcelRequire("8aC7P");

var $e80R6 = parcelRequire("e80R6");

var $lXxYk = parcelRequire("lXxYk");

var $dofl4 = parcelRequire("dofl4");

var $iEtN5 = parcelRequire("iEtN5");

var $jAkJt = parcelRequire("jAkJt");
"use strict";
const $258a91d856307e86$var$validSVGExtension = ".svg";
const $258a91d856307e86$var$validSVGMIME = "image/svg+xml";
const $258a91d856307e86$export$b6a2e78b63791dfa = {
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Low,
        name: "loadSVG"
    },
    /** used for deprecation purposes */ name: "loadSVG",
    id: "svg",
    config: {
        crossOrigin: "anonymous",
        parseAsGraphicsContext: false
    },
    test (url) {
        return (0, $lXxYk.checkDataUrl)(url, $258a91d856307e86$var$validSVGMIME) || (0, $dofl4.checkExtension)(url, $258a91d856307e86$var$validSVGExtension);
    },
    async load (url, asset, loader) {
        if (asset.data?.parseAsGraphicsContext ?? this.config.parseAsGraphicsContext) return $258a91d856307e86$var$loadAsGraphics(url);
        return $258a91d856307e86$var$loadAsTexture(url, asset, loader, this.config.crossOrigin);
    },
    unload (asset) {
        asset.destroy(true);
    }
};
async function $258a91d856307e86$var$loadAsTexture(url, asset, loader, crossOrigin) {
    const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
    const image = (0, $iCGeI.DOMAdapter).get().createImage();
    image.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(await response.text())}`;
    image.crossOrigin = crossOrigin;
    await image.decode();
    const width = asset.data?.width ?? image.width;
    const height = asset.data?.height ?? image.height;
    const resolution = asset.data?.resolution || (0, $e80R6.getResolutionOfUrl)(url);
    const canvasWidth = Math.ceil(width * resolution);
    const canvasHeight = Math.ceil(height * resolution);
    const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas(canvasWidth, canvasHeight);
    const context = canvas.getContext("2d");
    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = "high";
    context.drawImage(image, 0, 0, width * resolution, height * resolution);
    const { parseAsGraphicsContext: _p, ...rest } = asset.data ?? {};
    const base = new (0, $aQPld.ImageSource)({
        resource: canvas,
        alphaMode: "premultiply-alpha-on-upload",
        resolution: resolution,
        ...rest
    });
    return (0, $jAkJt.createTexture)(base, loader, url);
}
async function $258a91d856307e86$var$loadAsGraphics(url) {
    const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
    const svgSource = await response.text();
    const context = new (0, $8aC7P.GraphicsContext)();
    context.svg(svgSource);
    return context;
}

});
parcelRegister("e80R6", function(module, exports) {

$parcel$export(module.exports, "getResolutionOfUrl", () => $69836a01b04ce50b$export$8695ab2f322d2637);

var $8kCsw = parcelRequire("8kCsw");
"use strict";
function $69836a01b04ce50b$export$8695ab2f322d2637(url, defaultValue = 1) {
    const resolution = (0, $8kCsw.Resolver).RETINA_PREFIX?.exec(url);
    if (resolution) return parseFloat(resolution[1]);
    return defaultValue;
}

});

parcelRegister("jAkJt", function(module, exports) {

$parcel$export(module.exports, "createTexture", () => $703462f38e5d63e3$export$37b981a8c575f415);

var $bLlTJ = parcelRequire("bLlTJ");

var $hUCK4 = parcelRequire("hUCK4");

var $2IhKp = parcelRequire("2IhKp");
"use strict";
function $703462f38e5d63e3$export$37b981a8c575f415(source, loader, url) {
    source.label = url;
    source._sourceOrigin = url;
    const texture = new (0, $bLlTJ.Texture)({
        source: source,
        label: url
    });
    const unload = ()=>{
        delete loader.promiseCache[url];
        if ((0, $2IhKp.Cache).has(url)) (0, $2IhKp.Cache).remove(url);
    };
    texture.source.once("destroy", ()=>{
        if (loader.promiseCache[url]) {
            (0, $hUCK4.warn)("[Assets] A TextureSource managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the TextureSource.");
            unload();
        }
    });
    texture.once("destroy", ()=>{
        if (!source.destroyed) {
            (0, $hUCK4.warn)("[Assets] A Texture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the Texture.");
            unload();
        }
    });
    return texture;
}

});


parcelRegister("ckjdh", function(module, exports) {

$parcel$export(module.exports, "loadTextures", () => $7390591d087b0cdb$export$897b113ee8307cd0);

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $aQPld = parcelRequire("aQPld");

var $e80R6 = parcelRequire("e80R6");

var $lXxYk = parcelRequire("lXxYk");

var $dofl4 = parcelRequire("dofl4");

var $1nTSS = parcelRequire("1nTSS");

var $iEtN5 = parcelRequire("iEtN5");

var $jAkJt = parcelRequire("jAkJt");
"use strict";
const $7390591d087b0cdb$var$validImageExtensions = [
    ".jpeg",
    ".jpg",
    ".png",
    ".webp",
    ".avif"
];
const $7390591d087b0cdb$var$validImageMIMEs = [
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/avif"
];
async function $7390591d087b0cdb$export$c614e6247302006d(url, asset) {
    const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
    if (!response.ok) throw new Error(`[loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);
    const imageBlob = await response.blob();
    return asset?.data?.alphaMode === "premultiplied-alpha" ? createImageBitmap(imageBlob, {
        premultiplyAlpha: "none"
    }) : createImageBitmap(imageBlob);
}
const $7390591d087b0cdb$export$897b113ee8307cd0 = {
    /** used for deprecation purposes */ name: "loadTextures",
    id: "texture",
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).High,
        name: "loadTextures"
    },
    config: {
        preferWorkers: true,
        preferCreateImageBitmap: true,
        crossOrigin: "anonymous"
    },
    test (url) {
        return (0, $lXxYk.checkDataUrl)(url, $7390591d087b0cdb$var$validImageMIMEs) || (0, $dofl4.checkExtension)(url, $7390591d087b0cdb$var$validImageExtensions);
    },
    async load (url, asset, loader) {
        let src = null;
        if (globalThis.createImageBitmap && this.config.preferCreateImageBitmap) {
            if (this.config.preferWorkers && await (0, $1nTSS.WorkerManager).isImageBitmapSupported()) src = await (0, $1nTSS.WorkerManager).loadImageBitmap(url, asset);
            else src = await $7390591d087b0cdb$export$c614e6247302006d(url, asset);
        } else src = await new Promise((resolve, reject)=>{
            src = (0, $iCGeI.DOMAdapter).get().createImage();
            src.crossOrigin = this.config.crossOrigin;
            src.src = url;
            if (src.complete) resolve(src);
            else {
                src.onload = ()=>{
                    resolve(src);
                };
                src.onerror = reject;
            }
        });
        const base = new (0, $aQPld.ImageSource)({
            resource: src,
            alphaMode: "premultiply-alpha-on-upload",
            resolution: asset.data?.resolution || (0, $e80R6.getResolutionOfUrl)(url),
            ...asset.data
        });
        return (0, $jAkJt.createTexture)(base, loader, url);
    },
    unload (texture) {
        texture.destroy(true);
    }
};

});
parcelRegister("1nTSS", function(module, exports) {

$parcel$export(module.exports, "WorkerManager", () => $778464c1601fd395$export$bcff6015853c67ce);

var $l4P2n = parcelRequire("l4P2n");

var $55Igy = parcelRequire("55Igy");
"use strict";
let $778464c1601fd395$var$UUID = 0;
let $778464c1601fd395$var$MAX_WORKERS;
class $778464c1601fd395$var$WorkerManagerClass {
    constructor(){
        /** Whether the worker manager has been initialized */ this._initialized = false;
        /** Current number of created workers (used to enforce MAX_WORKERS limit) */ this._createdWorkers = 0;
        this._workerPool = [];
        this._queue = [];
        this._resolveHash = {};
    }
    /**
   * Checks if ImageBitmap is supported in the current environment.
   *
   * This method uses a dedicated worker to test ImageBitmap support
   * and caches the result for subsequent calls.
   * @returns Promise that resolves to true if ImageBitmap is supported, false otherwise
   */ isImageBitmapSupported() {
        if (this._isImageBitmapSupported !== void 0) return this._isImageBitmapSupported;
        this._isImageBitmapSupported = new Promise((resolve)=>{
            const { worker: worker } = new (0, $l4P2n.default)();
            worker.addEventListener("message", (event)=>{
                worker.terminate();
                (0, $l4P2n.default).revokeObjectURL();
                resolve(event.data);
            });
        });
        return this._isImageBitmapSupported;
    }
    /**
   * Loads an image as an ImageBitmap using a web worker.
   * @param src - The source URL or path of the image to load
   * @param asset - Optional resolved asset containing additional texture source options
   * @returns Promise that resolves to the loaded ImageBitmap
   * @example
   * ```typescript
   * const bitmap = await WorkerManager.loadImageBitmap('image.png');
   * const bitmapWithOptions = await WorkerManager.loadImageBitmap('image.png', asset);
   * ```
   */ loadImageBitmap(src, asset) {
        return this._run("loadImageBitmap", [
            src,
            asset?.data?.alphaMode
        ]);
    }
    /**
   * Initializes the worker pool if not already initialized.
   * Currently a no-op but reserved for future initialization logic.
   */ async _initWorkers() {
        if (this._initialized) return;
        this._initialized = true;
    }
    /**
   * Gets an available worker from the pool or creates a new one if needed.
   *
   * Workers are created up to the MAX_WORKERS limit (based on navigator.hardwareConcurrency).
   * Each worker is configured with a message handler for processing results.
   * @returns Available worker or undefined if pool is at capacity and no workers are free
   */ _getWorker() {
        if ($778464c1601fd395$var$MAX_WORKERS === void 0) $778464c1601fd395$var$MAX_WORKERS = navigator.hardwareConcurrency || 4;
        let worker = this._workerPool.pop();
        if (!worker && this._createdWorkers < $778464c1601fd395$var$MAX_WORKERS) {
            this._createdWorkers++;
            worker = new (0, $55Igy.default)().worker;
            worker.addEventListener("message", (event)=>{
                this._complete(event.data);
                this._returnWorker(event.target);
                this._next();
            });
        }
        return worker;
    }
    /**
   * Returns a worker to the pool after completing a task.
   * @param worker - The worker to return to the pool
   */ _returnWorker(worker) {
        this._workerPool.push(worker);
    }
    /**
   * Handles completion of a worker task by resolving or rejecting the corresponding promise.
   * @param data - Result data from the worker containing uuid, data, and optional error
   */ _complete(data) {
        if (data.error !== void 0) this._resolveHash[data.uuid].reject(data.error);
        else this._resolveHash[data.uuid].resolve(data.data);
        this._resolveHash[data.uuid] = null;
    }
    /**
   * Executes a task using the worker pool system.
   *
   * Queues the task and processes it when a worker becomes available.
   * @param id - Identifier for the type of task to run
   * @param args - Arguments to pass to the worker
   * @returns Promise that resolves with the worker's result
   */ async _run(id, args) {
        await this._initWorkers();
        const promise = new Promise((resolve, reject)=>{
            this._queue.push({
                id: id,
                arguments: args,
                resolve: resolve,
                reject: reject
            });
        });
        this._next();
        return promise;
    }
    /**
   * Processes the next item in the queue if workers are available.
   *
   * This method is called after worker initialization and when workers
   * complete tasks to continue processing the queue.
   */ _next() {
        if (!this._queue.length) return;
        const worker = this._getWorker();
        if (!worker) return;
        const toDo = this._queue.pop();
        const id = toDo.id;
        this._resolveHash[$778464c1601fd395$var$UUID] = {
            resolve: toDo.resolve,
            reject: toDo.reject
        };
        worker.postMessage({
            data: toDo.arguments,
            uuid: $778464c1601fd395$var$UUID++,
            id: id
        });
    }
    /**
   * Resets the worker manager, terminating all workers and clearing the queue.
   *
   * This method:
   * - Terminates all active workers
   * - Rejects all pending promises with an error
   * - Clears all internal state
   * - Resets initialization flags
   *
   * This should be called when the worker manager is no longer needed
   * to prevent memory leaks and ensure proper cleanup.
   * @example
   * ```typescript
   * // Clean up when shutting down
   * WorkerManager.reset();
   * ```
   */ reset() {
        this._workerPool.forEach((worker)=>worker.terminate());
        this._workerPool.length = 0;
        Object.values(this._resolveHash).forEach(({ reject: reject })=>{
            reject?.(new Error("WorkerManager destroyed"));
        });
        this._resolveHash = {};
        this._queue.length = 0;
        this._initialized = false;
        this._createdWorkers = 0;
    }
}
const $778464c1601fd395$export$bcff6015853c67ce = new $778464c1601fd395$var$WorkerManagerClass();

});
parcelRegister("l4P2n", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a21140edc3f77d8$export$2e2bcd8739ae039);
const $9a21140edc3f77d8$var$WORKER_CODE = "(function () {\n    'use strict';\n\n    const WHITE_PNG = \"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=\";\n    async function checkImageBitmap() {\n      try {\n        if (typeof createImageBitmap !== \"function\")\n          return false;\n        const response = await fetch(WHITE_PNG);\n        const imageBlob = await response.blob();\n        const imageBitmap = await createImageBitmap(imageBlob);\n        return imageBitmap.width === 1 && imageBitmap.height === 1;\n      } catch (_e) {\n        return false;\n      }\n    }\n    void checkImageBitmap().then((result) => {\n      self.postMessage(result);\n    });\n\n})();\n";
let $9a21140edc3f77d8$var$WORKER_URL = null;
class $9a21140edc3f77d8$export$2e2bcd8739ae039 {
    constructor(){
        if (!$9a21140edc3f77d8$var$WORKER_URL) $9a21140edc3f77d8$var$WORKER_URL = URL.createObjectURL(new Blob([
            $9a21140edc3f77d8$var$WORKER_CODE
        ], {
            type: 'application/javascript'
        }));
        this.worker = new Worker($9a21140edc3f77d8$var$WORKER_URL);
    }
}
$9a21140edc3f77d8$export$2e2bcd8739ae039.revokeObjectURL = function revokeObjectURL() {
    if ($9a21140edc3f77d8$var$WORKER_URL) {
        URL.revokeObjectURL($9a21140edc3f77d8$var$WORKER_URL);
        $9a21140edc3f77d8$var$WORKER_URL = null;
    }
};

});

parcelRegister("55Igy", function(module, exports) {

$parcel$export(module.exports, "default", () => $361d1ede8b4541ed$export$2e2bcd8739ae039);
const $361d1ede8b4541ed$var$WORKER_CODE = "(function () {\n    'use strict';\n\n    async function loadImageBitmap(url, alphaMode) {\n      const response = await fetch(url);\n      if (!response.ok) {\n        throw new Error(`[WorkerManager.loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);\n      }\n      const imageBlob = await response.blob();\n      return alphaMode === \"premultiplied-alpha\" ? createImageBitmap(imageBlob, { premultiplyAlpha: \"none\" }) : createImageBitmap(imageBlob);\n    }\n    self.onmessage = async (event) => {\n      try {\n        const imageBitmap = await loadImageBitmap(event.data.data[0], event.data.data[1]);\n        self.postMessage({\n          data: imageBitmap,\n          uuid: event.data.uuid,\n          id: event.data.id\n        }, [imageBitmap]);\n      } catch (e) {\n        self.postMessage({\n          error: e,\n          uuid: event.data.uuid,\n          id: event.data.id\n        });\n      }\n    };\n\n})();\n";
let $361d1ede8b4541ed$var$WORKER_URL = null;
class $361d1ede8b4541ed$export$2e2bcd8739ae039 {
    constructor(){
        if (!$361d1ede8b4541ed$var$WORKER_URL) $361d1ede8b4541ed$var$WORKER_URL = URL.createObjectURL(new Blob([
            $361d1ede8b4541ed$var$WORKER_CODE
        ], {
            type: 'application/javascript'
        }));
        this.worker = new Worker($361d1ede8b4541ed$var$WORKER_URL);
    }
}
$361d1ede8b4541ed$export$2e2bcd8739ae039.revokeObjectURL = function revokeObjectURL() {
    if ($361d1ede8b4541ed$var$WORKER_URL) {
        URL.revokeObjectURL($361d1ede8b4541ed$var$WORKER_URL);
        $361d1ede8b4541ed$var$WORKER_URL = null;
    }
};

});



parcelRegister("qPdOe", function(module, exports) {

$parcel$export(module.exports, "loadVideoTextures", () => $170b999e73028fac$export$68fa0976ba667d63);

var $i9BKe = parcelRequire("i9BKe");

var $hNatJ = parcelRequire("hNatJ");

var $7blVu = parcelRequire("7blVu");

var $e80R6 = parcelRequire("e80R6");

var $eSIgD = parcelRequire("eSIgD");

var $lXxYk = parcelRequire("lXxYk");

var $dofl4 = parcelRequire("dofl4");

var $jAkJt = parcelRequire("jAkJt");
"use strict";
const $170b999e73028fac$var$potentialVideoExtensions = [
    ".mp4",
    ".m4v",
    ".webm",
    ".ogg",
    ".ogv",
    ".h264",
    ".avi",
    ".mov"
];
let $170b999e73028fac$var$validVideoExtensions;
let $170b999e73028fac$var$validVideoMIMEs;
function $170b999e73028fac$export$c47cb7c63271266e(element, url, crossorigin) {
    if (crossorigin === void 0 && !url.startsWith("data:")) element.crossOrigin = $170b999e73028fac$export$292083da55c5b406(url);
    else if (crossorigin !== false) element.crossOrigin = typeof crossorigin === "string" ? crossorigin : "anonymous";
}
function $170b999e73028fac$export$856bfbe81968ff62(element) {
    return new Promise((resolve, reject)=>{
        element.addEventListener("canplaythrough", loaded);
        element.addEventListener("error", error);
        element.load();
        function loaded() {
            cleanup();
            resolve();
        }
        function error(err) {
            cleanup();
            reject(err);
        }
        function cleanup() {
            element.removeEventListener("canplaythrough", loaded);
            element.removeEventListener("error", error);
        }
    });
}
function $170b999e73028fac$export$292083da55c5b406(url, loc = globalThis.location) {
    if (url.startsWith("data:")) return "";
    loc || (loc = globalThis.location);
    const parsedUrl = new URL(url, document.baseURI);
    if (parsedUrl.hostname !== loc.hostname || parsedUrl.port !== loc.port || parsedUrl.protocol !== loc.protocol) return "anonymous";
    return "";
}
function $170b999e73028fac$var$getBrowserSupportedVideoExtensions() {
    const supportedExtensions = [];
    const supportedMimes = [];
    for (const ext of $170b999e73028fac$var$potentialVideoExtensions){
        const mimeType = (0, $hNatJ.VideoSource).MIME_TYPES[ext.substring(1)] || `video/${ext.substring(1)}`;
        if ((0, $eSIgD.testVideoFormat)(mimeType)) {
            supportedExtensions.push(ext);
            if (!supportedMimes.includes(mimeType)) supportedMimes.push(mimeType);
        }
    }
    return {
        validVideoExtensions: supportedExtensions,
        validVideoMime: supportedMimes
    };
}
const $170b999e73028fac$export$68fa0976ba667d63 = {
    /** used for deprecation purposes */ name: "loadVideo",
    id: "video",
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        name: "loadVideo"
    },
    test (url) {
        if (!$170b999e73028fac$var$validVideoExtensions || !$170b999e73028fac$var$validVideoMIMEs) {
            const { validVideoExtensions: ve, validVideoMime: vm } = $170b999e73028fac$var$getBrowserSupportedVideoExtensions();
            $170b999e73028fac$var$validVideoExtensions = ve;
            $170b999e73028fac$var$validVideoMIMEs = vm;
        }
        const isValidDataUrl = (0, $lXxYk.checkDataUrl)(url, $170b999e73028fac$var$validVideoMIMEs);
        const isValidExtension = (0, $dofl4.checkExtension)(url, $170b999e73028fac$var$validVideoExtensions);
        return isValidDataUrl || isValidExtension;
    },
    async load (url, asset, loader) {
        const options = {
            ...(0, $hNatJ.VideoSource).defaultOptions,
            resolution: asset.data?.resolution || (0, $e80R6.getResolutionOfUrl)(url),
            alphaMode: asset.data?.alphaMode || await (0, $7blVu.detectVideoAlphaMode)(),
            ...asset.data
        };
        const videoElement = document.createElement("video");
        const attributeMap = {
            preload: options.autoLoad !== false ? "auto" : void 0,
            "webkit-playsinline": options.playsinline !== false ? "" : void 0,
            playsinline: options.playsinline !== false ? "" : void 0,
            muted: options.muted === true ? "" : void 0,
            loop: options.loop === true ? "" : void 0,
            autoplay: options.autoPlay !== false ? "" : void 0
        };
        Object.keys(attributeMap).forEach((key)=>{
            const value = attributeMap[key];
            if (value !== void 0) videoElement.setAttribute(key, value);
        });
        if (options.muted === true) videoElement.muted = true;
        $170b999e73028fac$export$c47cb7c63271266e(videoElement, url, options.crossorigin);
        const sourceElement = document.createElement("source");
        let mime;
        if (options.mime) mime = options.mime;
        else if (url.startsWith("data:")) mime = url.slice(5, url.indexOf(";"));
        else if (!url.startsWith("blob:")) {
            const ext = url.split("?")[0].slice(url.lastIndexOf(".") + 1).toLowerCase();
            mime = (0, $hNatJ.VideoSource).MIME_TYPES[ext] || `video/${ext}`;
        }
        sourceElement.src = url;
        if (mime) sourceElement.type = mime;
        return new Promise((resolve)=>{
            const onCanPlay = async ()=>{
                const base = new (0, $hNatJ.VideoSource)({
                    ...options,
                    resource: videoElement
                });
                videoElement.removeEventListener("canplay", onCanPlay);
                if (asset.data.preload) await $170b999e73028fac$export$856bfbe81968ff62(videoElement);
                resolve((0, $jAkJt.createTexture)(base, loader, url));
            };
            if (options.preload && !options.autoPlay) videoElement.load();
            videoElement.addEventListener("canplay", onCanPlay);
            videoElement.appendChild(sourceElement);
        });
    },
    unload (texture) {
        texture.destroy(true);
    }
};

});

parcelRegister("iiAQE", function(module, exports) {

$parcel$export(module.exports, "resolveJsonUrl", () => $7c85897abf6bc2d6$export$2b5cca0b89cb089c);

var $i9BKe = parcelRequire("i9BKe");

var $8kCsw = parcelRequire("8kCsw");

var $7ESOd = parcelRequire("7ESOd");
"use strict";
const $7c85897abf6bc2d6$export$2b5cca0b89cb089c = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ResolveParser,
        priority: -2,
        name: "resolveJson"
    },
    test: (value)=>(0, $8kCsw.Resolver).RETINA_PREFIX.test(value) && value.endsWith(".json"),
    parse: (0, $7ESOd.resolveTextureUrl).parse
};

});
parcelRegister("7ESOd", function(module, exports) {

$parcel$export(module.exports, "resolveTextureUrl", () => $f9f0a4a658d5e519$export$cc356fa83de02bea);

var $i9BKe = parcelRequire("i9BKe");

var $ckjdh = parcelRequire("ckjdh");

var $8kCsw = parcelRequire("8kCsw");
"use strict";
const $f9f0a4a658d5e519$export$cc356fa83de02bea = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ResolveParser,
        name: "resolveTexture"
    },
    test: (0, $ckjdh.loadTextures).test,
    parse: (value)=>({
            resolution: parseFloat((0, $8kCsw.Resolver).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
            format: value.split(".").pop(),
            src: value
        })
};

});



parcelRegister("cm9HO", function(module, exports) {

$parcel$export(module.exports, "ColorMatrixFilter", () => $4b3be3ea887b7347$export$6547db23997fcec5);

var $a2eTA = parcelRequire("a2eTA");

var $fK92B = parcelRequire("fK92B");

var $6j7wq = parcelRequire("6j7wq");

var $cryyq = parcelRequire("cryyq");

var $9gqyK = parcelRequire("9gqyK");

var $hrcic = parcelRequire("hrcic");

var $eaNdK = parcelRequire("eaNdK");

var $bPY6g = parcelRequire("bPY6g");
"use strict";
class $4b3be3ea887b7347$export$6547db23997fcec5 extends (0, $9gqyK.Filter) {
    constructor(options = {}){
        const colorMatrixUniforms = new (0, $cryyq.UniformGroup)({
            uColorMatrix: {
                value: [
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0
                ],
                type: "f32",
                size: 20
            },
            uAlpha: {
                value: 1,
                type: "f32"
            }
        });
        const gpuProgram = (0, $6j7wq.GpuProgram).from({
            vertex: {
                source: $bPY6g.default,
                entryPoint: "mainVertex"
            },
            fragment: {
                source: $bPY6g.default,
                entryPoint: "mainFragment"
            }
        });
        const glProgram = (0, $fK92B.GlProgram).from({
            vertex: $hrcic.default,
            fragment: $eaNdK.default,
            name: "color-matrix-filter"
        });
        super({
            ...options,
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            resources: {
                colorMatrixUniforms: colorMatrixUniforms
            }
        });
        this.alpha = 1;
    }
    /**
   * Transforms current matrix and set the new one
   * @param {number[]} matrix - 5x4 matrix
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with matrix
   */ _loadMatrix(matrix, multiply = false) {
        let newMatrix = matrix;
        if (multiply) {
            this._multiply(newMatrix, this.matrix, matrix);
            newMatrix = this._colorMatrix(newMatrix);
        }
        this.resources.colorMatrixUniforms.uniforms.uColorMatrix = newMatrix;
        this.resources.colorMatrixUniforms.update();
    }
    /**
   * Multiplies two mat5's
   * @private
   * @param out - 5x4 matrix the receiving matrix
   * @param a - 5x4 matrix the first operand
   * @param b - 5x4 matrix the second operand
   * @returns {number[]} 5x4 matrix
   */ _multiply(out, a, b) {
        out[0] = a[0] * b[0] + a[1] * b[5] + a[2] * b[10] + a[3] * b[15];
        out[1] = a[0] * b[1] + a[1] * b[6] + a[2] * b[11] + a[3] * b[16];
        out[2] = a[0] * b[2] + a[1] * b[7] + a[2] * b[12] + a[3] * b[17];
        out[3] = a[0] * b[3] + a[1] * b[8] + a[2] * b[13] + a[3] * b[18];
        out[4] = a[0] * b[4] + a[1] * b[9] + a[2] * b[14] + a[3] * b[19] + a[4];
        out[5] = a[5] * b[0] + a[6] * b[5] + a[7] * b[10] + a[8] * b[15];
        out[6] = a[5] * b[1] + a[6] * b[6] + a[7] * b[11] + a[8] * b[16];
        out[7] = a[5] * b[2] + a[6] * b[7] + a[7] * b[12] + a[8] * b[17];
        out[8] = a[5] * b[3] + a[6] * b[8] + a[7] * b[13] + a[8] * b[18];
        out[9] = a[5] * b[4] + a[6] * b[9] + a[7] * b[14] + a[8] * b[19] + a[9];
        out[10] = a[10] * b[0] + a[11] * b[5] + a[12] * b[10] + a[13] * b[15];
        out[11] = a[10] * b[1] + a[11] * b[6] + a[12] * b[11] + a[13] * b[16];
        out[12] = a[10] * b[2] + a[11] * b[7] + a[12] * b[12] + a[13] * b[17];
        out[13] = a[10] * b[3] + a[11] * b[8] + a[12] * b[13] + a[13] * b[18];
        out[14] = a[10] * b[4] + a[11] * b[9] + a[12] * b[14] + a[13] * b[19] + a[14];
        out[15] = a[15] * b[0] + a[16] * b[5] + a[17] * b[10] + a[18] * b[15];
        out[16] = a[15] * b[1] + a[16] * b[6] + a[17] * b[11] + a[18] * b[16];
        out[17] = a[15] * b[2] + a[16] * b[7] + a[17] * b[12] + a[18] * b[17];
        out[18] = a[15] * b[3] + a[16] * b[8] + a[17] * b[13] + a[18] * b[18];
        out[19] = a[15] * b[4] + a[16] * b[9] + a[17] * b[14] + a[18] * b[19] + a[19];
        return out;
    }
    /**
   * Create a Float32 Array and normalize the offset component to 0-1
   * @param {number[]} matrix - 5x4 matrix
   * @returns {number[]} 5x4 matrix with all values between 0-1
   */ _colorMatrix(matrix) {
        const m = new Float32Array(matrix);
        m[4] /= 255;
        m[9] /= 255;
        m[14] /= 255;
        m[19] /= 255;
        return m;
    }
    /**
   * Adjusts the brightness of a display object.
   *
   * The brightness adjustment works by multiplying the RGB channels by a scalar value while keeping
   * the alpha channel unchanged. Values below 1 darken the image, while values above 1 brighten it.
   * @param b - The brightness multiplier to apply. Values between 0-1 darken the image (0 being black),
   *           while values > 1 brighten it (2.0 would make it twice as bright)
   * @param multiply - When true, the new matrix is multiplied with the current one instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * // Create a new color matrix filter
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Darken the image to 50% brightness
   * colorMatrix.brightness(0.5, false);
   *
   * // Chain with other effects by using multiply
   * colorMatrix
   *     .brightness(1.2, true)  // Brighten by 20%
   *     .saturate(1.1, true);   // Increase saturation by 10%
   * ```
   */ brightness(b, multiply) {
        const matrix = [
            b,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Sets each channel on the diagonal of the color matrix to apply a color tint.
   *
   * This method provides a way to tint display objects using the color matrix filter, similar to
   * the tint property available on Sprites and other display objects. The tint is applied by
   * scaling the RGB channels of each pixel.
   * @param color - The color to use for tinting, this can be any valid color source.
   * @param multiply - When true, the new tint matrix is multiplied with the current matrix instead
   *                  of replacing it. This allows for combining tints with other color effects.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply a red tint
   * colorMatrix.tint(0xff0000);
   *
   * // Layer a green tint on top of existing effects
   * colorMatrix.tint('green', true);
   *
   * // Chain with other color adjustments
   * colorMatrix
   *     .tint('blue')       // Blue tint
   *     .brightness(1.2, true) // Increase brightness
   * ```
   */ tint(color, multiply) {
        const [r, g, b] = (0, $a2eTA.Color).shared.setValue(color).toArray();
        const matrix = [
            r,
            0,
            0,
            0,
            0,
            0,
            g,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Converts the display object to greyscale by applying a weighted matrix transformation.
   *
   * The greyscale effect works by setting equal RGB values for each pixel based on the scale parameter,
   * effectively removing color information while preserving luminance.
   * @param scale - The intensity of the greyscale effect. Value between 0-1, where:
   *               - 0 produces black
   *               - 0.5 produces 50% grey
   *               - 1 produces white
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Convert to 50% grey
   * colorMatrix.greyscale(0.5, false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .greyscale(0.6, true)    // Add grey tint
   *     .brightness(1.2, true);   // Brighten the result
   * ```
   */ greyscale(scale, multiply) {
        const matrix = [
            scale,
            scale,
            scale,
            0,
            0,
            scale,
            scale,
            scale,
            0,
            0,
            scale,
            scale,
            scale,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Converts the display object to grayscale by applying a weighted matrix transformation.
   *
   * The grayscale effect works by setting equal RGB values for each pixel based on the scale parameter,
   * effectively removing color information while preserving luminance.
   * @param scale - The intensity of the grayscale effect. Value between 0-1, where:
   *               - 0 produces black
   *               - 0.5 produces 50% grey
   *               - 1 produces white
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Convert to 50% grey
   * colorMatrix.grayscale(0.5, false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .grayscale(0.6, true)    // Add grey tint
   *     .brightness(1.2, true);   // Brighten the result
   * ```
   */ grayscale(scale, multiply) {
        this.greyscale(scale, multiply);
    }
    /**
   * Converts the display object to pure black and white using a luminance-based threshold.
   *
   * This method applies a matrix transformation that removes all color information and reduces
   * the image to just black and white values based on the luminance of each pixel. The transformation
   * uses standard luminance weightings: 30% red, 60% green, and 10% blue.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Convert to black and white
   * colorMatrix.blackAndWhite(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .blackAndWhite(true)     // Apply B&W effect
   *     .brightness(1.2, true);   // Then increase brightness
   * ```
   */ blackAndWhite(multiply) {
        const matrix = [
            0.3,
            0.6,
            0.1,
            0,
            0,
            0.3,
            0.6,
            0.1,
            0,
            0,
            0.3,
            0.6,
            0.1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Adjusts the hue of the display object by rotating the color values around the color wheel.
   *
   * This method uses an optimized matrix transformation that accurately rotates the RGB color space
   * around its luminance axis. The implementation is based on RGB cube rotation in 3D space, providing
   * better results than traditional matrices with magic luminance constants.
   * @param rotation - The angle of rotation in degrees around the color wheel:
   *                  - 0 = no change
   *                  - 90 = rotate colors 90° clockwise
   *                  - 180 = invert all colors
   *                  - 270 = rotate colors 90° counter-clockwise
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Rotate hue by 90 degrees
   * colorMatrix.hue(90, false);
   *
   * // Chain multiple color adjustments
   * colorMatrix
   *     .hue(45, true)          // Rotate colors by 45°
   *     .saturate(1.2, true)    // Increase saturation
   *     .brightness(1.1, true); // Slightly brighten
   * ```
   */ hue(rotation, multiply) {
        rotation = (rotation || 0) / 180 * Math.PI;
        const cosR = Math.cos(rotation);
        const sinR = Math.sin(rotation);
        const sqrt = Math.sqrt;
        const w = 1 / 3;
        const sqrW = sqrt(w);
        const a00 = cosR + (1 - cosR) * w;
        const a01 = w * (1 - cosR) - sqrW * sinR;
        const a02 = w * (1 - cosR) + sqrW * sinR;
        const a10 = w * (1 - cosR) + sqrW * sinR;
        const a11 = cosR + w * (1 - cosR);
        const a12 = w * (1 - cosR) - sqrW * sinR;
        const a20 = w * (1 - cosR) - sqrW * sinR;
        const a21 = w * (1 - cosR) + sqrW * sinR;
        const a22 = cosR + w * (1 - cosR);
        const matrix = [
            a00,
            a01,
            a02,
            0,
            0,
            a10,
            a11,
            a12,
            0,
            0,
            a20,
            a21,
            a22,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Adjusts the contrast of the display object by modifying the separation between dark and bright values.
   *
   * This method applies a matrix transformation that affects the difference between dark and light areas
   * in the image. Increasing contrast makes shadows darker and highlights brighter, while decreasing
   * contrast brings shadows up and highlights down, reducing the overall dynamic range.
   * @param amount - The contrast adjustment value. Range is 0 to 1, where:
   *                - 0 represents minimum contrast (flat gray)
   *                - 0.5 represents normal contrast
   *                - 1 represents maximum contrast
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Increase contrast by 50%
   * colorMatrix.contrast(0.75, false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .contrast(0.6, true)     // Boost contrast
   *     .brightness(1.1, true)   // Slightly brighten
   *     .saturate(1.2, true);    // Increase color intensity
   * ```
   */ contrast(amount, multiply) {
        const v = (amount || 0) + 1;
        const o = -0.5 * (v - 1);
        const matrix = [
            v,
            0,
            0,
            0,
            o,
            0,
            v,
            0,
            0,
            o,
            0,
            0,
            v,
            0,
            o,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Adjusts the saturation of the display object by modifying color separation.
   *
   * This method applies a matrix transformation that affects the intensity of colors.
   * Increasing saturation makes colors more vivid and intense, while decreasing saturation
   * moves colors toward grayscale.
   * @param amount - The saturation adjustment value. Range is -1 to 1, where:
   *                - -1 produces grayscale
   *                - 0 represents no change
   *                - 1 produces maximum saturation
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Double the saturation
   * colorMatrix.saturate(1, false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .saturate(0.5, true)     // Increase saturation by 50%
   *     .brightness(1.1, true)    // Slightly brighten
   *     .contrast(0.8, true);     // Reduce contrast
   * ```
   */ saturate(amount = 0, multiply) {
        const x = amount * 2 / 3 + 1;
        const y = (x - 1) * -0.5;
        const matrix = [
            x,
            y,
            y,
            0,
            0,
            y,
            x,
            y,
            0,
            0,
            y,
            y,
            x,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Completely removes color information from the display object, creating a grayscale version.
   *
   * This is a convenience method that calls `saturate(-1)` internally. The transformation preserves
   * the luminance of the original image while removing all color information.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Convert image to grayscale
   * colorMatrix.desaturate();
   *
   * // Can be chained with other effects
   * colorMatrix
   *     .desaturate()         // Remove all color
   *     .brightness(1.2);     // Then increase brightness
   * ```
   */ desaturate() {
        this.saturate(-1);
    }
    /**
   * Creates a negative effect by inverting all colors in the display object.
   *
   * This method applies a matrix transformation that inverts the RGB values of each pixel
   * while preserving the alpha channel. The result is similar to a photographic negative.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Create negative effect
   * colorMatrix.negative(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .negative(true)       // Apply negative effect
   *     .brightness(1.2, true) // Increase brightness
   *     .contrast(0.8, true);  // Reduce contrast
   * ```
   */ negative(multiply) {
        const matrix = [
            -1,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            -1,
            1,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Applies a sepia tone effect to the display object, creating a warm brown tint reminiscent of vintage photographs.
   *
   * This method applies a matrix transformation that converts colors to various shades of brown while
   * preserving the original luminance values.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply sepia effect
   * colorMatrix.sepia(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .sepia(true)           // Add sepia tone
   *     .brightness(1.1, true)  // Slightly brighten
   *     .contrast(0.9, true);   // Reduce contrast
   * ```
   */ sepia(multiply) {
        const matrix = [
            0.393,
            0.7689999,
            0.18899999,
            0,
            0,
            0.349,
            0.6859999,
            0.16799999,
            0,
            0,
            0.272,
            0.5339999,
            0.13099999,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Applies a Technicolor-style effect that simulates the early color motion picture process.
   *
   * This method applies a matrix transformation that recreates the distinctive look of the
   * Technicolor process. The effect produces highly
   * saturated colors with a particular emphasis on reds, greens, and blues.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply Technicolor effect
   * colorMatrix.technicolor(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .technicolor(true)      // Add Technicolor effect
   *     .contrast(1.1, true)    // Boost contrast
   *     .brightness(0.9, true); // Slightly darken
   * ```
   */ technicolor(multiply) {
        const matrix = [
            1.9125277891456083,
            -0.8545344976951645,
            -0.09155508482755585,
            0,
            11.793603434377337,
            -0.3087833385928097,
            1.7658908555458428,
            -0.10601743074722245,
            0,
            -70.35205161461398,
            -0.231103377548616,
            -0.7501899197440212,
            1.847597816108189,
            0,
            30.950940869491138,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Applies a vintage Polaroid camera effect to the display object.
   *
   * This method applies a matrix transformation that simulates the distinctive look of
   * Polaroid instant photographs, characterized by slightly enhanced contrast, subtle color shifts,
   * and a warm overall tone.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply Polaroid effect
   * colorMatrix.polaroid(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .polaroid(true)         // Add Polaroid effect
   *     .brightness(1.1, true)  // Slightly brighten
   *     .contrast(1.1, true);   // Boost contrast
   * ```
   */ polaroid(multiply) {
        const matrix = [
            1.438,
            -0.062,
            -0.062,
            0,
            0,
            -0.122,
            1.378,
            -0.122,
            0,
            0,
            -0.016,
            -0.016,
            1.483,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Swaps the red and blue color channels in the display object.
   *
   * This method applies a matrix transformation that exchanges the red and blue color values
   * while keeping the green channel and alpha unchanged.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Swap red and blue channels
   * colorMatrix.toBGR(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .toBGR(true)           // Swap R and B channels
   *     .brightness(1.1, true)  // Slightly brighten
   *     .contrast(0.9, true);   // Reduce contrast
   * ```
   */ toBGR(multiply) {
        const matrix = [
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Applies a Kodachrome color effect that simulates the iconic film stock.
   *
   * This method applies a matrix transformation that recreates the distinctive look of Kodachrome film,
   * known for its rich, vibrant colors and excellent image preservation qualities. The effect emphasizes
   * reds and blues while producing deep, true blacks.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply Kodachrome effect
   * colorMatrix.kodachrome(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .kodachrome(true)       // Add Kodachrome effect
   *     .contrast(1.1, true)    // Boost contrast
   *     .brightness(0.9, true); // Slightly darken
   * ```
   */ kodachrome(multiply) {
        const matrix = [
            1.1285582396593525,
            -0.3967382283601348,
            -0.03992559172921793,
            0,
            63.72958762196502,
            -0.16404339962244616,
            1.0835251566291304,
            -0.05498805115633132,
            0,
            24.732407896706203,
            -0.16786010706155763,
            -0.5603416277695248,
            1.6014850761964943,
            0,
            35.62982807460946,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Applies a stylized brown-tinted effect to the display object.
   *
   * This method applies a matrix transformation that creates a rich, warm brown tone
   * with enhanced contrast and subtle color shifts.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply browni effect
   * colorMatrix.browni(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .browni(true)          // Add brown tint
   *     .brightness(1.1, true)  // Slightly brighten
   *     .contrast(1.2, true);   // Boost contrast
   * ```
   */ browni(multiply) {
        const matrix = [
            0.5997023498159715,
            0.34553243048391263,
            -0.2708298674538042,
            0,
            47.43192855600873,
            -0.037703249837783157,
            0.8609577587992641,
            0.15059552388459913,
            0,
            -36.96841498319127,
            0.24113635128153335,
            -0.07441037908422492,
            0.44972182064877153,
            0,
            -7.562075277591283,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Applies a vintage photo effect that simulates old photography techniques.
   *
   * This method applies a matrix transformation that creates a nostalgic, aged look
   * with muted colors, enhanced warmth, and subtle vignetting.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply vintage effect
   * colorMatrix.vintage(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .vintage(true)          // Add vintage look
   *     .brightness(0.9, true)  // Slightly darken
   *     .contrast(1.1, true);   // Boost contrast
   * ```
   */ vintage(multiply) {
        const matrix = [
            0.6279345635605994,
            0.3202183420819367,
            -0.03965408211312453,
            0,
            9.651285835294123,
            0.02578397704808868,
            0.6441188644374771,
            0.03259127616149294,
            0,
            7.462829176470591,
            0.0466055556782719,
            -0.0851232987247891,
            0.5241648018700465,
            0,
            5.159190588235296,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * We don't know exactly what it does, kind of gradient map, but funny to play with!
   * @param desaturation - Tone values.
   * @param toned - Tone values.
   * @param lightColor - Tone values, example: `0xFFE580`
   * @param darkColor - Tone values, example: `0xFFE580`
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with matrix
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Create sepia-like effect with custom colors
   * colorMatrix.colorTone(
   *     0.3,        // Moderate desaturation
   *     0.2,        // Moderate toning
   *     0xFFE580,   // Warm highlight color
   *     0x338000,   // Dark green shadows
   *     false
   * );
   *
   * // Chain with other effects
   * colorMatrix
   *     .colorTone(0.2, 0.15, 0xFFE580, 0x338000, true)
   *     .brightness(1.1, true);  // Slightly brighten
   * ```
   */ colorTone(desaturation, toned, lightColor, darkColor, multiply) {
        desaturation || (desaturation = 0.2);
        toned || (toned = 0.15);
        lightColor || (lightColor = 16770432);
        darkColor || (darkColor = 3375104);
        const temp = (0, $a2eTA.Color).shared;
        const [lR, lG, lB] = temp.setValue(lightColor).toArray();
        const [dR, dG, dB] = temp.setValue(darkColor).toArray();
        const matrix = [
            0.3,
            0.59,
            0.11,
            0,
            0,
            lR,
            lG,
            lB,
            desaturation,
            0,
            dR,
            dG,
            dB,
            toned,
            0,
            lR - dR,
            lG - dG,
            lB - dB,
            0,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Applies a night vision effect to the display object.
   *
   * This method applies a matrix transformation that simulates night vision by enhancing
   * certain color channels while suppressing others, creating a green-tinted effect
   * similar to night vision goggles.
   * @param intensity - The intensity of the night effect (0-1):
   *                   - 0 produces no effect
   *                   - 0.1 produces a subtle night vision effect (default)
   *                   - 1 produces maximum night vision effect
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply night vision effect
   * colorMatrix.night(0.3, false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .night(0.2, true)        // Add night vision
   *     .brightness(1.1, true)    // Slightly brighten
   *     .contrast(1.2, true);     // Boost contrast
   * ```
   */ night(intensity, multiply) {
        intensity || (intensity = 0.1);
        const matrix = [
            intensity * -2,
            -intensity,
            0,
            0,
            0,
            -intensity,
            0,
            intensity,
            0,
            0,
            0,
            intensity,
            intensity * 2,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Predator effect
   *
   * Erase the current matrix by setting a new independent one
   * @param amount - how much the predator feels his future victim
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with matrix
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply thermal vision effect
   * colorMatrix.predator(0.5, false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .predator(0.3, true)      // Add thermal effect
   *     .contrast(1.2, true)      // Boost contrast
   *     .brightness(1.1, true);   // Slightly brighten
   * ```
   */ predator(amount, multiply) {
        const matrix = [
            // row 1
            11.224130630493164 * amount,
            -4.794486999511719 * amount,
            -2.8746118545532227 * amount,
            0 * amount,
            0.40342438220977783 * amount,
            // row 2
            -3.6330697536468506 * amount,
            9.193157196044922 * amount,
            -2.951810836791992 * amount,
            0 * amount,
            -1.316135048866272 * amount,
            // row 3
            -3.2184197902679443 * amount,
            -4.2375030517578125 * amount,
            7.476448059082031 * amount,
            0 * amount,
            0.8044459223747253 * amount,
            // row 4
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Applies a psychedelic color effect that creates dramatic color shifts.
   *
   * This method applies a matrix transformation that produces vibrant colors
   * through channel mixing and amplification. Creates an effect reminiscent of
   * color distortions in psychedelic art.
   * @param multiply - When true, the new matrix is multiplied with the current matrix instead of replacing it.
   *                  This allows for cumulative effects when calling multiple color adjustments.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply psychedelic effect
   * colorMatrix.lsd(false);
   *
   * // Chain with other effects
   * colorMatrix
   *     .lsd(true)             // Add color distortion
   *     .brightness(0.9, true)  // Slightly darken
   *     .contrast(1.2, true);   // Boost contrast
   * ```
   */ lsd(multiply) {
        const matrix = [
            2,
            -0.4,
            0.5,
            0,
            0,
            -0.5,
            2,
            -0.4,
            0,
            0,
            -0.4,
            -0.5,
            3,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Resets the color matrix filter to its default state.
   *
   * This method resets all color transformations by setting the matrix back to its identity state.
   * The identity matrix leaves colors unchanged, effectively removing all previously applied effects.
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply some effects
   * colorMatrix
   *     .sepia(true)
   *     .brightness(1.2, true);
   *
   * // Reset back to original colors
   * colorMatrix.reset();
   * ```
   */ reset() {
        const matrix = [
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, false);
    }
    /**
   * The current color transformation matrix of the filter.
   *
   * This 5x4 matrix transforms RGBA color and alpha values of each pixel. The matrix is stored
   * as a 20-element array in row-major order.
   * @type {ColorMatrix}
   * @default [
   *     1, 0, 0, 0, 0,  // Red channel
   *     0, 1, 0, 0, 0,  // Green channel
   *     0, 0, 1, 0, 0,  // Blue channel
   *     0, 0, 0, 1, 0   // Alpha channel
   * ]
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   * // Get the current color matrix
   * const currentMatrix = colorMatrix.matrix;
   * // Modify the matrix
   * colorMatrix.matrix = [
   *     1, 0, 0, 0, 0,
   *     0, 1, 0, 0, 0,
   *     0, 0, 1, 0, 0,
   *     0, 0, 0, 1, 0
   * ];
   */ get matrix() {
        return this.resources.colorMatrixUniforms.uniforms.uColorMatrix;
    }
    set matrix(value) {
        this.resources.colorMatrixUniforms.uniforms.uColorMatrix = value;
    }
    /**
   * The opacity value used to blend between the original and transformed colors.
   *
   * This value controls how much of the color transformation is applied:
   * - 0 = Original color only (no effect)
   * - 0.5 = 50% blend of original and transformed colors
   * - 1 = Fully transformed color (default)
   * @default 1
   * @example
   * ```ts
   * const colorMatrix = new ColorMatrixFilter();
   *
   * // Apply sepia at 50% strength
   * colorMatrix.sepia(false);
   * colorMatrix.alpha = 0.5;
   *
   * // Fade between effects
   * colorMatrix
   *     .saturate(1.5)      // Increase saturation
   *     .contrast(1.2);     // Boost contrast
   * colorMatrix.alpha = 0.7; // Apply at 70% strength
   * ```
   */ get alpha() {
        return this.resources.colorMatrixUniforms.uniforms.uAlpha;
    }
    set alpha(value) {
        this.resources.colorMatrixUniforms.uniforms.uAlpha = value;
    }
}

});
parcelRegister("hrcic", function(module, exports) {

$parcel$export(module.exports, "default", () => $db2f89c5ab2c7b82$export$2e2bcd8739ae039);
var $db2f89c5ab2c7b82$export$2e2bcd8739ae039 = "in vec2 aPosition;\nout vec2 vTextureCoord;\n\nuniform vec4 uInputSize;\nuniform vec4 uOutputFrame;\nuniform vec4 uOutputTexture;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;\n    \n    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aPosition * (uOutputFrame.zw * uInputSize.zw);\n}\n\nvoid main(void)\n{\n    gl_Position = filterVertexPosition();\n    vTextureCoord = filterTextureCoord();\n}\n";

});

parcelRegister("eaNdK", function(module, exports) {

$parcel$export(module.exports, "default", () => $13c3f6a23aee145b$export$2e2bcd8739ae039);
var $13c3f6a23aee145b$export$2e2bcd8739ae039 = "\nin vec2 vTextureCoord;\nin vec4 vColor;\n\nout vec4 finalColor;\n\nuniform float uColorMatrix[20];\nuniform float uAlpha;\n\nuniform sampler2D uTexture;\n\nfloat rand(vec2 co)\n{\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nvoid main()\n{\n    vec4 color = texture(uTexture, vTextureCoord);\n    float randomValue = rand(gl_FragCoord.xy * 0.2);\n    float diff = (randomValue - 0.5) *  0.5;\n\n    if (uAlpha == 0.0) {\n        finalColor = color;\n        return;\n    }\n\n    if (color.a > 0.0) {\n        color.rgb /= color.a;\n    }\n\n    vec4 result;\n\n    result.r = (uColorMatrix[0] * color.r);\n        result.r += (uColorMatrix[1] * color.g);\n        result.r += (uColorMatrix[2] * color.b);\n        result.r += (uColorMatrix[3] * color.a);\n        result.r += uColorMatrix[4];\n\n    result.g = (uColorMatrix[5] * color.r);\n        result.g += (uColorMatrix[6] * color.g);\n        result.g += (uColorMatrix[7] * color.b);\n        result.g += (uColorMatrix[8] * color.a);\n        result.g += uColorMatrix[9];\n\n    result.b = (uColorMatrix[10] * color.r);\n       result.b += (uColorMatrix[11] * color.g);\n       result.b += (uColorMatrix[12] * color.b);\n       result.b += (uColorMatrix[13] * color.a);\n       result.b += uColorMatrix[14];\n\n    result.a = (uColorMatrix[15] * color.r);\n       result.a += (uColorMatrix[16] * color.g);\n       result.a += (uColorMatrix[17] * color.b);\n       result.a += (uColorMatrix[18] * color.a);\n       result.a += uColorMatrix[19];\n\n    vec3 rgb = mix(color.rgb, result.rgb, uAlpha);\n\n    // Premultiply alpha again.\n    rgb *= result.a;\n\n    finalColor = vec4(rgb, result.a);\n}\n";

});

parcelRegister("bPY6g", function(module, exports) {

$parcel$export(module.exports, "default", () => $3107b35e098f2d50$export$2e2bcd8739ae039);
var $3107b35e098f2d50$export$2e2bcd8739ae039 = "struct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\nstruct ColorMatrixUniforms {\n  uColorMatrix:array<vec4<f32>, 5>,\n  uAlpha:f32,\n};\n\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n@group(0) @binding(1) var uTexture: texture_2d<f32>;\n@group(0) @binding(2) var uSampler : sampler;\n@group(1) @binding(0) var<uniform> colorMatrixUniforms : ColorMatrixUniforms;\n\n\nstruct VSOutput {\n    @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>,\n  };\n  \nfn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>\n{\n    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;\n\n    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nfn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n  return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);\n}\n\n@vertex\nfn mainVertex(\n  @location(0) aPosition : vec2<f32>, \n) -> VSOutput {\n  return VSOutput(\n   filterVertexPosition(aPosition),\n   filterTextureCoord(aPosition),\n  );\n}\n\n\n@fragment\nfn mainFragment(\n  @location(0) uv: vec2<f32>,\n) -> @location(0) vec4<f32> {\n\n\n  var c = textureSample(uTexture, uSampler, uv);\n  \n  if (colorMatrixUniforms.uAlpha == 0.0) {\n    return c;\n  }\n\n \n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (c.a > 0.0) {\n      c.r /= c.a;\n      c.g /= c.a;\n      c.b /= c.a;\n    }\n\n    var cm = colorMatrixUniforms.uColorMatrix;\n\n\n    var result = vec4<f32>(0.);\n\n    result.r = (cm[0][0] * c.r);\n    result.r += (cm[0][1] * c.g);\n    result.r += (cm[0][2] * c.b);\n    result.r += (cm[0][3] * c.a);\n    result.r += cm[1][0];\n\n    result.g = (cm[1][1] * c.r);\n    result.g += (cm[1][2] * c.g);\n    result.g += (cm[1][3] * c.b);\n    result.g += (cm[2][0] * c.a);\n    result.g += cm[2][1];\n\n    result.b = (cm[2][2] * c.r);\n    result.b += (cm[2][3] * c.g);\n    result.b += (cm[3][0] * c.b);\n    result.b += (cm[3][1] * c.a);\n    result.b += cm[3][2];\n\n    result.a = (cm[3][3] * c.r);\n    result.a += (cm[4][0] * c.g);\n    result.a += (cm[4][1] * c.b);\n    result.a += (cm[4][2] * c.a);\n    result.a += cm[4][3];\n\n    var rgb = mix(c.rgb, result.rgb, colorMatrixUniforms.uAlpha);\n\n    rgb.r *= result.a;\n    rgb.g *= result.a;\n    rgb.b *= result.a;\n\n    return vec4(rgb, result.a);\n}";

});


parcelRegister("djRgo", function(module, exports) {

$parcel$export(module.exports, "NineSliceSprite", () => $e9e4a9e44b3c9d74$export$ea7c4e309714d712);

var $a32F4 = parcelRequire("a32F4");

var $bLlTJ = parcelRequire("bLlTJ");

var $kXq8E = parcelRequire("kXq8E");

var $b9FQU = parcelRequire("b9FQU");

var $hIpDK = parcelRequire("hIpDK");
"use strict";
const $e9e4a9e44b3c9d74$var$_NineSliceSprite = class _NineSliceSprite extends (0, $b9FQU.ViewContainer) {
    constructor(options){
        if (options instanceof (0, $bLlTJ.Texture)) options = {
            texture: options
        };
        const { width: width, height: height, anchor: anchor, leftWidth: leftWidth, rightWidth: rightWidth, topHeight: topHeight, bottomHeight: bottomHeight, texture: texture, roundPixels: roundPixels, ...rest } = options;
        super({
            label: "NineSliceSprite",
            ...rest
        });
        /** @internal */ this.renderPipeId = "nineSliceSprite";
        /** @internal */ this.batched = true;
        this._leftWidth = leftWidth ?? texture?.defaultBorders?.left ?? (0, $hIpDK.NineSliceGeometry).defaultOptions.leftWidth;
        this._topHeight = topHeight ?? texture?.defaultBorders?.top ?? (0, $hIpDK.NineSliceGeometry).defaultOptions.topHeight;
        this._rightWidth = rightWidth ?? texture?.defaultBorders?.right ?? (0, $hIpDK.NineSliceGeometry).defaultOptions.rightWidth;
        this._bottomHeight = bottomHeight ?? texture?.defaultBorders?.bottom ?? (0, $hIpDK.NineSliceGeometry).defaultOptions.bottomHeight;
        this._width = width ?? texture.width ?? (0, $hIpDK.NineSliceGeometry).defaultOptions.width;
        this._height = height ?? texture.height ?? (0, $hIpDK.NineSliceGeometry).defaultOptions.height;
        this.allowChildren = false;
        this.texture = texture ?? _NineSliceSprite.defaultOptions.texture;
        this.roundPixels = roundPixels ?? false;
        this._anchor = new (0, $a32F4.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        if (anchor) this.anchor = anchor;
        else if (this.texture.defaultAnchor) this.anchor = this.texture.defaultAnchor;
    }
    /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * - The default is `(0,0)`, this means the sprite's origin is the top left.
   * - Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   * - Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * ```ts
   * // Center the anchor point
   * sprite.anchor = 0.5; // Sets both x and y to 0.5
   * sprite.position.set(400, 300); // Sprite will be centered at this position
   *
   * // Set specific x/y anchor points
   * sprite.anchor = {
   *     x: 1, // Right edge
   *     y: 0  // Top edge
   * };
   *
   * // Using individual coordinates
   * sprite.anchor.set(0.5, 1); // Center-bottom
   *
   * // For rotation around center
   * sprite.anchor.set(0.5);
   * sprite.rotation = Math.PI / 4; // 45 degrees around center
   *
   * // For scaling from center
   * sprite.anchor.set(0.5);
   * sprite.scale.set(2); // Scales from center point
   * ```
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   * The width of the NineSliceSprite, setting this will actually modify the vertices and UV's of this plane.
   * The width affects how the middle sections are scaled.
   * @example
   * ```ts
   * // Create a nine-slice sprite with fixed width
   * const panel = new NineSliceSprite({
   *     texture: Texture.from('panel.png'),
   *     width: 200  // Sets initial width
   * });
   *
   * // Adjust width dynamically
   * panel.width = 300;  // Stretches middle sections
   * ```
   * @see {@link NineSliceSprite#setSize} For setting both width and height efficiently
   * @see {@link NineSliceSprite#height} For setting height
   */ get width() {
        return this._width;
    }
    set width(value) {
        this._width = value;
        this.onViewUpdate();
    }
    /**
   * The height of the NineSliceSprite, setting this will actually modify the vertices and UV's of this plane.
   * The height affects how the middle sections are scaled.
   * @example
   * ```ts
   * // Create a nine-slice sprite with fixed height
   * const panel = new NineSliceSprite({
   *     texture: Texture.from('panel.png'),
   *     height: 150  // Sets initial height
   * });
   *
   * // Adjust height dynamically
   * panel.height = 200;  // Stretches middle sections
   *
   * // Create responsive UI element
   * const dialog = new NineSliceSprite({
   *     texture: Texture.from('dialog.png'),
   *     topHeight: 30,
   *     bottomHeight: 30,
   *     height: parent.height * 0.5  // 50% of parent height
   * });
   * ```
   * @see {@link NineSliceSprite#setSize} For setting both width and height efficiently
   * @see {@link NineSliceSprite#width} For setting width
   */ get height() {
        return this._height;
    }
    set height(value) {
        this._height = value;
        this.onViewUpdate();
    }
    /**
   * Sets the size of the NineSliceSprite to the specified width and height.
   * This method directly modifies the vertices and UV coordinates of the sprite.
   *
   * Using this is more efficient than setting width and height separately as it only triggers one update.
   * @example
   * ```ts
   * // Set to specific dimensions
   * panel.setSize(300, 200); // Width: 300, Height: 200
   *
   * // Set uniform size
   * panel.setSize(200); // Makes a square 200x200
   *
   * // Set size using object
   * panel.setSize({
   *     width: 400,
   *     height: 300
   * });
   * ```
   * @param value - This can be either a number or a Size object with width/height properties
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link NineSliceSprite#width} For setting width only
   * @see {@link NineSliceSprite#height} For setting height only
   */ setSize(value, height) {
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        }
        this._width = value;
        this._height = height ?? value;
        this.onViewUpdate();
    }
    /**
   * Retrieves the size of the NineSliceSprite as a [Size]{@link Size} object.
   * This method is more efficient than getting width and height separately.
   * @example
   * ```ts
   * // Get basic size
   * const size = panel.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * panel.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the NineSliceSprite
   * @see {@link NineSliceSprite#width} For getting just the width
   * @see {@link NineSliceSprite#height} For getting just the height
   * @see {@link NineSliceSprite#setSize} For setting both width and height efficiently
   */ getSize(out) {
        out || (out = {});
        out.width = this._width;
        out.height = this._height;
        return out;
    }
    /**
   * Width of the left vertical bar (A).
   * Controls the size of the left edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., leftWidth: 20 });
   * sprite.leftWidth = 20; // Set left border width
   * ```
   * @default 10
   */ get leftWidth() {
        return this._leftWidth;
    }
    set leftWidth(value) {
        this._leftWidth = value;
        this.onViewUpdate();
    }
    /**
   * Height of the top horizontal bar (C).
   * Controls the size of the top edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., topHeight: 20 });
   * sprite.topHeight = 20; // Set top border height
   * ```
   * @default 10
   */ get topHeight() {
        return this._topHeight;
    }
    set topHeight(value) {
        this._topHeight = value;
        this.onViewUpdate();
    }
    /**
   * Width of the right vertical bar (B).
   * Controls the size of the right edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., rightWidth: 20 });
   * sprite.rightWidth = 20; // Set right border width
   * ```
   * @default 10
   */ get rightWidth() {
        return this._rightWidth;
    }
    set rightWidth(value) {
        this._rightWidth = value;
        this.onViewUpdate();
    }
    /**
   * Height of the bottom horizontal bar (D).
   * Controls the size of the bottom edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., bottomHeight: 20 });
   * sprite.bottomHeight = 20; // Set bottom border height
   * ```
   * @default 10
   */ get bottomHeight() {
        return this._bottomHeight;
    }
    set bottomHeight(value) {
        this._bottomHeight = value;
        this.onViewUpdate();
    }
    /**
   * The texture to use on the NineSliceSprite.
   * ```ts
   * // Create a sprite with a texture
   * const sprite = new NineSliceSprite({
   *     texture: Texture.from('path/to/image.png')
   * });
   * // Update the texture later
   * sprite.texture = Texture.from('path/to/another-image.png');
   * ```
   * @default Texture.EMPTY
   */ get texture() {
        return this._texture;
    }
    set texture(value) {
        value || (value = (0, $bLlTJ.Texture).EMPTY);
        const currentTexture = this._texture;
        if (currentTexture === value) return;
        if (currentTexture && currentTexture.dynamic) currentTexture.off("update", this.onViewUpdate, this);
        if (value.dynamic) value.on("update", this.onViewUpdate, this);
        this._texture = value;
        this.onViewUpdate();
    }
    /**
   * The original width of the texture before any nine-slice scaling.
   * This is the width of the source texture used to create the nine-slice sprite.
   * @example
   * ```ts
   * // Get original dimensions
   * console.log(`Original size: ${sprite.originalWidth}x${sprite.originalHeight}`);
   *
   * // Use for relative scaling
   * sprite.width = sprite.originalWidth * 2; // Double the original width
   *
   * // Reset to original size
   * sprite.setSize(sprite.originalWidth, sprite.originalHeight);
   * ```
   * @readonly
   * @see {@link NineSliceSprite#width} For the current displayed width
   * @see {@link Texture#width} For direct texture width access
   * @returns The original width of the texture
   */ get originalWidth() {
        return this._texture.width;
    }
    /**
   * The original height of the texture before any nine-slice scaling.
   * This is the height of the source texture used to create the nine-slice sprite.
   * @example
   * ```ts
   * // Get original dimensions
   * console.log(`Original size: ${sprite.originalWidth}x${sprite.originalHeight}`);
   *
   * // Use for relative scaling
   * sprite.height = sprite.originalHeight * 2; // Double the original height
   *
   * // Reset to original size
   * sprite.setSize(sprite.originalWidth, sprite.originalHeight);
   * ```
   * @readonly
   * @see {@link NineSliceSprite#height} For the current displayed height
   * @see {@link Texture#height} For direct texture height access
   * @returns The original height of the texture
   */ get originalHeight() {
        return this._texture.height;
    }
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * nineSliceSprite.destroy();
   * nineSliceSprite.destroy(true);
   * nineSliceSprite.destroy({ texture: true, textureSource: true });
   */ destroy(options) {
        super.destroy(options);
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            this._texture.destroy(destroyTextureSource);
        }
        this._texture = null;
    }
    /** @private */ updateBounds() {
        const bounds = this._bounds;
        const anchor = this._anchor;
        const width = this._width;
        const height = this._height;
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
};
/**
 * The default options used to override initial values of any options passed in the constructor.
 * These values are used as fallbacks when specific options are not provided.
 * @example
 * ```ts
 * // Override default options globally
 * NineSliceSprite.defaultOptions.texture = Texture.from('defaultButton.png');
 * // Create sprite with default texture
 * const sprite = new NineSliceSprite({...});
 * // sprite will use 'defaultButton.png' as its texture
 *
 * // Reset to empty texture
 * NineSliceSprite.defaultOptions.texture = Texture.EMPTY;
 * ```
 * @type {NineSliceSpriteOptions}
 * @see {@link NineSliceSpriteOptions} For all available options
 * @see {@link Texture#defaultBorders} For texture-level border settings
 */ $e9e4a9e44b3c9d74$var$_NineSliceSprite.defaultOptions = {
    /** @default Texture.EMPTY */ texture: (0, $bLlTJ.Texture).EMPTY
};
let $e9e4a9e44b3c9d74$export$ea7c4e309714d712 = $e9e4a9e44b3c9d74$var$_NineSliceSprite;
class $e9e4a9e44b3c9d74$export$acdf4cb3f489544e extends $e9e4a9e44b3c9d74$export$ea7c4e309714d712 {
    constructor(...args){
        let options = args[0];
        if (options instanceof (0, $bLlTJ.Texture)) {
            (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "NineSlicePlane now uses the options object {texture, leftWidth, rightWidth, topHeight, bottomHeight}");
            options = {
                texture: options,
                leftWidth: args[1],
                topHeight: args[2],
                rightWidth: args[3],
                bottomHeight: args[4]
            };
        }
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "NineSlicePlane is deprecated. Use NineSliceSprite instead.");
        super(options);
    }
}

});

parcelRegister("gc0ip", function(module, exports) {

$parcel$export(module.exports, "Text", () => $dd84afd4ef9f1e09$export$5f1af8db9871e1d6);

var $aFPUT = parcelRequire("aFPUT");

var $j9OVc = parcelRequire("j9OVc");

var $f9zuU = parcelRequire("f9zuU");

var $wLFHs = parcelRequire("wLFHs");

var $eKNW7 = parcelRequire("eKNW7");
"use strict";
class $dd84afd4ef9f1e09$export$5f1af8db9871e1d6 extends (0, $j9OVc.AbstractText) {
    constructor(...args){
        const options = (0, $j9OVc.ensureTextOptions)(args, "Text");
        super(options, (0, $eKNW7.TextStyle));
        /** @internal */ this.renderPipeId = "text";
        if (options.textureStyle) this.textureStyle = options.textureStyle instanceof (0, $aFPUT.TextureStyle) ? options.textureStyle : new (0, $aFPUT.TextureStyle)(options.textureStyle);
    }
    /** @private */ updateBounds() {
        const bounds = this._bounds;
        const anchor = this._anchor;
        let width = 0;
        let height = 0;
        if (this._style.trim) {
            const { frame: frame, canvasAndContext: canvasAndContext } = (0, $f9zuU.CanvasTextGenerator).getCanvasAndContext({
                text: this.text,
                style: this._style,
                resolution: 1
            });
            (0, $f9zuU.CanvasTextGenerator).returnCanvasAndContext(canvasAndContext);
            width = frame.width;
            height = frame.height;
        } else {
            const canvasMeasurement = (0, $wLFHs.CanvasTextMetrics).measureText(this._text, this._style);
            width = canvasMeasurement.width;
            height = canvasMeasurement.height;
        }
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
}

});
parcelRegister("j9OVc", function(module, exports) {

$parcel$export(module.exports, "AbstractText", () => $7e36113173fcb92e$export$daf74670712de91);
$parcel$export(module.exports, "ensureTextOptions", () => $7e36113173fcb92e$export$8ddfb4f614f8ed86);

var $a32F4 = parcelRequire("a32F4");

var $kXq8E = parcelRequire("kXq8E");

var $b9FQU = parcelRequire("b9FQU");
"use strict";
class $7e36113173fcb92e$export$daf74670712de91 extends (0, $b9FQU.ViewContainer) {
    constructor(options, styleClass){
        const { text: text, resolution: resolution, style: style, anchor: anchor, width: width, height: height, roundPixels: roundPixels, ...rest } = options;
        super({
            ...rest
        });
        /** @internal */ this.batched = true;
        /** @internal */ this._resolution = null;
        /** @internal */ this._autoResolution = true;
        /** @internal */ this._didTextUpdate = true;
        this._styleClass = styleClass;
        this.text = text ?? "";
        this.style = style;
        this.resolution = resolution ?? null;
        this.allowChildren = false;
        this._anchor = new (0, $a32F4.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        if (anchor) this.anchor = anchor;
        this.roundPixels = roundPixels ?? false;
        if (width !== void 0) this.width = width;
        if (height !== void 0) this.height = height;
    }
    /**
   * The anchor point of the text that controls the origin point for positioning and rotation.
   * Can be a number (same value for x/y) or a PointData object.
   * - (0,0) is top-left
   * - (0.5,0.5) is center
   * - (1,1) is bottom-right
   * ```ts
   * // Set anchor to center
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: 0.5 // Same as { x: 0.5, y: 0.5 }
   * });
   * // Set anchor to top-left
   * const text2 = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: { x: 0, y: 0 } // Top-left corner
   * });
   * // Set anchor to bottom-right
   * const text3 = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: { x: 1, y: 1 } // Bottom-right corner
   * });
   * ```
   * @default { x: 0, y: 0 }
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   * The text content to display. Use '\n' for line breaks.
   * Accepts strings, numbers, or objects with toString() method.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Hello Pixi!',
   * });
   * const multilineText = new Text({
   *     text: 'Line 1\nLine 2\nLine 3',
   * });
   * const numberText = new Text({
   *     text: 12345, // Will be converted to '12345'
   * });
   * const objectText = new Text({
   *     text: { toString: () => 'Object Text' }, // Custom toString
   * });
   *
   * // Update text dynamically
   * text.text = 'Updated Text'; // Re-renders with new text
   * text.text = 67890; // Updates to '67890'
   * text.text = { toString: () => 'Dynamic Text' }; // Uses custom toString method
   * // Clear text
   * text.text = ''; // Clears the text
   * ```
   * @default ''
   */ set text(value) {
        value = value.toString();
        if (this._text === value) return;
        this._text = value;
        this.onViewUpdate();
    }
    get text() {
        return this._text;
    }
    /**
   * The resolution/device pixel ratio for rendering.
   * Higher values result in sharper text at the cost of performance.
   * Set to null for auto-resolution based on device.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     resolution: 2 // High DPI for sharper text
   * });
   * const autoResText = new Text({
   *     text: 'Auto Resolution',
   *     resolution: null // Use device's pixel ratio
   * });
   * ```
   * @default null
   */ set resolution(value) {
        this._autoResolution = value === null;
        this._resolution = value;
        this.onViewUpdate();
    }
    get resolution() {
        return this._resolution;
    }
    get style() {
        return this._style;
    }
    /**
   * The style configuration for the text.
   * Can be a TextStyle instance or a configuration object.
   * Supports canvas text styles, HTML text styles, and bitmap text styles.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Styled Text',
   *     style: {
   *         fontSize: 24,
   *         fill: 0xff1010, // Red color
   *         fontFamily: 'Arial',
   *         align: 'center', // Center alignment
   *         stroke: { color: '#4a1850', width: 5 }, // Purple stroke
   *         dropShadow: {
   *             color: '#000000', // Black shadow
   *             blur: 4, // Shadow blur
   *             distance: 6 // Shadow distance
   *         }
   *     }
   * });
   * const htmlText = new HTMLText({
   *     text: 'HTML Styled Text',
   *     style: {
   *         fontSize: '20px',
   *         fill: 'blue',
   *         fontFamily: 'Verdana',
   *     }
   * });
   * const bitmapText = new BitmapText({
   *     text: 'Bitmap Styled Text',
   *     style: {
   *         fontName: 'Arial',
   *         fontSize: 32,
   *     }
   * })
   *
   * // Update style dynamically
   * text.style = {
   *     fontSize: 30, // Change font size
   *     fill: 0x00ff00, // Change color to green
   *     align: 'right', // Change alignment to right
   *     stroke: { color: '#000000', width: 2 }, // Add black stroke
   * }
   */ set style(style) {
        style || (style = {});
        this._style?.off("update", this.onViewUpdate, this);
        if (style instanceof this._styleClass) this._style = style;
        else this._style = new this._styleClass(style);
        this._style.on("update", this.onViewUpdate, this);
        this.onViewUpdate();
    }
    /**
   * The width of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set width directly
   * texture.width = 200;
   * console.log(texture.scale.x); // Scale adjusted to match width
   *
   * // For better performance when setting both width and height
   * texture.setSize(300, 400); // Avoids recalculating bounds twice
   * ```
   */ get width() {
        return Math.abs(this.scale.x) * this.bounds.width;
    }
    set width(value) {
        this._setWidth(value, this.bounds.width);
    }
    /**
   * The height of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set height directly
   * texture.height = 200;
   * console.log(texture.scale.y); // Scale adjusted to match height
   *
   * // For better performance when setting both width and height
   * texture.setSize(300, 400); // Avoids recalculating bounds twice
   * ```
   */ get height() {
        return Math.abs(this.scale.y) * this.bounds.height;
    }
    set height(value) {
        this._setHeight(value, this.bounds.height);
    }
    /**
   * Retrieves the size of the Text as a [Size]{@link Size} object based on the texture dimensions and scale.
   * This is faster than getting width and height separately as it only calculates the bounds once.
   * @example
   * ```ts
   * // Basic size retrieval
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     style: { fontSize: 24 }
   * });
   * const size = text.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * text.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the Sprite
   * @see {@link Text#width} For getting just the width
   * @see {@link Text#height} For getting just the height
   * @see {@link Text#setSize} For setting both width and height
   */ getSize(out) {
        out || (out = {});
        out.width = Math.abs(this.scale.x) * this.bounds.width;
        out.height = Math.abs(this.scale.y) * this.bounds.height;
        return out;
    }
    /**
   * Sets the size of the Text to the specified width and height.
   * This is faster than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * const text = new Text({
   *    text: 'Hello Pixi!',
   *    style: { fontSize: 24 }
   * });
   * text.setSize(100, 200); // Width: 100, Height: 200
   *
   * // Set uniform size
   * text.setSize(100); // Sets both width and height to 100
   *
   * // Set size with object
   * text.setSize({
   *     width: 200,
   *     height: 300
   * });
   * ```
   * @param value - This can be either a number or a {@link Size} object
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link Text#width} For setting width only
   * @see {@link Text#height} For setting height only
   */ setSize(value, height) {
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        } else height ?? (height = value);
        value !== void 0 && this._setWidth(value, this.bounds.width);
        height !== void 0 && this._setHeight(height, this.bounds.height);
    }
    /**
   * Checks if the object contains the given point in local coordinates.
   * Uses the text's bounds for hit testing.
   * @example
   * ```ts
   * // Basic point check
   * const localPoint = { x: 50, y: 25 };
   * const contains = text.containsPoint(localPoint);
   * console.log('Point is inside:', contains);
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is within the text's bounds
   * @see {@link Container#toLocal} For converting global coordinates to local
   */ containsPoint(point) {
        const width = this.bounds.width;
        const height = this.bounds.height;
        const x1 = -width * this.anchor.x;
        let y1 = 0;
        if (point.x >= x1 && point.x <= x1 + width) {
            y1 = -height * this.anchor.y;
            if (point.y >= y1 && point.y <= y1 + height) return true;
        }
        return false;
    }
    /** @internal */ onViewUpdate() {
        if (!this.didViewUpdate) this._didTextUpdate = true;
        super.onViewUpdate();
    }
    /**
   * Destroys this text renderable and optionally its style texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * // Destroys the text and its style
   * text.destroy({ style: true, texture: true, textureSource: true });
   * text.destroy(true);
   * text.destroy() // Destroys the text, but not its style
   */ destroy(options = false) {
        super.destroy(options);
        this.owner = null;
        this._bounds = null;
        this._anchor = null;
        if (typeof options === "boolean" ? options : options?.style) this._style.destroy(options);
        this._style = null;
        this._text = null;
    }
    /**
   * Returns a unique key for this instance.
   * This key is used for caching.
   * @returns {string} Unique key for the instance
   */ get styleKey() {
        return `${this._text}:${this._style.styleKey}:${this._resolution}`;
    }
}
function $7e36113173fcb92e$export$8ddfb4f614f8ed86(args, name) {
    let options = args[0] ?? {};
    if (typeof options === "string" || args[1]) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), `use new ${name}({ text: "hi!", style }) instead`);
        options = {
            text: options,
            style: args[1]
        };
    }
    return options;
}

});



parcelRegister("9ec1t", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c8d7f3339ba7892$export$2e2bcd8739ae039);
parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");

var $75RpY = parcelRequire("75RpY");

var $aUeTn = parcelRequire("aUeTn");

var $1NR8g = parcelRequire("1NR8g");
class $0c8d7f3339ba7892$export$2e2bcd8739ae039 extends $eicwU.Container {
    static instance;
    Game = (0, $75RpY.default).getInstance();
    BottomUnder;
    Bottom;
    Middle;
    TopUnder;
    Top;
    Info;
    UI;
    UITop;
    VideoMode;
    constructor(){
        super();
        if (!$0c8d7f3339ba7892$export$2e2bcd8739ae039.instance) $0c8d7f3339ba7892$export$2e2bcd8739ae039.instance = this;
        this.BottomUnder = new $0c8d7f3339ba7892$var$BaseLayer();
        this.Bottom = new $0c8d7f3339ba7892$var$BaseLayer();
        this.Middle = new $0c8d7f3339ba7892$var$BaseLayer();
        this.TopUnder = new $0c8d7f3339ba7892$var$BaseLayer();
        this.Top = new $0c8d7f3339ba7892$var$BaseLayer();
        this.Info = new $0c8d7f3339ba7892$var$BaseLayer();
        this.UI = new $0c8d7f3339ba7892$var$BaseLayer();
        this.UITop = new $0c8d7f3339ba7892$var$BaseLayer();
        this.VideoMode = new $0c8d7f3339ba7892$var$BaseLayer();
        this.UI.interactive = true;
        this.UITop.interactive = true;
        this.checkVideoMode();
        this.addToStage();
    }
    addToStage = ()=>this.Game.stage.addChild(this);
    static getInstance = ()=>$0c8d7f3339ba7892$export$2e2bcd8739ae039.instance;
    checkVideoMode() {
        const params = new URLSearchParams(window.location.search);
        const videoMode = params.get("videomode");
        if (videoMode) {
            new (0, $1NR8g.default)();
            new (0, $aUeTn.default)();
        }
    }
}
class $0c8d7f3339ba7892$var$BaseLayer extends $eicwU.Container {
    Layers = $0c8d7f3339ba7892$export$2e2bcd8739ae039.getInstance();
    constructor(){
        super();
        this.addToLayers();
    }
    addToLayers = ()=>this.Layers.addChild(this);
}

});
parcelRegister("aUeTn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f6fb4efeb0e25a$export$2e2bcd8739ae039);
parcelRequire("iuB9z");
var $3cebA = parcelRequire("3cebA");

var $75RpY = parcelRequire("75RpY");

var $9ec1t = parcelRequire("9ec1t");
class $f6f6fb4efeb0e25a$export$2e2bcd8739ae039 extends $3cebA.Graphics {
    Game = (0, $75RpY.default).getInstance();
    Layers = (0, $9ec1t.default).getInstance();
    constructor(){
        super();
        this.draw();
        this.followPointer();
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.VideoMode.addChild(this);
    draw() {
        this.circle(0, 0, 20).fill("yellow").alpha = .5;
    }
    followPointer() {
        this.Layers.UI.on("pointermove", (e)=>{
            this.position.copyFrom(e.data.global);
        });
    }
}

});

parcelRegister("1NR8g", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf4d2195e39f79f0$export$2e2bcd8739ae039);
parcelRequire("iuB9z");
var $4rhnu = parcelRequire("4rhnu");

var $9ec1t = parcelRequire("9ec1t");

var $7vBln = parcelRequire("7vBln");

var $3ANoO = parcelRequire("3ANoO");
const $cf4d2195e39f79f0$var$LOGO_PATH = "/logo-small.png";
class $cf4d2195e39f79f0$export$2e2bcd8739ae039 extends $4rhnu.Sprite {
    Layers = (0, $9ec1t.default).getInstance();
    constructor(){
        super();
        Object.assign(this, (0, $3ANoO.LOGO_BOUNDS));
        this.anchor.set(.5);
        this.texture = (0, $7vBln.default).getTexture($cf4d2195e39f79f0$var$LOGO_PATH);
        this.Layers.VideoMode.addChild(this);
    }
}

});
parcelRegister("7vBln", function(module, exports) {

$parcel$export(module.exports, "default", () => $bad62ad915ddc1e0$export$2e2bcd8739ae039);
parcelRequire("iuB9z");
var $9Gm4h = parcelRequire("9Gm4h");
var $bLlTJ = parcelRequire("bLlTJ");

var $3ANoO = parcelRequire("3ANoO");

var $7hiC7 = parcelRequire("7hiC7");
class $bad62ad915ddc1e0$export$2e2bcd8739ae039 {
    static basePath = (0, $3ANoO.BASE_PATH);
    static logoPath = `${this.basePath}${0, $3ANoO.LOGO_PATH}`;
    static assetList;
    static textures;
    static logo;
    static infoSliderAssetURLs = [];
    constructor(){}
    static getLogo = ()=>new $bLlTJ.Texture(this.logo);
    static async load(assetsList, cb) {
        this.assetList = [
            ...assetsList.map((asset)=>`${asset.includes("http") ? "" : this.basePath}${asset}`)
        ];
        this.textures = await $9Gm4h.Assets.load(this.assetList, (p)=>cb(Math.floor(p * 100)));
    }
    static async loadLogo() {
        this.logo = await $9Gm4h.Assets.load(this.logoPath);
    }
    static getTexture(_path) {
        const path = `${_path.includes("http") ? "" : this.basePath}${_path}`;
        let Texture = this.textures[path];
        if (!Texture) {
            console.log("Texture is not found", path);
            Texture = $bLlTJ.Texture.WHITE;
        }
        return new $bLlTJ.Texture(Texture);
    }
    static async getAssetsUrls(assetsSlug) {
        if (assetsSlug === undefined && assetsSlug == "") this.infoSliderAssetURLs = [];
        else {
            const data = await (0, $7hiC7.default)(assetsSlug);
            this.infoSliderAssetURLs = data && data.gameCard ? data.gameCard.cards.map((card)=>card.image.url) : [];
        }
        return this.infoSliderAssetURLs;
    }
    static getInfoSliderAssetURLs = ()=>this.infoSliderAssetURLs;
}

});
parcelRegister("3ANoO", function(module, exports) {

$parcel$export(module.exports, "INITIAL_WIDTH", () => $f445c1e99063c794$export$f288ef2b564392e7);
$parcel$export(module.exports, "INITIAL_HEIGHT", () => $f445c1e99063c794$export$bcc993773d425214);
$parcel$export(module.exports, "INITIAL_CIRCLE_RADIUS", () => $f445c1e99063c794$export$f5c0794bc0266f1);
$parcel$export(module.exports, "GUIDE_TEXT_COORD", () => $f445c1e99063c794$export$158208f930a33a87);
$parcel$export(module.exports, "CENTER_ANGLE_COLOR", () => $f445c1e99063c794$export$c4ea4e1e5a8f943);
$parcel$export(module.exports, "CIRCUM_ANGLE_COLOR", () => $f445c1e99063c794$export$1b467e970dd19e37);
$parcel$export(module.exports, "INFO_SLIDER_DIMS", () => $f445c1e99063c794$export$6cb4ba5e1687d4db);
$parcel$export(module.exports, "LOGO_BOUNDS", () => $f445c1e99063c794$export$64f72e9985500875);
$parcel$export(module.exports, "LINE_CONFIG", () => $f445c1e99063c794$export$732e921126aac07a);
$parcel$export(module.exports, "BASE_PATH", () => $f445c1e99063c794$export$2812a1fb15aca49c);
$parcel$export(module.exports, "ROOT_ASSETS_LIST", () => $f445c1e99063c794$export$1dfe9ddb85bd80cb);
$parcel$export(module.exports, "LOGO_PATH", () => $f445c1e99063c794$export$6a3201cd80ff343f);

var $dWG0X = parcelRequire("dWG0X");
const $f445c1e99063c794$export$f288ef2b564392e7 = 1600;
const $f445c1e99063c794$export$bcc993773d425214 = 900;
const $f445c1e99063c794$export$f5c0794bc0266f1 = 200;
const $f445c1e99063c794$export$158208f930a33a87 = {
    x: 50,
    y: 20
};
const $f445c1e99063c794$export$c4ea4e1e5a8f943 = {
    color: 0xFC99C4,
    textColor: 0xf94f6f
};
const $f445c1e99063c794$export$1b467e970dd19e37 = {
    color: 0x21D4FE,
    textColor: 0x0195b8
};
const $f445c1e99063c794$export$6cb4ba5e1687d4db = {
    width: 405,
    height: 270
};
const $f445c1e99063c794$export$64f72e9985500875 = {
    x: 1550,
    y: 100,
    width: 134,
    height: 134
};
const $f445c1e99063c794$export$732e921126aac07a = {
    width: 5,
    isDashed: false,
    isEqualSymbol: false,
    equalSymbol: (0, $dWG0X.LineEqualSymbol).Dash,
    arrowCap: (0, $dWG0X.ArrowCap).None,
    color: 0x000000
};
const $f445c1e99063c794$export$2812a1fb15aca49c = "/static/images";
const $f445c1e99063c794$export$1dfe9ddb85bd80cb = [
    "/default.png",
    "/logo.png",
    "/logo-small.png",
    "/info-slider/mask.png",
    "/info-slider/arrow.png"
];
const $f445c1e99063c794$export$6a3201cd80ff343f = "/logo.png";

});
parcelRegister("dWG0X", function(module, exports) {

$parcel$export(module.exports, "ArrowCap", () => $adaf5dcf8d75d927$export$33015f7e98c64b0b);
$parcel$export(module.exports, "LineEqualSymbol", () => $adaf5dcf8d75d927$export$9eecdac46a978b55);
$parcel$export(module.exports, "SwitcherBgColors", () => $adaf5dcf8d75d927$export$3a1db0583aebea0a);
var $adaf5dcf8d75d927$export$ab0516adfd7424f0 = /*#__PURE__*/ function(LineEqualType) {
    LineEqualType["doubleLine"] = "DOUBLE_LINE";
    LineEqualType["singleLine"] = "SINGLE_LINE";
    return LineEqualType;
}({});
var $adaf5dcf8d75d927$export$33015f7e98c64b0b = /*#__PURE__*/ function(ArrowCap) {
    ArrowCap["None"] = "NONE";
    ArrowCap["Start"] = "START";
    ArrowCap["End"] = "END";
    ArrowCap["Both"] = "BOTH";
    return ArrowCap;
}({});
var $adaf5dcf8d75d927$export$9eecdac46a978b55 = /*#__PURE__*/ function(LineEqualSymbol) {
    LineEqualSymbol["Dash"] = "DASH";
    LineEqualSymbol["Arrow"] = "ARROW";
    return LineEqualSymbol;
}({});
var $adaf5dcf8d75d927$export$3a1db0583aebea0a = /*#__PURE__*/ function(SwitcherBgColors) {
    SwitcherBgColors[SwitcherBgColors["defaultBgColor"] = 14501328] = "defaultBgColor";
    SwitcherBgColors[SwitcherBgColors["pressedBgColor"] = 16773120] = "pressedBgColor";
    return SwitcherBgColors;
}({});

});


parcelRegister("7hiC7", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e125e161ca5c0b$export$2e2bcd8739ae039);
const $60e125e161ca5c0b$var$GRAPHQL_URL = "https://graphql.datocms.com/";
const $60e125e161ca5c0b$var$DATOCMS_API_TOKEN = "50fbbdf84945fb3a8a5c085a788b2b";
const $60e125e161ca5c0b$var$getQuery = (slug)=>`
  query GetCircleTheorem {
    gameCard(filter: { slug: {eq: "${slug}"}}) {
      slug
      cards {
        __typename
        ... on GameCardBlockRecord {
          id
          title
          image {
            url
          }
        }
      }
    }
  }
`;
async function $60e125e161ca5c0b$export$2e2bcd8739ae039(slug) {
    try {
        const response = await fetch($60e125e161ca5c0b$var$GRAPHQL_URL, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${$60e125e161ca5c0b$var$DATOCMS_API_TOKEN}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                query: $60e125e161ca5c0b$var$getQuery(slug),
                variables: {
                    slug: slug
                }
            })
        });
        const { data: data } = await response.json();
        return data;
    } catch (error) {
        console.error("Error:", error);
        return {};
    }
}

});




parcelRegister("ddvKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d45a358ab71a80e$export$2e2bcd8739ae039);
parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
var $4rhnu = parcelRequire("4rhnu");
var $bLlTJ = parcelRequire("bLlTJ");

var $75RpY = parcelRequire("75RpY");

var $9ec1t = parcelRequire("9ec1t");

var $erVR3 = parcelRequire("erVR3");

var $16Wgx = parcelRequire("16Wgx");

var $kPclf = parcelRequire("kPclf");

var $16HUD = parcelRequire("16HUD");

var $8Db5v = parcelRequire("8Db5v");
class $7d45a358ab71a80e$export$2e2bcd8739ae039 extends $eicwU.Container {
    Game = (0, $75RpY.default).getInstance();
    Layers = (0, $9ec1t.default).getInstance();
    lastUnixTime = 0;
    currCursorType = (0, $16HUD.CustomCursorType).default;
    constructor(){
        super();
        this.addBg();
        this.setLayer(false);
        this.addInteractivity();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).setInteractLayer, (isDowned)=>this.setLayer(isDowned));
        (0, $8Db5v.cursorEventBus).on((0, $8Db5v.EnumCursorEventBus).setInteractLayerCursor, (c)=>this.currCursorType = c);
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.interactive = false);
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.interactive = true);
    }
    setLayer = (isDown)=>{
        const layer = isDown ? "UITop" : "Top";
        this.parent?.removeChild(this);
        this.Layers[`${layer}`].addChild(this);
    };
    addBg() {
        const texture = new $bLlTJ.Texture($bLlTJ.Texture.EMPTY);
        const sprite = this.addChild(new $4rhnu.Sprite(texture));
        const dim = this.Game.getDim();
        sprite.width = dim.WIDTH;
        sprite.height = dim.HEIGHT;
        sprite.position.copyFrom({
            x: 0,
            y: 0
        });
    }
    addInteractivity() {
        (0, $16Wgx.default)(this, {
            handleDownFunc: (e)=>this.handlePointerDown(e),
            handleMoveFunc: (e)=>this.handlePointerMove(e),
            handleUpFunc: (e)=>this.handlePointerUp(e),
            handleOutFunc: (e)=>this.handlePointerUp(e),
            handleUpOutSideFunc: (e)=>this.handlePointerUp(e)
        }, (0, $16HUD.CustomCursorType).default, true);
    }
    handlePointerUp(e) {
        const coord = (0, $kPclf.default)(e.global);
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).setPointerUp, coord);
    }
    handlePointerDown(e) {
        const coord = (0, $kPclf.default)(e.global);
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).setPointerDown, coord);
    }
    handlePointerMove(e) {
        const UnixTime = Date.now();
        if (UnixTime >= this.lastUnixTime + 5) {
            this.lastUnixTime = UnixTime;
            const coord = (0, $kPclf.default)(e.global);
            (0, $8Db5v.cursorEventBus).emit((0, $8Db5v.EnumCursorEventBus).setCursor, this.currCursorType);
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).setPointerMove, coord);
        }
    }
}

});
parcelRegister("erVR3", function(module, exports) {

$parcel$export(module.exports, "EnumRootEventBus", () => $ef559677fd8b5b0c$export$f8b196b0adfd67bd);
$parcel$export(module.exports, "rootEventBus", () => $ef559677fd8b5b0c$export$7b985fa60576bb58);
parcelRequire("iuB9z");
var $3vRz3 = parcelRequire("3vRz3");
var $ef559677fd8b5b0c$export$f8b196b0adfd67bd = /*#__PURE__*/ function(EnumRootEventBus) {
    EnumRootEventBus["onVideoMode"] = "ON_VIDEO_MODE";
    EnumRootEventBus["setInfoSliderPage"] = "SET_INFO_SLIDER_PAGE";
    EnumRootEventBus["setInfoSliderPageWArr"] = "SET_INFO_SLIDER_PAGE_WITH_ARROW";
    EnumRootEventBus["setCurPage"] = "SET_CURRENT_PAGE";
    EnumRootEventBus["updateEdgeState"] = "UPDATE_EDGE_STATE";
    EnumRootEventBus["startedCircleAnim"] = "STARTED_CIRCLE_ANIMATION";
    EnumRootEventBus["completedCircleAnim"] = "COMPLETED_CIRCLE_ANIMATION";
    EnumRootEventBus["cancelledCircleAnim"] = "CANCELLED_CIRCLE_ANIMATION";
    EnumRootEventBus["closeSwitcher"] = "CLOSE_SWITCHER";
    EnumRootEventBus["setRedPointTag"] = "SET_RED_POINT_TAG";
    EnumRootEventBus["setRedPointCoord"] = "SET_RED_POINT_COORD";
    EnumRootEventBus["setRefRadians"] = "SET_REFERANCE_RADIANS";
    EnumRootEventBus["getCircleCoord"] = "GET_CIRCLE_COORD";
    EnumRootEventBus["drawElements"] = "DRAW_ELEMENTS";
    EnumRootEventBus["setPointerDown"] = "SET_POINTER_DOWN";
    EnumRootEventBus["setPointerMove"] = "SET_POINTER_MOVE";
    EnumRootEventBus["setPointerUp"] = "SET_POINTER_UP";
    EnumRootEventBus["setRulerLineStartCoord"] = "SET_RULER_LINE_START_COORD";
    EnumRootEventBus["setInteractLayer"] = "SET_INTERACTIVITY_COMPONENT_LAYER";
    EnumRootEventBus["topSwitcherButtonLabel"] = "TOP_SWITCHER_BUTTON_LABEL"; // emit top switcher button label
    return EnumRootEventBus;
}({});
const $ef559677fd8b5b0c$export$7b985fa60576bb58 = new (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3)))();

});

parcelRegister("16Wgx", function(module, exports) {

$parcel$export(module.exports, "default", () => $f707d6d439d85198$export$2e2bcd8739ae039);

var $erVR3 = parcelRequire("erVR3");

var $8Db5v = parcelRequire("8Db5v");

var $16HUD = parcelRequire("16HUD");

var $kPclf = parcelRequire("kPclf");

var $7oAU9 = parcelRequire("7oAU9");
function $f707d6d439d85198$export$2e2bcd8739ae039(elm, eventFuncs, cursorType, isCursorMutable = false, isButton = false) {
    const { handleOverFunc: handleOverFunc, handleDownFunc: handleDownFunc, handleMoveFunc: handleMoveFunc, handleUpFunc: handleUpFunc, handleLeaveFunc: handleLeaveFunc, handleOutFunc: handleOutFunc, handleUpOutSideFunc: handleUpOutSideFunc } = eventFuncs;
    const handleDown = (e)=>{
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).setInteractLayer, true);
        isButton && elm.scale.set(.95);
        !isCursorMutable && (0, $8Db5v.cursorEventBus).emit((0, $8Db5v.EnumCursorEventBus).setInteractLayerCursor, cursorType);
        handleDownFunc && handleDownFunc(e);
    };
    const handleUp = (e)=>{
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).setInteractLayer, false);
        isButton && elm.scale.set(1);
        !isCursorMutable && (0, $8Db5v.cursorEventBus).emit((0, $8Db5v.EnumCursorEventBus).setInteractLayerCursor, (0, $16HUD.CustomCursorType).default);
        handleUpFunc && handleUpFunc(e);
    };
    const handleLeave = (e)=>{
        handleLeaveFunc && handleLeaveFunc(e);
    };
    const handleOver = (e)=>{
        const coord = (0, $kPclf.default)(e.global);
        (0, $8Db5v.cursorEventBus).emit((0, $8Db5v.EnumCursorEventBus).setCursor, cursorType, coord);
        elm.filters = [
            (0, $7oAU9.brightnessFilter)
        ];
        handleOverFunc && handleOverFunc(e);
    };
    const handleMove = (e)=>{
        const coord = (0, $kPclf.default)(e.global);
        (0, $8Db5v.cursorEventBus).emit((0, $8Db5v.EnumCursorEventBus).setCursor, cursorType, coord, isCursorMutable);
        handleMoveFunc && handleMoveFunc(e);
    };
    const handleOut = (e)=>{
        (0, $8Db5v.cursorEventBus).emit((0, $8Db5v.EnumCursorEventBus).setCursor, (0, $16HUD.CustomCursorType).empty);
        isButton && elm.scale.set(1);
        elm.filters = [];
        handleOutFunc && handleOutFunc(e);
    };
    const handleOutSide = (e)=>handleUpOutSideFunc && handleUpOutSideFunc(e);
    elm.interactive = true;
    elm.cursor = "none";
    elm.on("pointerover", handleOver).on("pointermove", handleMove).on("pointerout", handleOut).on("pointerupoutside", handleOutSide).on("pointerdown", handleDown).on("pointerup", handleUp).on("pointerupoutside", handleUp).on("pointerleave", handleLeave);
}

});
parcelRegister("8Db5v", function(module, exports) {

$parcel$export(module.exports, "EnumCursorEventBus", () => $75d777284d29094e$export$cf058ae5b46dbef4);
$parcel$export(module.exports, "cursorEventBus", () => $75d777284d29094e$export$ad3df7e758f51150);
parcelRequire("iuB9z");
var $3vRz3 = parcelRequire("3vRz3");
var $75d777284d29094e$export$cf058ae5b46dbef4 = /*#__PURE__*/ function(EnumCursorEventBus) {
    EnumCursorEventBus["setCursor"] = "SET_CURSOR";
    EnumCursorEventBus["setRotation"] = "SET_ROTATION";
    EnumCursorEventBus["setColor"] = "SET_COLOR";
    EnumCursorEventBus["setInteractLayerCursor"] = "SET_INTERACTIVITY_LAYER_CUSTOM_CURSOR";
    return EnumCursorEventBus;
}({});
const $75d777284d29094e$export$ad3df7e758f51150 = new (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3)))();

});

parcelRegister("16HUD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f8419b1a72f42e0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CustomCursorType", () => $0f8419b1a72f42e0$export$a0a7d1c7de2d5537);
parcelRequire("iuB9z");
var $3cebA = parcelRequire("3cebA");

var $75RpY = parcelRequire("75RpY");

var $9ec1t = parcelRequire("9ec1t");

var $34nLP = parcelRequire("34nLP");

var $erVR3 = parcelRequire("erVR3");

var $8Db5v = parcelRequire("8Db5v");

var $kPclf = parcelRequire("kPclf");
class $0f8419b1a72f42e0$export$2e2bcd8739ae039 extends $3cebA.Graphics {
    Game = (0, $75RpY.default).getInstance();
    cursorType;
    interactLayerCursor = "DEFAULT";
    pencilColor = 0x000000;
    constructor(){
        super();
        this.setLayer(true);
        this.eventMode = "none";
        this.setVisibilityForDevice();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).setPointerMove, (coord)=>this.followPointer(coord));
        (0, $8Db5v.cursorEventBus).on((0, $8Db5v.EnumCursorEventBus).setInteractLayerCursor, (c)=>this.setInteractLayerCursor(c));
        (0, $8Db5v.cursorEventBus).on((0, $8Db5v.EnumCursorEventBus).setCursor, (type, coord, isMutable)=>this.setCustomCursor(type, coord, isMutable));
        (0, $8Db5v.cursorEventBus).on((0, $8Db5v.EnumCursorEventBus).setRotation, (rotation)=>this.setRotation(rotation));
        (0, $8Db5v.cursorEventBus).on((0, $8Db5v.EnumCursorEventBus).setColor, (color)=>this.setColor(color));
    }
    setLayer(isGame) {
        this.parent?.removeChild(this);
        if (isGame) return this.Game.stage.addChild(this);
        const layers = (0, $9ec1t.default).getInstance();
        layers.UITop.addChild(this);
    }
    setRotation = (rot)=>this.rotation = rot ? rot : 0;
    setColor = (color)=>this.pencilColor = color;
    setInteractLayerCursor = (c)=>this.interactLayerCursor !== c ? this.interactLayerCursor = c : "";
    followPointer = (coord)=>this.visible && this.position.copyFrom((0, $kPclf.default)(coord));
    setVisibilityForDevice() {
        const isCoarsePointer = window.matchMedia("(pointer: coarse)").matches;
        const isSmallScreen = window.innerWidth < 1024;
        const isDesktop = !isCoarsePointer && !isSmallScreen;
        this.visible = isDesktop;
    }
    setCustomCursor(_type, coord, isMutable) {
        const type = isMutable ? this.interactLayerCursor : _type;
        this.cursorType = type;
        if (this.interactLayerCursor !== "PENCIL" && this.cursorType !== "PENCIL") this.rotation = 0;
        switch(type){
            case "DEFAULT":
                (0, $34nLP.default).drawDefaultIcon(this);
                break;
            case "POINTER":
                (0, $34nLP.default).drawPointerIcon(this);
                break;
            case "GRAB":
                (0, $34nLP.default).drawGrabIcon(this);
                break;
            case "PENCIL":
                (0, $34nLP.default).drawPencilIcon(this, this.pencilColor);
                break;
            case "ROTATE":
                (0, $34nLP.default).drawRotateIcon(this);
                break;
            case "TARGET":
                (0, $34nLP.default).drawTargetIcon(this);
                break;
            default:
                this.clear();
                break;
        }
        coord && this.followPointer(coord);
    }
}
var $0f8419b1a72f42e0$export$a0a7d1c7de2d5537 = /*#__PURE__*/ function(CustomCursorType) {
    CustomCursorType["default"] = "DEFAULT";
    CustomCursorType["pointer"] = "POINTER";
    CustomCursorType["grab"] = "GRAB";
    CustomCursorType["rotate"] = "ROTATE";
    CustomCursorType["pencil"] = "PENCIL";
    CustomCursorType["target"] = "TARGET";
    CustomCursorType["empty"] = "EMPTY";
    return CustomCursorType;
}({});

});
parcelRegister("34nLP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d2839626d182ea7$export$2e2bcd8739ae039);

var $2UGuq = parcelRequire("2UGuq");

var $ad4ha = parcelRequire("ad4ha");
class $6d2839626d182ea7$export$2e2bcd8739ae039 {
    static drawPencilIcon(customCursor, color) {
        (0, $ad4ha.drawPencil)(customCursor, color);
    }
    static drawDefaultIcon(customCursor) {
        const startCoord = (0, $2UGuq.default)(Math.PI / 36 * 13, 4);
        const endCoord = (0, $2UGuq.default)(Math.PI / 36 * 13, 24);
        const mid1Coord = (0, $2UGuq.default)(Math.PI / 36 * 9, 16);
        const mid2Coord = (0, $2UGuq.default)(Math.PI / 36 * 17, 16);
        customCursor.clear().moveTo(1, 0).lineTo(mid1Coord.x, mid1Coord.y).lineTo(mid2Coord.x, mid2Coord.y).lineTo(1, 0).fill(0x000000).stroke({
            width: 2,
            color: 0x000000,
            cap: "round"
        }).moveTo(startCoord.x + 1, startCoord.y).lineTo(endCoord.x, endCoord.y).stroke({
            width: 3,
            color: 0x000000,
            cap: "round"
        });
    }
    static drawPointerIcon(customCursor) {
        const w = 3.5;
        const arcStartCoord = (0, $2UGuq.default)(Math.PI, w * 2.5);
        customCursor.clear().moveTo(0, 1) // index finger
        .lineTo(0, 20).moveTo(w, 7) // middle finger
        .lineTo(w, 20).moveTo(w * 2, 8) // ring finger
        .lineTo(w * 2, 20).moveTo(w * 3, 9) // pinky
        .lineTo(w * 3, 18).moveTo(-5, 13) // thumb
        .lineTo(0, 20).stroke({
            width: w - .5,
            color: 0x000000,
            cap: "round"
        }).moveTo(w * 2.5 + arcStartCoord.x, 20 + arcStartCoord.y).arc(w * 1.5, 18, w * 1.8, 0, Math.PI).moveTo(0, 13).rect(0, 13, w * 3, 8).fill(0x000000);
    }
    static drawGrabIcon(customCursor) {
        const w = 3.5;
        customCursor.clear().moveTo(-w, w) // thumb
        .lineTo(-10, -6).moveTo(-w, w) // index finger
        .lineTo(-w - 2, -13).moveTo(0, 0) // middle finger
        .lineTo(-1, -15).moveTo(w, w) // ring finger
        .lineTo(w, -13).moveTo(w * 1.1, w) // pinky
        .lineTo(w * 2.2, -8).stroke({
            width: w - .5,
            color: 0x000000,
            cap: "round"
        }).moveTo(0, 0).circle(0, 0, w * 1.8).fill(0x000000);
    }
    static drawRotateIcon(customCursor) {
        const radius = 10;
        const first = [
            Math.PI,
            Math.PI / 8 * 3
        ];
        const second = [
            0,
            -Math.PI / 8 * 5
        ];
        const startCoord1 = (0, $2UGuq.default)(first[0], radius);
        const startCoord2 = (0, $2UGuq.default)(second[0], radius);
        customCursor.clear().moveTo(startCoord1.x, startCoord1.y).roundPoly(startCoord1.x, startCoord1.y, 7, 3, 3, -Math.PI / 18).moveTo(startCoord2.x, startCoord2.y).roundPoly(startCoord2.x, startCoord2.y, 7, 3, 3, Math.PI / 18 * 17).fill(0x000000).moveTo(startCoord1.x, startCoord1.y).arc(0, 0, radius, first[0], first[1], true).moveTo(startCoord2.x, startCoord2.y).arc(0, 0, radius, second[0], second[1], true).stroke({
            width: 4,
            color: 0x000000
        });
    }
    static drawTargetIcon(customCursor) {
        const length = 14;
        customCursor.clear().moveTo(length / 2, length / 2).lineTo(-length / 2, -length / 2).moveTo(length / 2, -length / 2).lineTo(-length / 2, length / 2).stroke({
            width: 3,
            color: 0x000000,
            cap: "round"
        }).circle(0, 0, 3).fill(0xFFFFFF);
    }
}

});
parcelRegister("2UGuq", function(module, exports) {

$parcel$export(module.exports, "default", () => $cad6f98d3e4544cd$export$2e2bcd8739ae039);
function $cad6f98d3e4544cd$export$2e2bcd8739ae039(rad, radius) {
    return {
        x: Math.cos(rad) * radius,
        y: Math.sin(rad) * radius
    };
}

});

parcelRegister("ad4ha", function(module, exports) {

$parcel$export(module.exports, "drawPencil", () => $a6949420cc98e932$export$eabbdfb811db0121);
function $a6949420cc98e932$export$eabbdfb811db0121(graph, color, sCoord = {
    x: 0,
    y: 0
}) {
    graph.clear().moveTo(sCoord.x + 0, sCoord.y - 5).roundPoly(sCoord.x + 0, sCoord.y - 5, 6, 3, 0, Math.PI).rect(sCoord.x - 5, sCoord.y - 30, 10, 20).rect(sCoord.x - 5, sCoord.y - 37, 10, 5).fill(color);
}

});


parcelRegister("kPclf", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e2cb1acfd2b58d2$export$2e2bcd8739ae039);
const $9e2cb1acfd2b58d2$var$getCleanCoord = (coord)=>({
        x: Math.floor(coord.x),
        y: Math.floor(coord.y)
    });
var $9e2cb1acfd2b58d2$export$2e2bcd8739ae039 = $9e2cb1acfd2b58d2$var$getCleanCoord;

});


parcelRegister("7oAU9", function(module, exports) {

$parcel$export(module.exports, "disabledfilter", () => $ce9cfc10a2b4152a$export$9c690c405523a56c);
$parcel$export(module.exports, "brightnessFilter", () => $ce9cfc10a2b4152a$export$3e00f819dc8d4597);
parcelRequire("iuB9z");
var $cm9HO = parcelRequire("cm9HO");
const $ce9cfc10a2b4152a$export$9c690c405523a56c = new $cm9HO.ColorMatrixFilter();
$ce9cfc10a2b4152a$export$9c690c405523a56c.desaturate();
const $ce9cfc10a2b4152a$export$3e00f819dc8d4597 = new $cm9HO.ColorMatrixFilter();
$ce9cfc10a2b4152a$export$3e00f819dc8d4597.brightness(1.1, true);
$ce9cfc10a2b4152a$export$3e00f819dc8d4597.resolution = 2;

});



parcelRegister("1PAc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf496dd42e066fa$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $erVR3 = parcelRequire("erVR3");
class $5cf496dd42e066fa$export$2e2bcd8739ae039 {
    static instance;
    static isCancelled = false;
    rootEventBus = (0, $erVR3.rootEventBus);
    EnumRootEventBus = (0, $erVR3.EnumRootEventBus);
    constructor(){
        if (!$5cf496dd42e066fa$export$2e2bcd8739ae039.instance) $5cf496dd42e066fa$export$2e2bcd8739ae039.instance = this;
        this.rootEventBus.on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>$5cf496dd42e066fa$export$2e2bcd8739ae039.isCancelled = false);
        this.rootEventBus.on((0, $erVR3.EnumRootEventBus).cancelledCircleAnim, ()=>{
            $5cf496dd42e066fa$export$2e2bcd8739ae039.isCancelled = true;
            setTimeout(()=>{
                $5cf496dd42e066fa$export$2e2bcd8739ae039.isCancelled = false;
                this.rootEventBus.emit((0, $erVR3.EnumRootEventBus).completedCircleAnim);
            }, 0);
        });
        this.rootEventBus.on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>$5cf496dd42e066fa$export$2e2bcd8739ae039.isCancelled = false);
    }
    update = (delta)=>(0, $6m47o.default).update(delta);
    getIsCancelled = ()=>$5cf496dd42e066fa$export$2e2bcd8739ae039.isCancelled;
    static getInstance = ()=>$5cf496dd42e066fa$export$2e2bcd8739ae039.instance;
}

});
parcelRegister("6m47o", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a07fdf50faf4114$export$2e2bcd8739ae039);

var $hPtJY = parcelRequire("hPtJY");
var $4a07fdf50faf4114$var$NOW;
// Include a performance.now polyfill.
// In node.js, use process.hrtime.
// @ts-ignore
if (typeof self === 'undefined' && typeof $hPtJY !== 'undefined' && $hPtJY.hrtime) $4a07fdf50faf4114$var$NOW = function() {
    // @ts-ignore
    var time = $hPtJY.hrtime();
    // Convert [seconds, nanoseconds] to milliseconds.
    return time[0] * 1000 + time[1] / 1000000;
};
else if (typeof self !== 'undefined' && self.performance !== undefined && self.performance.now !== undefined) // This must be bound, because directly assigning this function
// leads to an invocation exception in Chrome.
$4a07fdf50faf4114$var$NOW = self.performance.now.bind(self.performance);
else if (Date.now !== undefined) $4a07fdf50faf4114$var$NOW = Date.now;
else $4a07fdf50faf4114$var$NOW = function() {
    return new Date().getTime();
};
var $4a07fdf50faf4114$var$NOW$1 = $4a07fdf50faf4114$var$NOW;
/**
 * Controlling groups of tweens
 *
 * Using the TWEEN singleton to manage your tweens can cause issues in large apps with many components.
 * In these cases, you may want to create your own smaller groups of tween
 */ var $4a07fdf50faf4114$var$Group = /** @class */ function() {
    function Group() {
        this._tweens = {};
        this._tweensAddedDuringUpdate = {};
    }
    Group.prototype.getAll = function() {
        var _this = this;
        return Object.keys(this._tweens).map(function(tweenId) {
            return _this._tweens[tweenId];
        });
    };
    Group.prototype.removeAll = function() {
        this._tweens = {};
    };
    Group.prototype.add = function(tween) {
        this._tweens[tween.getId()] = tween;
        this._tweensAddedDuringUpdate[tween.getId()] = tween;
    };
    Group.prototype.remove = function(tween) {
        delete this._tweens[tween.getId()];
        delete this._tweensAddedDuringUpdate[tween.getId()];
    };
    Group.prototype.update = function(time, preserve) {
        var tweenIds = Object.keys(this._tweens);
        if (tweenIds.length === 0) return false;
        time = time !== undefined ? time : $4a07fdf50faf4114$var$NOW$1();
        // Tweens are updated in "batches". If you add a new tween during an
        // update, then the new tween will be updated in the next batch.
        // If you remove a tween during an update, it may or may not be updated.
        // However, if the removed tween was added during the current batch,
        // then it will not be updated.
        while(tweenIds.length > 0){
            this._tweensAddedDuringUpdate = {};
            for(var i = 0; i < tweenIds.length; i++){
                var tween = this._tweens[tweenIds[i]];
                if (tween && tween.update(time) === false) {
                    tween.playing = false;
                    if (!preserve) delete this._tweens[tweenIds[i]];
                }
            }
            tweenIds = Object.keys(this._tweensAddedDuringUpdate);
        }
        return true;
    };
    return Group;
}();
/**
 * The Ease class provides a collection of easing functions for use with tween.js.
 */ var $4a07fdf50faf4114$var$Easing = {
    Linear: {
        None: function(amount) {
            return amount;
        }
    },
    Quadratic: {
        In: function(amount) {
            return amount * amount;
        },
        Out: function(amount) {
            return amount * (2 - amount);
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount;
            return -0.5 * (--amount * (amount - 2) - 1);
        }
    },
    Cubic: {
        In: function(amount) {
            return amount * amount * amount;
        },
        Out: function(amount) {
            return --amount * amount * amount + 1;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount;
            return 0.5 * ((amount -= 2) * amount * amount + 2);
        }
    },
    Quartic: {
        In: function(amount) {
            return amount * amount * amount * amount;
        },
        Out: function(amount) {
            return 1 - --amount * amount * amount * amount;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount * amount;
            return -0.5 * ((amount -= 2) * amount * amount * amount - 2);
        }
    },
    Quintic: {
        In: function(amount) {
            return amount * amount * amount * amount * amount;
        },
        Out: function(amount) {
            return --amount * amount * amount * amount * amount + 1;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount * amount * amount;
            return 0.5 * ((amount -= 2) * amount * amount * amount * amount + 2);
        }
    },
    Sinusoidal: {
        In: function(amount) {
            return 1 - Math.cos(amount * Math.PI / 2);
        },
        Out: function(amount) {
            return Math.sin(amount * Math.PI / 2);
        },
        InOut: function(amount) {
            return 0.5 * (1 - Math.cos(Math.PI * amount));
        }
    },
    Exponential: {
        In: function(amount) {
            return amount === 0 ? 0 : Math.pow(1024, amount - 1);
        },
        Out: function(amount) {
            return amount === 1 ? 1 : 1 - Math.pow(2, -10 * amount);
        },
        InOut: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            if ((amount *= 2) < 1) return 0.5 * Math.pow(1024, amount - 1);
            return 0.5 * (-Math.pow(2, -10 * (amount - 1)) + 2);
        }
    },
    Circular: {
        In: function(amount) {
            return 1 - Math.sqrt(1 - amount * amount);
        },
        Out: function(amount) {
            return Math.sqrt(1 - --amount * amount);
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return -0.5 * (Math.sqrt(1 - amount * amount) - 1);
            return 0.5 * (Math.sqrt(1 - (amount -= 2) * amount) + 1);
        }
    },
    Elastic: {
        In: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            return -Math.pow(2, 10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI);
        },
        Out: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            return Math.pow(2, -10 * amount) * Math.sin((amount - 0.1) * 5 * Math.PI) + 1;
        },
        InOut: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            amount *= 2;
            if (amount < 1) return -0.5 * Math.pow(2, 10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI);
            return 0.5 * Math.pow(2, -10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI) + 1;
        }
    },
    Back: {
        In: function(amount) {
            var s = 1.70158;
            return amount * amount * ((s + 1) * amount - s);
        },
        Out: function(amount) {
            var s = 1.70158;
            return --amount * amount * ((s + 1) * amount + s) + 1;
        },
        InOut: function(amount) {
            var s = 2.5949095;
            if ((amount *= 2) < 1) return 0.5 * (amount * amount * ((s + 1) * amount - s));
            return 0.5 * ((amount -= 2) * amount * ((s + 1) * amount + s) + 2);
        }
    },
    Bounce: {
        In: function(amount) {
            return 1 - $4a07fdf50faf4114$var$Easing.Bounce.Out(1 - amount);
        },
        Out: function(amount) {
            if (amount < 1 / 2.75) return 7.5625 * amount * amount;
            else if (amount < 2 / 2.75) return 7.5625 * (amount -= 1.5 / 2.75) * amount + 0.75;
            else if (amount < 2.5 / 2.75) return 7.5625 * (amount -= 2.25 / 2.75) * amount + 0.9375;
            else return 7.5625 * (amount -= 2.625 / 2.75) * amount + 0.984375;
        },
        InOut: function(amount) {
            if (amount < 0.5) return $4a07fdf50faf4114$var$Easing.Bounce.In(amount * 2) * 0.5;
            return $4a07fdf50faf4114$var$Easing.Bounce.Out(amount * 2 - 1) * 0.5 + 0.5;
        }
    }
};
/**
 *
 */ var $4a07fdf50faf4114$var$Interpolation = {
    Linear: function(v, k) {
        var m = v.length - 1;
        var f = m * k;
        var i = Math.floor(f);
        var fn = $4a07fdf50faf4114$var$Interpolation.Utils.Linear;
        if (k < 0) return fn(v[0], v[1], f);
        if (k > 1) return fn(v[m], v[m - 1], m - f);
        return fn(v[i], v[i + 1 > m ? m : i + 1], f - i);
    },
    Bezier: function(v, k) {
        var b = 0;
        var n = v.length - 1;
        var pw = Math.pow;
        var bn = $4a07fdf50faf4114$var$Interpolation.Utils.Bernstein;
        for(var i = 0; i <= n; i++)b += pw(1 - k, n - i) * pw(k, i) * v[i] * bn(n, i);
        return b;
    },
    CatmullRom: function(v, k) {
        var m = v.length - 1;
        var f = m * k;
        var i = Math.floor(f);
        var fn = $4a07fdf50faf4114$var$Interpolation.Utils.CatmullRom;
        if (v[0] === v[m]) {
            if (k < 0) i = Math.floor(f = m * (1 + k));
            return fn(v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m], f - i);
        } else {
            if (k < 0) return v[0] - (fn(v[0], v[0], v[1], v[1], -f) - v[0]);
            if (k > 1) return v[m] - (fn(v[m], v[m], v[m - 1], v[m - 1], f - m) - v[m]);
            return fn(v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2], f - i);
        }
    },
    Utils: {
        Linear: function(p0, p1, t) {
            return (p1 - p0) * t + p0;
        },
        Bernstein: function(n, i) {
            var fc = $4a07fdf50faf4114$var$Interpolation.Utils.Factorial;
            return fc(n) / fc(i) / fc(n - i);
        },
        Factorial: function() {
            var a = [
                1
            ];
            return function(n) {
                var s = 1;
                if (a[n]) return a[n];
                for(var i = n; i > 1; i--)s *= i;
                a[n] = s;
                return s;
            };
        }(),
        CatmullRom: function(p0, p1, p2, p3, t) {
            var v0 = (p2 - p0) * 0.5;
            var v1 = (p3 - p1) * 0.5;
            var t2 = t * t;
            var t3 = t * t2;
            return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
        }
    }
};
/**
 * Utils
 */ var $4a07fdf50faf4114$var$Sequence = /** @class */ function() {
    function Sequence() {}
    Sequence._nextId = 0;
    Sequence.nextId = function() {
        return Sequence._nextId++;
    };
    return Sequence;
}();
/**
 * Tween.js - Licensed under the MIT license
 * https://github.com/tweenjs/tween.js
 * ----------------------------------------------
 *
 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
 * Thank you all, you're awesome!
 */ /**
 * A tween (from in-between) is a concept that allows you to change the values of the properties of an object in a
 * smooth way. You just tell it which properties you want to change, which final values should they have when the
 * tween finishes running, and how long should this take, and the tweening engine will take care of finding the
 * intermediate values from the starting to the ending point.
 */ var $4a07fdf50faf4114$var$Tween = /** @class */ function() {
    function Tween(object, groupRef) {
        this.playing = false;
        this.paused = false;
        this.pauseStart = 0;
        this.valuesStart = {};
        this.valuesEnd = {};
        this.valuesStartRepeat = {};
        this.durationValue = 1000;
        this.repeatValue = 0;
        this.yoyoValue = false;
        this.reversed = false;
        this.delayTime = 0;
        this.startTime = 0;
        this.easingFunction = $4a07fdf50faf4114$var$Easing.Linear.None;
        this.interpolationFunction = $4a07fdf50faf4114$var$Interpolation.Linear;
        this.chainedTweens = [];
        this.onStartCallbackFired = false;
        this.id = $4a07fdf50faf4114$var$Sequence.nextId();
        this.object = object;
        this.groupRef = groupRef || Tween.TWEEN;
    }
    Tween.inject = function(instance) {
        Tween.TWEEN = instance;
    };
    Tween.prototype.getId = function() {
        return this.id;
    };
    Tween.prototype.isPlaying = function() {
        return this.playing;
    };
    Tween.prototype.isPaused = function() {
        return this.paused;
    };
    Tween.prototype.to = function(properties, duration) {
        this.valuesEnd = Object.create(properties);
        if (duration !== undefined) this.durationValue = duration;
        return this;
    };
    Tween.prototype.duration = function(value) {
        this.durationValue = value;
        return this;
    };
    Tween.prototype.start = function(time) {
        this.groupRef.add(this);
        this.playing = true;
        this.paused = false;
        this.onStartCallbackFired = false;
        this.startTime = time !== undefined ? typeof time === 'string' ? $4a07fdf50faf4114$var$NOW$1() + parseFloat(time) : time : $4a07fdf50faf4114$var$NOW$1();
        this.startTime += this.delayTime;
        for(var property in this.valuesEnd){
            // Check if an Array was provided as property value
            if (this.valuesEnd[property] instanceof Array) {
                if (this.valuesEnd[property].length === 0) continue;
                // Create a local copy of the Array with the start value at the front
                this.valuesEnd[property] = [
                    this.object[property]
                ].concat(this.valuesEnd[property]);
            }
            // If `to()` specifies a property that doesn't exist in the source object,
            // we should not set that property in the object
            if (this.object[property] === undefined) continue;
            // Save the starting value, but only once.
            if (typeof this.valuesStart[property] === 'undefined') this.valuesStart[property] = this.object[property];
            if (this.valuesStart[property] instanceof Array === false) this.valuesStart[property] *= 1.0; // Ensures we're using numbers, not strings
            this.valuesStartRepeat[property] = this.valuesStart[property] || 0;
        }
        return this;
    };
    Tween.prototype.stop = function() {
        if (!this.playing) return this;
        this.groupRef.remove(this);
        this.playing = false;
        this.paused = false;
        if (this.onStopCallback) this.onStopCallback(this.object);
        this.stopChainedTweens();
        return this;
    };
    Tween.prototype.end = function() {
        this.update(Infinity);
        return this;
    };
    Tween.prototype.pause = function(time) {
        if (this.paused || !this.playing) return this;
        this.paused = true;
        this.pauseStart = time === undefined ? $4a07fdf50faf4114$var$NOW$1() : time;
        this.groupRef.remove(this);
        return this;
    };
    Tween.prototype.resume = function(time) {
        if (!this.paused || !this.playing) return this;
        this.paused = false;
        this.startTime += (time === undefined ? $4a07fdf50faf4114$var$NOW$1() : time) - this.pauseStart;
        this.pauseStart = 0;
        this.groupRef.add(this);
        return this;
    };
    Tween.prototype.stopChainedTweens = function() {
        for(var i = 0, numChainedTweens = this.chainedTweens.length; i < numChainedTweens; i++)this.chainedTweens[i].stop();
    };
    Tween.prototype.group = function(group) {
        this.groupRef = group;
        return this;
    };
    Tween.prototype.delay = function(amount) {
        this.delayTime = amount;
        return this;
    };
    Tween.prototype.repeat = function(times) {
        this.repeatValue = times;
        return this;
    };
    Tween.prototype.repeatDelay = function(amount) {
        this.repeatDelayTime = amount;
        return this;
    };
    Tween.prototype.yoyo = function(yoyo) {
        this.yoyoValue = yoyo;
        return this;
    };
    Tween.prototype.easing = function(easing) {
        this.easingFunction = easing;
        return this;
    };
    Tween.prototype.interpolation = function(interpolation) {
        this.interpolationFunction = interpolation;
        return this;
    };
    Tween.prototype.chain = function() {
        var tweens = [];
        for(var _i = 0; _i < arguments.length; _i++)tweens[_i] = arguments[_i];
        this.chainedTweens = tweens;
        return this;
    };
    Tween.prototype.onStart = function(callback) {
        this.onStartCallback = callback;
        return this;
    };
    Tween.prototype.onUpdate = function(callback) {
        this.onUpdateCallback = callback;
        return this;
    };
    Tween.prototype.onRepeat = function(callback) {
        this.onRepeatCallback = callback;
        return this;
    };
    Tween.prototype.onComplete = function(callback) {
        this.onCompleteCallback = callback;
        return this;
    };
    Tween.prototype.onStop = function(callback) {
        this.onStopCallback = callback;
        return this;
    };
    /**
     * Tween.js doesn't run by itself. You need to tell it when to run, by explicitly calling the update method.
     * The recommended method is to do this inside your main animation loop, which should be called with
     * requestAnimationFrame for getting the best graphics performance
     *
     * If called without parameters, update will determine the current time in order to find out how long has it been
     * since the last time it ran.
     *
     * @param time
     */ Tween.prototype.update = function(time) {
        if (time === void 0) time = 0;
        var property;
        var elapsed;
        var value;
        if (time < this.startTime) return true;
        if (this.onStartCallbackFired === false) {
            if (this.onStartCallback) this.onStartCallback(this.object);
            this.onStartCallbackFired = true;
        }
        elapsed = (time - this.startTime) / this.durationValue;
        elapsed = this.durationValue === 0 || elapsed > 1 ? 1 : elapsed;
        value = this.easingFunction(elapsed);
        for(property in this.valuesEnd){
            // Don't update properties that do not exist in the source object
            if (this.valuesStart[property] === undefined) continue;
            var start = this.valuesStart[property] || 0;
            var end = this.valuesEnd[property];
            if (end instanceof Array) this.object[property] = this.interpolationFunction(end, value);
            else {
                // Parses relative end values with start as base (e.g.: +10, -3)
                if (typeof end === 'string') {
                    if (end.charAt(0) === '+' || end.charAt(0) === '-') end = start + parseFloat(end);
                    else end = parseFloat(end);
                }
                // Protect against non numeric properties.
                if (typeof end === 'number') this.object[property] = start + (end - start) * value;
            }
        }
        if (this.onUpdateCallback) this.onUpdateCallback(this.object, elapsed);
        if (elapsed === 1) {
            if (this.repeatValue > 0) {
                if (isFinite(this.repeatValue)) this.repeatValue--;
                // Reassign starting values, restart by making startTime = now
                for(property in this.valuesStartRepeat){
                    if (typeof this.valuesEnd[property] === 'string') this.valuesStartRepeat[property] = this.valuesStartRepeat[property] + parseFloat(this.valuesEnd[property]);
                    if (this.yoyoValue) {
                        var tmp = this.valuesStartRepeat[property];
                        this.valuesStartRepeat[property] = this.valuesEnd[property];
                        this.valuesEnd[property] = tmp;
                    }
                    this.valuesStart[property] = this.valuesStartRepeat[property];
                }
                if (this.yoyoValue) this.reversed = !this.reversed;
                if (this.repeatDelayTime !== undefined) this.startTime = time + this.repeatDelayTime;
                else this.startTime = time + this.delayTime;
                if (this.onRepeatCallback) this.onRepeatCallback(this.object);
                return true;
            } else {
                if (this.onCompleteCallback) this.onCompleteCallback(this.object);
                for(var i = 0, numChainedTweens = this.chainedTweens.length; i < numChainedTweens; i++)// Make the chained tweens start exactly at the time they should,
                // even if the `update()` method was called way past the duration of the tween
                this.chainedTweens[i].start(this.startTime + this.durationValue);
                return false;
            }
        }
        return true;
    };
    return Tween;
}();
var $4a07fdf50faf4114$var$VERSION = '18.6.0';
/**
 * Tween.js - Licensed under the MIT license
 * https://github.com/tweenjs/tween.js
 * ----------------------------------------------
 *
 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
 * Thank you all, you're awesome!
 */ var $4a07fdf50faf4114$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Controlling groups of tweens
 *
 * Using the TWEEN singleton to manage your tweens can cause issues in large apps with many components.
 * In these cases, you may want to create your own smaller groups of tween
 */ var $4a07fdf50faf4114$var$Main = /** @class */ function(_super) {
    $4a07fdf50faf4114$var$__extends(Main, _super);
    function Main() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.version = $4a07fdf50faf4114$var$VERSION;
        _this.now = $4a07fdf50faf4114$var$NOW$1;
        _this.Group = $4a07fdf50faf4114$var$Group;
        _this.Easing = $4a07fdf50faf4114$var$Easing;
        _this.Interpolation = $4a07fdf50faf4114$var$Interpolation;
        _this.nextId = $4a07fdf50faf4114$var$Sequence.nextId;
        _this.Tween = $4a07fdf50faf4114$var$Tween;
        return _this;
    }
    return Main;
}($4a07fdf50faf4114$var$Group);
var $4a07fdf50faf4114$var$TWEEN = new $4a07fdf50faf4114$var$Main();
$4a07fdf50faf4114$var$Tween.inject($4a07fdf50faf4114$var$TWEEN);
var $4a07fdf50faf4114$export$2e2bcd8739ae039 = $4a07fdf50faf4114$var$TWEEN;

});


parcelRegister("8V48z", function(module, exports) {

$parcel$export(module.exports, "default", () => $30bf004d8cf60872$export$2e2bcd8739ae039);

var $aBiHe = parcelRequire("aBiHe");
function $30bf004d8cf60872$export$2e2bcd8739ae039(INITIAL_WIDTH, INITIAL_HEIGHT) {
    let iWidth = window.innerWidth;
    let iHeight = window.innerHeight;
    const { width: width, height: height } = $30bf004d8cf60872$var$checkConDim();
    if (width && height) {
        iWidth = width;
        iHeight = height;
    }
    const dims = (0, $aBiHe.default)(INITIAL_WIDTH, INITIAL_HEIGHT, iWidth, iHeight);
    let dimsAndScale = {
        WIDTH: dims.width,
        HEIGHT: dims.height,
        LAYER_HEIGHT: dims.layerHeight,
        SCALE: dims.scale
    };
    return dimsAndScale;
}
function $30bf004d8cf60872$var$checkConDim() {
    const params = new URLSearchParams(window.location.search);
    const width = Number(params.get("width"));
    const height = Number(params.get("height"));
    return {
        width: width,
        height: height
    };
}

});
parcelRegister("aBiHe", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc7623046556d2bb$export$2e2bcd8739ae039);
function $cc7623046556d2bb$export$2e2bcd8739ae039(_width, _height, innerW, innerH) {
    let w = _width;
    let h = _height;
    if (innerH > innerW) {
        w = _height;
        h = _width * 1.2;
    }
    let scaleW = innerW / w;
    let scaleH = innerH / h;
    let scale = scaleW > scaleH ? scaleH : scaleW;
    let width = scaleW > scaleH ? innerW / scale : w;
    let height = innerH / scale //scaleW > scaleH ? innerH / scale : innerH / scale;
    ;
    let layerHeight = scaleW > scaleH ? innerH / scale : h;
    return {
        scale: scale,
        width: width,
        height: height,
        layerHeight: layerHeight
    };
}

});


parcelRegister("7uAaF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c693612b2e61811$export$2e2bcd8739ae039);
parcelRequire("iuB9z");
var $eicwU = parcelRequire("eicwU");
var $3cebA = parcelRequire("3cebA");
var $4rhnu = parcelRequire("4rhnu");
var $gc0ip = parcelRequire("gc0ip");

var $75RpY = parcelRequire("75RpY");

var $7vBln = parcelRequire("7vBln");

var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");

var $lccuU = parcelRequire("lccuU");
class $9c693612b2e61811$export$2e2bcd8739ae039 extends $eicwU.Container {
    Game = (0, $75RpY.default).getInstance();
    bg = this.addChild(new $3cebA.Graphics());
    button = this.addChild(new $3cebA.Graphics());
    buttonTitle = this.addChild(new $gc0ip.Text({
        text: "Start Game"
    }));
    handlePress;
    elementScale = .5;
    coord;
    constructor(handlePress){
        super();
        this.handlePress = handlePress;
        this.addCoord();
        this.isVertical();
        this.addBg();
        this.addLogo();
        this.addLoadingButton();
        this.addToStage();
    }
    addToStage = ()=>this.Game.stage.addChild(this);
    addCoord() {
        const dim = this.Game.getDim();
        this.coord = {
            x: dim.WIDTH / 2,
            y: dim.HEIGHT * 5 / 8
        };
    }
    isVertical() {
        const dim = this.Game.getDim();
        if (dim.WIDTH < dim.HEIGHT) this.elementScale = .8;
        return dim.WIDTH < dim.HEIGHT;
    }
    addBg() {
        const dim = this.Game.getDim();
        this.bg.rect(0, 0, dim.WIDTH, dim.HEIGHT).fill({
            color: 0xff0000,
            alpha: 0
        });
        (0, $16Wgx.default)(this.bg, {}, (0, $16HUD.CustomCursorType).default);
    }
    addLogo() {
        const logoTexture = (0, $7vBln.default).getLogo();
        const logo = this.addChild(new $4rhnu.Sprite(logoTexture));
        logo.anchor.set(.5);
        logo.scale.set(this.elementScale);
        logo.x = this.coord.x;
        logo.y = this.coord.y - 260 * this.elementScale;
    }
    addLoadingButton() {
        (0, $lccuU.default).drawButton(this.button, 100);
        this.button.position.copyFrom(this.coord);
        (0, $lccuU.default).setButtonTitle(this.buttonTitle);
        Object.assign(this.buttonTitle, this.coord);
    }
    addButtonInteractivity() {
        const handleUpFunc = ()=>{
            this.visible = false;
            this.handlePress();
        };
        (0, $16Wgx.default)(this.button, {
            handleUpFunc: handleUpFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
    }
    drawLoadingButton(percent) {
        (0, $lccuU.default).drawButton(this.button, percent);
        if (percent == 100) {
            this.buttonTitle.visible = true;
            this.addButtonInteractivity();
        }
    }
}

});
parcelRegister("lccuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $79a142aee871e1d3$export$2e2bcd8739ae039);
const $79a142aee871e1d3$var$Bar = {
    width: 200,
    height: 30,
    radius: 5
};
class $79a142aee871e1d3$export$2e2bcd8739ae039 {
    static drawButton(button, percent) {
        const barWidth = percent / 100 * $79a142aee871e1d3$var$Bar.width;
        button.clear().roundRect(-$79a142aee871e1d3$var$Bar.width / 2, -$79a142aee871e1d3$var$Bar.height / 2, $79a142aee871e1d3$var$Bar.width, $79a142aee871e1d3$var$Bar.height, $79a142aee871e1d3$var$Bar.radius).fill(0xEFEFEF).roundRect(-$79a142aee871e1d3$var$Bar.width / 2, -$79a142aee871e1d3$var$Bar.height / 2, barWidth, $79a142aee871e1d3$var$Bar.height, $79a142aee871e1d3$var$Bar.radius).fill(0x21D4FE);
    }
    static setButtonTitle(buttonTitle) {
        buttonTitle.eventMode = "none";
        buttonTitle.style.fill = 0x0195b8;
        buttonTitle.style.fontSize = 20;
        buttonTitle.anchor.set(.5);
        buttonTitle.visible = false;
    }
}

});


parcelRegister("gFv4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $65b128bd22e0940c$export$2e2bcd8739ae039);

var $erVR3 = parcelRequire("erVR3");
function $65b128bd22e0940c$export$2e2bcd8739ae039() {
    const params = new URLSearchParams(window.location.search);
    const videoMode = params.get("videomode");
    if (videoMode) (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).onVideoMode);
}

});


parcelRegister("aPdzS", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f825acb474581e3$export$2e2bcd8739ae039);
parcelRequire("iuB9z");
var $3cebA = parcelRequire("3cebA");

var $75RpY = parcelRequire("75RpY");

var $9ec1t = parcelRequire("9ec1t");
class $5f825acb474581e3$export$2e2bcd8739ae039 extends $3cebA.Graphics {
    Game = (0, $75RpY.default).getInstance();
    Layers = (0, $9ec1t.default).getInstance();
    fillColor;
    radius = 10;
    constructor(coord, fillColor = 0x000000, radius = 10, autoAdd = true){
        super();
        Object.assign(this, coord);
        this.fillColor = fillColor;
        this.radius = radius;
        this.eventMode = "none";
        autoAdd && this.addToLayer();
    }
    addToLayer = ()=>this.Layers.UI.addChild(this);
    setColor = (color)=>this.fillColor = color;
    draw(coord) {
        const dim = this.Game.getDim();
        const isVertical = dim.WIDTH < dim.HEIGHT;
        this.clear();
        Object.assign(this, coord);
        this.circle(0, 0, this.radius).fill({
            color: this.fillColor
        });
        isVertical && this.circle(0, 0, 50).fill({
            color: "blue",
            alpha: 0
        });
    }
}

});

parcelRegister("61Efw", function(module, exports) {

$parcel$export(module.exports, "default", () => $015007460ae0d382$export$2e2bcd8739ae039);
function $015007460ae0d382$export$2e2bcd8739ae039(sCoord, r, radian) {
    const x = Number((sCoord.x + Math.cos(radian) * r).toFixed(2));
    const y = Number((sCoord.y + Math.sin(radian) * r).toFixed(2));
    return {
        x: x,
        y: y
    };
}

});

parcelRegister("darcK", function(module, exports) {

$parcel$export(module.exports, "normalizeRadian", () => $47665cf1c39720c8$export$d44861331f213635);
function $47665cf1c39720c8$export$d44861331f213635(radian) {
    const twoPi = Math.PI * 2;
    const _radian = (radian % twoPi + twoPi) % twoPi;
    return Number(_radian.toFixed(3));
}

});

parcelRegister("2h5MD", function(module, exports) {

$parcel$export(module.exports, "default", () => $797d451673cb4731$export$2e2bcd8739ae039);
function $797d451673cb4731$export$2e2bcd8739ae039(cStart, cEnd) {
    return Number(Math.atan2(cEnd.y - cStart.y, cEnd.x - cStart.x).toFixed(4));
}

});

parcelRegister("d0yDD", function(module, exports) {

$parcel$export(module.exports, "default", () => $72ec39fa453fa997$export$2e2bcd8739ae039);
parcelRequire("iuB9z");
var $3cebA = parcelRequire("3cebA");

var $9ec1t = parcelRequire("9ec1t");

var $dO0zr = parcelRequire("dO0zr");

var $dWG0X = parcelRequire("dWG0X");

var $3ANoO = parcelRequire("3ANoO");

var $2GxlO = parcelRequire("2GxlO");
class $72ec39fa453fa997$export$2e2bcd8739ae039 extends $3cebA.Graphics {
    Layers = (0, $9ec1t.default).getInstance();
    LineFactory;
    Config = {
        ...(0, $3ANoO.LINE_CONFIG)
    };
    isVisibleEqualSymbol = false;
    coordStart = {
        x: 0,
        y: 0
    };
    coordEnd = {
        x: 0,
        y: 0
    };
    constructor(Config){
        super();
        Config && Object.assign(this.Config, Config);
        this.LineFactory = new (0, $dO0zr.default)(this.Config.width, this.Config.color);
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Middle.addChild(this);
    setLineColor(color) {
        this.Config.color = color;
        this.LineFactory.setLineColor(color);
    }
    setVisibleOfEqualSymbol = (v)=>{
        this.isVisibleEqualSymbol = v;
        this.draw(this.coordStart, this.coordEnd);
    };
    draw(coordStart, coordEnd) {
        this.coordStart = coordStart;
        this.coordEnd = coordEnd;
        if (this.Config.arrowCap !== (0, $dWG0X.ArrowCap).None) {
            const coords = (0, $2GxlO.getCoordsForArrowCaps)(coordStart, coordEnd);
            if (this.Config.arrowCap === (0, $dWG0X.ArrowCap).Both) {
                this.coordStart = coords.coordStart;
                this.coordEnd = coords.coordEnd;
            } else if (this.Config.arrowCap === (0, $dWG0X.ArrowCap).Start) this.coordStart = coords.coordStart;
            else if (this.Config.arrowCap === (0, $dWG0X.ArrowCap).End) this.coordEnd = coords.coordEnd;
        }
        this.LineFactory.drawLines(this, this.coordStart, this.coordEnd, this.Config.isDashed);
        this.LineFactory.drawArrowCaps(this, this.coordStart, this.coordEnd, this.Config.arrowCap);
        if (this.isVisibleEqualSymbol && this.Config.isEqualSymbol) this.LineFactory.drawEqualSymbol(this.Config.equalSymbol, this, this.coordStart, this.coordEnd);
    }
}

});
parcelRegister("dO0zr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b61abcab94754046$export$2e2bcd8739ae039);

var $dWG0X = parcelRequire("dWG0X");

var $2GxlO = parcelRequire("2GxlO");
class $b61abcab94754046$export$2e2bcd8739ae039 {
    width;
    lineColor;
    constructor(width, lineColor){
        this.width = width;
        this.lineColor = lineColor;
    }
    setLineColor = (color)=>this.lineColor = color;
    drawLines(graphic, coordStart, coordEnd, isDashed) {
        const coords = !isDashed ? [
            coordStart,
            coordEnd
        ] : (0, $2GxlO.genDashedCoords)(coordStart, coordEnd);
        if (!graphic) return;
        graphic.clear();
        coords.forEach((coord, cI)=>{
            if (cI % 2 === 1) return;
            const nextI = cI != coords.length - 1 ? cI + 1 : cI;
            graphic.moveTo(coord.x, coord.y).lineTo(coords[nextI].x, coords[nextI].y).stroke({
                color: this.lineColor,
                width: this.width,
                cap: "round"
            });
        });
    }
    drawEqualSymbol(type, graphic, coordStart, coordEnd) {
        switch(type){
            case (0, $dWG0X.LineEqualSymbol).Dash:
                this.drawDashSymbol(graphic, coordStart, coordEnd);
                break;
            case (0, $dWG0X.LineEqualSymbol).Arrow:
                this.drawArrowSymbol(graphic, coordStart, coordEnd);
                break;
            default:
                break;
        }
    }
    drawDashSymbol(graphic, coordStart, coordEnd) {
        const coords = (0, $2GxlO.getEqualSymbolCoords)(coordStart, coordEnd);
        graphic.moveTo(coords[0].x, coords[0].y).lineTo(coords[1].x, coords[1].y).stroke({
            color: this.lineColor,
            width: this.width,
            cap: "round"
        });
    }
    drawArrowSymbol(graphic, coordStart, coordEnd) {
        const coords = (0, $2GxlO.getArrowSymbolCoords)(coordStart, coordEnd);
        graphic.moveTo(coords[0].x, coords[0].y).lineTo(coords[1].x, coords[1].y).lineTo(coords[2].x, coords[2].y).stroke({
            width: this.width,
            color: this.lineColor,
            cap: "round"
        });
    }
    drawArrowCaps(graphic, coordStart, coordEnd, arrowCap) {
        if (arrowCap === (0, $dWG0X.ArrowCap).None) return;
        const coordsArr = (0, $2GxlO.getArrowCapsCoords)(coordStart, coordEnd, arrowCap);
        coordsArr.forEach((coords)=>{
            graphic.moveTo(coords[0].x, coords[0].y).lineTo(coords[1].x, coords[1].y).lineTo(coords[2].x, coords[2].y).stroke({
                width: 1,
                color: this.lineColor,
                cap: "round"
            }).fill(this.lineColor);
        });
    }
}

});
parcelRegister("2GxlO", function(module, exports) {

$parcel$export(module.exports, "getEqualSymbolCoords", () => $d0693081c59b6fca$export$e8ef89191e44275c);
$parcel$export(module.exports, "getArrowCapsCoords", () => $d0693081c59b6fca$export$4f100539048ef183);
$parcel$export(module.exports, "getArrowSymbolCoords", () => $d0693081c59b6fca$export$535e4cf2fd7d4ce1);
$parcel$export(module.exports, "genDashedCoords", () => $d0693081c59b6fca$export$db371c23848c9080);
$parcel$export(module.exports, "getCoordsForArrowCaps", () => $d0693081c59b6fca$export$cbb0571d5c5ff1ca);

var $dWG0X = parcelRequire("dWG0X");

var $2h5MD = parcelRequire("2h5MD");

var $ijoTh = parcelRequire("ijoTh");

var $eP48i = parcelRequire("eP48i");
function $d0693081c59b6fca$var$getArrowCapCoord(coordStart, coordEnd, cap, H_LENGTH = 20, V_LENGTH = 25) {
    const radian = (0, $2h5MD.default)(coordStart, coordEnd);
    const capCoord = cap === (0, $dWG0X.ArrowCap).Start ? coordStart : coordEnd;
    const horizontalR = radian + (cap === (0, $dWG0X.ArrowCap).Start ? Math.PI / 2 : -Math.PI / 2);
    const verticalR = cap === (0, $dWG0X.ArrowCap).Start ? radian - Math.PI : radian;
    const firstCoord = {
        x: capCoord.x + Math.cos(horizontalR) * H_LENGTH / 2,
        y: capCoord.y + Math.sin(horizontalR) * H_LENGTH / 2
    };
    const secondCoord = {
        x: capCoord.x + Math.cos(verticalR) * V_LENGTH,
        y: capCoord.y + Math.sin(verticalR) * V_LENGTH
    };
    const thirdCoord = {
        x: capCoord.x - Math.cos(horizontalR) * H_LENGTH / 2,
        y: capCoord.y - Math.sin(horizontalR) * H_LENGTH / 2
    };
    return [
        firstCoord,
        secondCoord,
        thirdCoord
    ];
}
function $d0693081c59b6fca$export$e8ef89191e44275c(coordStart, coordEnd) {
    const length = 18;
    const radian = (0, $2h5MD.default)(coordStart, coordEnd) + Math.PI / 2;
    const centerCoord = (0, $ijoTh.default)(coordStart, coordEnd);
    const coord1 = {
        x: Math.cos(radian) * (length / 2) + centerCoord.x,
        y: Math.sin(radian) * (length / 2) + centerCoord.y
    };
    const coord2 = {
        x: Math.cos(radian) * (-length / 2) + centerCoord.x,
        y: Math.sin(radian) * (-length / 2) + centerCoord.y
    };
    return [
        coord1,
        coord2
    ];
}
function $d0693081c59b6fca$export$4f100539048ef183(coordStart, coordEnd, cap) {
    if (cap === (0, $dWG0X.ArrowCap).None) return [];
    else if (cap === (0, $dWG0X.ArrowCap).Both) return [
        $d0693081c59b6fca$var$getArrowCapCoord(coordStart, coordEnd, (0, $dWG0X.ArrowCap).Start),
        $d0693081c59b6fca$var$getArrowCapCoord(coordStart, coordEnd, (0, $dWG0X.ArrowCap).End)
    ];
    else return [
        $d0693081c59b6fca$var$getArrowCapCoord(coordStart, coordEnd, cap)
    ];
}
function $d0693081c59b6fca$export$535e4cf2fd7d4ce1(coordStart, coordEnd) {
    const centerCoord = (0, $ijoTh.default)(coordStart, coordEnd);
    return $d0693081c59b6fca$var$getArrowCapCoord(coordStart, centerCoord, (0, $dWG0X.ArrowCap).End, 20, 20);
}
function $d0693081c59b6fca$export$db371c23848c9080(coordStart, coordEnd) {
    let dashedCoords = [];
    const lineLength = 20;
    const radian = (0, $2h5MD.default)(coordStart, coordEnd);
    const lineCount = Math.ceil((0, $eP48i.default)(coordStart, coordEnd) / lineLength);
    for(let i = 0; i < lineCount; i++){
        const startCoord = dashedCoords.length > 0 ? dashedCoords[dashedCoords.length - 1] : coordStart;
        const _x = startCoord.x + Math.cos(radian) * lineLength;
        const _y = startCoord.y + Math.sin(radian) * lineLength;
        const newCoord = i !== lineCount - 1 ? {
            x: _x,
            y: _y
        } : coordEnd;
        dashedCoords.push(newCoord);
    }
    return dashedCoords;
}
function $d0693081c59b6fca$export$cbb0571d5c5ff1ca(_coordStart, _coordEnd) {
    const radian = (0, $2h5MD.default)(_coordStart, _coordEnd);
    const coordStart = {
        x: _coordStart.x + Math.cos(radian) * 25,
        y: _coordStart.y + Math.sin(radian) * 25
    };
    const coordEnd = {
        x: _coordEnd.x - Math.cos(radian) * 25,
        y: _coordEnd.y - Math.sin(radian) * 25
    };
    return {
        coordStart: coordStart,
        coordEnd: coordEnd
    };
}

});
parcelRegister("ijoTh", function(module, exports) {

$parcel$export(module.exports, "default", () => $228b5d1a645d63ab$export$2e2bcd8739ae039);
function $228b5d1a645d63ab$export$2e2bcd8739ae039(coordStart, coordEnd) {
    return {
        x: Number(((coordStart.x + coordEnd.x) / 2).toFixed(2)),
        y: Number(((coordStart.y + coordEnd.y) / 2).toFixed(2))
    };
}

});

parcelRegister("eP48i", function(module, exports) {

$parcel$export(module.exports, "default", () => $98da00ac2f5269ae$export$2e2bcd8739ae039);
function $98da00ac2f5269ae$export$2e2bcd8739ae039(coord1, coord2) {
    return Math.sqrt(Math.pow(coord1.x - coord2.x, 2) + Math.pow(coord1.y - coord2.y, 2));
}

});




parcelRegister("iD90R", function(module, exports) {

$parcel$export(module.exports, "drawPointsAnim", () => $8aaae5f95c511a77$export$e6a3879eeac1aa9d);
$parcel$export(module.exports, "drawAngleAnim", () => $8aaae5f95c511a77$export$2707a00551b9d1cc);
$parcel$export(module.exports, "drawLineAnim", () => $8aaae5f95c511a77$export$720cbfe21b054bd1);
$parcel$export(module.exports, "drawCircleAnim", () => $8aaae5f95c511a77$export$7e0882271c304db0);
$parcel$export(module.exports, "movePointAnim", () => $8aaae5f95c511a77$export$6927aa2d8fee9fc5);
$parcel$export(module.exports, "moveAllPointAnim", () => $8aaae5f95c511a77$export$2798021cc33f6214);
$parcel$export(module.exports, "showSlidersAnim", () => $8aaae5f95c511a77$export$543c0984a55507b3);
$parcel$export(module.exports, "rotateCircleAnim", () => $8aaae5f95c511a77$export$f584aa9213fc042a);
$parcel$export(module.exports, "addCustomDelay", () => $8aaae5f95c511a77$export$47b5197e2a1e9820);

var $jRxpu = parcelRequire("jRxpu");

var $d3JxQ = parcelRequire("d3JxQ");

var $gQYAd = parcelRequire("gQYAd");

var $kBspE = parcelRequire("kBspE");

var $jSREn = parcelRequire("jSREn");

var $kSVlj = parcelRequire("kSVlj");

var $c8rVr = parcelRequire("c8rVr");

var $bm24x = parcelRequire("bm24x");
function $8aaae5f95c511a77$export$e6a3879eeac1aa9d(pointsArr) {
    return new Promise((resolve)=>{
        pointsArr.forEach((point)=>new (0, $kBspE.default)(point, resolve, resolve));
    });
}
function $8aaae5f95c511a77$export$2707a00551b9d1cc(angle, value) {
    return new Promise((resolve)=>{
        new (0, $jRxpu.default)(angle, ()=>{
            angle.AngleValue.setValue(value);
            angle.AngleValue.visible = true;
            resolve();
        }, resolve);
    });
}
function $8aaae5f95c511a77$export$720cbfe21b054bd1(line, from, to) {
    return new Promise((resolve)=>{
        line.visible = true;
        new (0, $gQYAd.default)(line, from, to, undefined, resolve, resolve);
    });
}
function $8aaae5f95c511a77$export$7e0882271c304db0(circle, radian, radianIndex, isTransparent, coord) {
    return new Promise((resolve)=>{
        new (0, $d3JxQ.default)(circle, radian, radianIndex, isTransparent, coord, resolve, resolve);
    });
}
function $8aaae5f95c511a77$export$6927aa2d8fee9fc5(sAngle, tAngle, callback, onComp = ()=>{}) {
    return new Promise((resolve)=>{
        new (0, $c8rVr.default)(sAngle, tAngle, callback, ()=>{
            onComp();
            resolve();
        }, resolve);
    });
}
function $8aaae5f95c511a77$export$2798021cc33f6214(sAngleArr, tAngleArr, callback) {
    return new Promise((resolve)=>{
        tAngleArr.forEach(async (tAngle, tAIndex)=>{
            if (tAIndex < tAngleArr.length - 1) return $8aaae5f95c511a77$export$6927aa2d8fee9fc5(sAngleArr[tAIndex], tAngle, (angle)=>callback(angle, tAIndex));
            await $8aaae5f95c511a77$export$6927aa2d8fee9fc5(sAngleArr[tAIndex], tAngle, (angle)=>callback(angle, tAIndex), ()=>resolve());
        });
    });
}
function $8aaae5f95c511a77$export$543c0984a55507b3(SliderManager) {
    return new Promise(()=>{
        const sliders = SliderManager.getSliders();
        sliders.forEach((slider)=>{
            const onUpdate = (v)=>slider.setScale(v, v);
            slider.setScale(.3, .3);
            slider.setSliderVisible(true);
            new (0, $kSVlj.default)(.3, 1, (v)=>onUpdate(v));
        });
    });
}
function $8aaae5f95c511a77$export$f584aa9213fc042a(callback) {
    return new Promise((resolve)=>new (0, $jSREn.default)(callback, 1, resolve, resolve));
}
function $8aaae5f95c511a77$export$47b5197e2a1e9820(delay) {
    return new Promise((resolve)=>new (0, $bm24x.default)(delay, resolve));
}

});
parcelRegister("jRxpu", function(module, exports) {

$parcel$export(module.exports, "default", () => $02e180efbe35cdd9$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $02e180efbe35cdd9$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    Anim = (0, $1PAc2.default).getInstance();
    isStopped = false;
    constructor(Angle, onComp, resolve){
        super();
        if (this.Anim.getIsCancelled()) {
            Angle.scale.set(1);
            Angle.setVisible(true);
            resolve();
            return;
        }
        Angle.visible = true;
        Angle.scale.set(0.3);
        const v = {
            s: Angle.scale
        };
        new (0, $6m47o.default).Tween(v).to({
            s: 1
        }, 500).easing((0, $6m47o.default).Easing.Linear.None).onUpdate((v)=>{
            const isCancelled = this.Anim.getIsCancelled();
            if (isCancelled) {
                this.isStopped = true;
                Angle.scale.set(1);
                onComp();
            }
            if (!this.isStopped) Angle.scale.set(v.s);
        }).onComplete(()=>onComp()).start();
    }
}

});

parcelRegister("d3JxQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e872bae10ec2ce7$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");

var $3ANoO = parcelRequire("3ANoO");
class $4e872bae10ec2ce7$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    Anim = (0, $1PAc2.default).getInstance();
    isStopped = false;
    Circle;
    cCoord;
    radians;
    radianIndex;
    constructor(Circle, targetRadian, radianIndex, transparent, cCoord, onComp, resolve){
        super();
        this.Circle = Circle;
        this.cCoord = cCoord;
        this.radians = [
            ...Circle.radians
        ];
        this.radianIndex = radianIndex;
        this.rootEventBus.on(this.EnumRootEventBus.cancelledCircleAnim, ()=>this.isStopped = true);
        if (this.Anim.getIsCancelled()) {
            resolve();
            return;
        }
        const r = {
            startRadian: this.radians[radianIndex]
        };
        new (0, $6m47o.default).Tween({
            ...r
        }).to({
            startRadian: targetRadian
        }, 2000).easing((0, $6m47o.default).Easing.Linear.None).onUpdate((c)=>{
            if (this.isStopped) {
                onComp();
                return;
            }
            const radians = [
                ...this.radians
            ];
            radians[radianIndex] = c.startRadian;
            this.Circle.draw({
                radians: radians,
                radius: (0, $3ANoO.INITIAL_CIRCLE_RADIUS)
            }, transparent);
        }).onComplete(()=>onComp()).start();
    }
}

});

parcelRegister("gQYAd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0130cf631be36b23$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $0130cf631be36b23$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    sCoord;
    tCoord;
    Anim;
    isStopped;
    constructor(Line, sCoord, tCoord, delay = 0, onComp, resolve){
        super(), this.sCoord = sCoord, this.tCoord = tCoord, this.Anim = (0, $1PAc2.default).getInstance(), this.isStopped = false;
        if (this.Anim.getIsCancelled()) {
            resolve();
            return;
        }
        new (0, $6m47o.default).Tween({
            ...sCoord
        }).to({
            x: tCoord.x,
            y: tCoord.y
        }, 1000).delay(delay).easing((0, $6m47o.default).Easing.Linear.None).onUpdate((coord, u)=>{
            const isCancelled = this.Anim.getIsCancelled();
            if (isCancelled) {
                this.isStopped = true;
                onComp();
            }
            if (!this.isStopped) Line.draw(sCoord, coord);
        }).onComplete(()=>onComp()).start();
    }
}

});

parcelRegister("kBspE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e753ef9a2e3e24b4$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $e753ef9a2e3e24b4$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    Anim = (0, $1PAc2.default).getInstance();
    isStopped = false;
    constructor(point, onComp, resolve){
        super();
        if (!point) return;
        if (this.Anim.getIsCancelled()) {
            point.scale.set(1);
            resolve();
            return;
        }
        point.visible = true;
        point.scale = 0.2;
        const p = {
            s: point.scale
        };
        new (0, $6m47o.default).Tween(p).to({
            s: 1
        }, 300).easing((0, $6m47o.default).Easing.Elastic.Out).onUpdate((p)=>{
            const isCancelled = this.Anim.getIsCancelled();
            if (isCancelled) {
                this.isStopped = true;
                point.scale.set(1);
                onComp();
            }
            if (!this.isStopped) point.scale.set(p.s);
        }).onComplete(()=>onComp()).start();
    }
}

});

parcelRegister("jSREn", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c03246944d2ddcf$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $6c03246944d2ddcf$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    Anim = (0, $1PAc2.default).getInstance();
    isStopped = false;
    constructor(onUpdate, rotationCount, onComp, resolve){
        super();
        this.rootEventBus.on(this.EnumRootEventBus.cancelledCircleAnim, ()=>this.isStopped = true);
        if (this.Anim.getIsCancelled()) {
            resolve();
            return;
        }
        const a = {
            radian: 0
        };
        const targetRadian = rotationCount * (Math.PI * 2);
        new (0, $6m47o.default).Tween({
            ...a
        }).to({
            radian: targetRadian
        }, 3000).delay(600).easing((0, $6m47o.default).Easing.Linear.None).onUpdate((a)=>{
            if (this.isStopped) {
                onComp();
                return;
            }
            onUpdate(a.radian);
        }).onComplete(()=>onComp()).start();
    }
}

});

parcelRegister("kSVlj", function(module, exports) {

$parcel$export(module.exports, "default", () => $912e1629173b93e5$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $912e1629173b93e5$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    constructor(startScale, targetScale, onUpdate, onComp = ()=>{}){
        super();
        const scale = {
            v: startScale
        };
        new (0, $6m47o.default).Tween(scale).to({
            v: targetScale
        }, 300).easing((0, $6m47o.default).Easing.Elastic.Out).onUpdate((s)=>onUpdate(s.v)).onComplete(()=>onComp()).start();
    }
}

});

parcelRegister("c8rVr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3f937a3f7c4d83b$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");

var $6eUaC = parcelRequire("6eUaC");
class $b3f937a3f7c4d83b$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    Anim = (0, $1PAc2.default).getInstance();
    isStopped = false;
    constructor(sRadian, radian, onUpdate, onComp, resolve){
        super();
        if (this.Anim.getIsCancelled()) {
            resolve();
            return;
        }
        const target = (0, $6eUaC.shortestAngleDifference)(sRadian, radian) + sRadian;
        const a = {
            radian: sRadian
        };
        new (0, $6m47o.default).Tween({
            ...a
        }).to({
            radian: target
        }, 1200).easing((0, $6m47o.default).Easing.Linear.None).onUpdate((a)=>{
            const isCancelled = this.Anim.getIsCancelled();
            if (isCancelled) {
                this.isStopped = true;
                onComp();
            }
            if (!this.isStopped) onUpdate(a.radian);
        }).onComplete(()=>onComp()).start();
    }
}

});
parcelRegister("6eUaC", function(module, exports) {

$parcel$export(module.exports, "shortestAngleDifference", () => $263a8d092ad3782c$export$15665e440adacfed);
function $263a8d092ad3782c$var$normalizeAngle(angle) {
    return (angle + Math.PI * 2) % (Math.PI * 2);
}
function $263a8d092ad3782c$export$15665e440adacfed(from, to) {
    const a = $263a8d092ad3782c$var$normalizeAngle(from);
    const b = $263a8d092ad3782c$var$normalizeAngle(to);
    let diff = b - a;
    if (diff > Math.PI) diff -= Math.PI * 2;
    if (diff < -Math.PI) diff += Math.PI * 2;
    return diff;
}

});


parcelRegister("bm24x", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4208b7ef14b587a$export$2e2bcd8739ae039);

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $d4208b7ef14b587a$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    Anim = (0, $1PAc2.default).getInstance();
    isStopped = false;
    constructor(delay, resolve){
        super();
        this.rootEventBus.on(this.EnumRootEventBus.cancelledCircleAnim, ()=>this.isStopped = true);
        if (this.Anim.getIsCancelled()) {
            resolve();
            return;
        }
        const time = {
            d: 0
        };
        new (0, $6m47o.default).Tween({
            ...time
        }).to({
            d: delay
        }, delay).easing((0, $6m47o.default).Easing.Linear.None).onUpdate((time)=>{
            if (this.isStopped) {
                resolve();
                return;
            }
        }).onComplete(()=>resolve()).start();
    }
}

});


var $38f7a42b32c543c7$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"7veMx\",\"index.df599b74.js\",\"dCEEN\",\"../../browserAll.8df5e516.js\",\"7kLcW\",\"../../browserAll.c0a70e02.js\",\"3n7mr\",\"../../browserAll.9323c0ea.js\",\"hXVys\",\"../../browserAll.dd9a13c8.js\",\"5zD7l\",\"../../webworkerAll.49571e05.js\",\"aNM0B\",\"../../WebGPURenderer.219b5545.js\",\"aFj9c\",\"../../WebGPURenderer.d20a0d36.js\",\"4Zt2U\",\"../../WebGPURenderer.dd6c5ed6.js\",\"7EYKF\",\"../../WebGLRenderer.788bda00.js\"]"));


//# sourceMappingURL=index.df599b74.js.map
